{
	"batchWeighings": {
		"01972fff-1076-7ee7-a86e-0c68981a320c": {
			"id": "01972fff-1076-7ee7-a86e-0c68981a320c",
			"batchId": "01972fff-1072-72db-95f0-dcb32b7e38f2",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-78bf-b91b-a1faad413af5",
				"01972fff-1078-7ad0-be3c-3269452d87ee",
				"01972fff-1078-7b7e-bf1f-5f31b7c8cd85",
				"01972fff-1078-7d7a-8d32-da2adcc6f112",
				"01972fff-1078-7126-98d9-4b7b73c88616",
				"01972fff-1078-704c-ad5a-db2b045845a5",
				"01972fff-1078-7e39-adac-db8ba23eac78",
				"01972fff-1078-71ec-bbf1-ef209a68fca8",
				"01972fff-1078-7471-99eb-398faf279512",
				"01972fff-1078-7a38-a18f-9ce2eca48fd3",
				"01972fff-1078-7387-b95a-8f5e4fa8b040",
				"01972fff-1078-7d98-8fe8-bb0a52d48aaf"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7d77-a3ce-9225bc3dfe31",
					"date": "2025-06-02T09:35:34.5190207Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7457-91b7-8ae28cd562fe": {
			"id": "01972fff-1077-7457-91b7-8ae28cd562fe",
			"batchId": "01972fff-1072-72db-95f0-dcb32b7e38f2",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-7948-b5fd-752a19fce407",
				"01972fff-1078-7881-aa8b-48669ed3b4fb",
				"01972fff-1078-72dd-9405-7567bd6c6619",
				"01972fff-1078-7934-b636-b256b675ffda",
				"01972fff-1078-7bc0-9ddb-baa81152b482",
				"01972fff-1078-7445-986b-176bbadfd8e7",
				"01972fff-1078-7677-ab06-1175669246fd",
				"01972fff-1078-7457-87e1-995480402fe1",
				"01972fff-1078-71ac-bdfe-76b411823a01",
				"01972fff-1078-7fd6-9a4a-ee1f5a9bd258",
				"01972fff-1078-7806-ad52-409e971bfe7f",
				"01972fff-1078-7062-a86f-dfb1231f0127"
			],
			"approvals": [
				{
					"id": "01972fff-1077-79e0-9a6a-20a1a7f3ac89",
					"date": "2025-06-02T09:35:34.5195025Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-76a5-b5a9-6786d1169fdc": {
			"id": "01972fff-1077-76a5-b5a9-6786d1169fdc",
			"batchId": "01972fff-1072-75dc-8ee9-586cb812668c",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-7abf-ae65-6f9a6b8fcb0d",
				"01972fff-1078-75ca-8419-22ab7580d14c",
				"01972fff-1078-7654-8d1f-b779e5640b87",
				"01972fff-1078-7d6d-83ca-7795f8972196",
				"01972fff-1078-77f9-b5ef-ad7ae8ec79e5",
				"01972fff-1078-7de0-8cd9-74ecc565c01b",
				"01972fff-1078-7dfe-b308-4c1acd436349",
				"01972fff-1078-7e21-ab3d-2d1a58c75fd9",
				"01972fff-1078-7515-b38f-0149d04acb12",
				"01972fff-1078-744f-a390-ea18e3c6ffa0",
				"01972fff-1078-7156-a47b-e8c5cfc68fd3",
				"01972fff-1078-7a3c-b6b4-233a8a2d3680"
			],
			"approvals": [
				{
					"id": "01972fff-1077-762a-9648-02cd8eb5256f",
					"date": "2025-06-02T09:35:34.5194846Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-70ba-adf8-71118e0771f3": {
			"id": "01972fff-1077-70ba-adf8-71118e0771f3",
			"batchId": "01972fff-1072-75dc-8ee9-586cb812668c",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-7006-8757-070205ece31a",
				"01972fff-1078-78e1-81d5-16d1b7265b75",
				"01972fff-1078-7d11-ae4b-2b56f97e621d",
				"01972fff-1078-788f-a103-986aea387bd8",
				"01972fff-1078-74a7-aeea-e350b8f68cf1",
				"01972fff-1078-7ecd-90b9-76996819a74b",
				"01972fff-1078-7059-b528-25daae415435",
				"01972fff-1078-70d3-abdf-e67b260ad99d",
				"01972fff-1078-73d7-87f0-760b83901bd0",
				"01972fff-1078-7b4a-bc83-85029e251d33",
				"01972fff-1078-7862-856b-3528e90f4f56",
				"01972fff-1078-7fa6-8bdf-69751d41797b"
			],
			"approvals": [
				{
					"id": "01972fff-1077-78dd-89dc-9b6ca9535527",
					"date": "2025-06-02T09:35:34.5195031Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-784e-b475-8696fb687e2f": {
			"id": "01972fff-1077-784e-b475-8696fb687e2f",
			"batchId": "01972fff-1072-7375-b509-591bb8159461",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-763d-9ddb-b06b13a1cd8b",
				"01972fff-1078-70d5-928e-3c193b49531e",
				"01972fff-1078-7052-8361-7a32a15b74fa",
				"01972fff-1078-78c6-97ea-befb4db0b13c",
				"01972fff-1078-772c-913e-171aeadde30f",
				"01972fff-1078-728c-aa1e-97fed8459c8d",
				"01972fff-1078-75bb-b8a5-5d6147a89d07",
				"01972fff-1078-741a-8043-354d657f64ba",
				"01972fff-1078-79c3-82b4-047c5b286e3a",
				"01972fff-1078-781d-bd12-582eb744b6e3",
				"01972fff-1078-7547-af36-68265cc07b0b",
				"01972fff-1078-7dc8-b04b-1c5fc865d7f7",
				"01972fff-1078-7447-98d6-385b3b101738",
				"01972fff-1078-7b68-be24-1530439df78f",
				"01972fff-1078-758c-a623-c330d636091c",
				"01972fff-1078-7b4d-b1a9-4c86e75b646c",
				"01972fff-1078-7fba-9010-85fa1c1ed894",
				"01972fff-1078-7ae6-9538-2627d7a7c3d0"
			],
			"approvals": [
				{
					"id": "01972fff-1077-78c6-a06c-01ef90abe590",
					"date": "2025-06-02T09:35:34.5194855Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7065-b662-6eafb71f91d4": {
			"id": "01972fff-1077-7065-b662-6eafb71f91d4",
			"batchId": "01972fff-1072-7375-b509-591bb8159461",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-7fb1-b709-cefa0ac2b180",
				"01972fff-1078-792c-b021-a691b6564d87",
				"01972fff-1078-7319-b756-acd7e41fc408",
				"01972fff-1078-7149-a404-5c2431c4a764",
				"01972fff-1078-7160-8f80-3c353f2a13d7",
				"01972fff-1078-7028-8c14-2c8ec0a49899",
				"01972fff-1078-73ad-aacb-90a60eeae3e2",
				"01972fff-1078-7743-8a35-ca4cb2d64c19",
				"01972fff-1078-7100-baf7-9c8f1e53ac46",
				"01972fff-1078-7e4a-873c-3f8b1a303745",
				"01972fff-1078-7340-b26e-7056b27965fd",
				"01972fff-1078-7044-be56-74cd23718012",
				"01972fff-1078-7095-a163-ff04eff6d963",
				"01972fff-1078-70a6-a353-d19a3bf387cc",
				"01972fff-1078-7659-93f6-93ea4e6e2d24",
				"01972fff-1078-7142-8fce-04c9aa62da22",
				"01972fff-1078-7b28-8f9c-00fe872c442f",
				"01972fff-1078-7903-8f0a-33c70a41d984"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7b15-9e4e-51b720e98971",
					"date": "2025-06-02T09:35:34.5195035Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7dc5-a171-848b262f8cf9": {
			"id": "01972fff-1077-7dc5-a171-848b262f8cf9",
			"batchId": "01972fff-1072-7507-b4c8-74fb15ed6544",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-7626-b302-d24c78c25d68",
				"01972fff-1078-7725-9526-7c303ab224cc",
				"01972fff-1078-7ae9-b992-084d1b467083",
				"01972fff-1078-77d9-a5b0-e62c8179b416",
				"01972fff-1078-7536-a4b5-331768f1a249",
				"01972fff-1078-7791-879f-4115336db563",
				"01972fff-1078-735c-8eef-41f80a365b17",
				"01972fff-1078-7c19-8eae-a724495d8ce4",
				"01972fff-1078-72d9-833a-7d8472f7ecf3",
				"01972fff-1078-761a-8cf8-c179ac0c14b4",
				"01972fff-1078-7b3e-993f-644f1d95e140",
				"01972fff-1078-7249-a7ba-7a6c4a77d849",
				"01972fff-1078-748b-bfdd-446d16ff39f9",
				"01972fff-1078-7e33-b62e-674e2fc37fdb",
				"01972fff-1078-7f92-94bc-97c687c97562",
				"01972fff-1078-7b3e-b6a9-a74abb2cb2d1",
				"01972fff-1078-7234-bf07-9b23ff5ce6f0",
				"01972fff-1078-72f9-a807-6f340904da45"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7556-a468-7d598ac365b9",
					"date": "2025-06-02T09:35:34.519486Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-73e9-97b0-ff34ca31a16a": {
			"id": "01972fff-1077-73e9-97b0-ff34ca31a16a",
			"batchId": "01972fff-1072-7507-b4c8-74fb15ed6544",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-7d16-8ce0-8e0977266c17",
				"01972fff-1078-7fd4-80fb-06b330dc24ef",
				"01972fff-1078-76cf-8531-4add2df3530a",
				"01972fff-1078-7f6c-af9d-0afc19f5805b",
				"01972fff-1078-76d2-aaf5-6c5432c2216d",
				"01972fff-1078-7e4f-b3be-33d0e37fdc72",
				"01972fff-1078-784c-95a9-218ea2949bf7",
				"01972fff-1078-7299-b157-3e3ebf9ccc59",
				"01972fff-1078-77b2-b783-b2002fc3703b",
				"01972fff-1078-7b64-a811-6cac0a0158cb",
				"01972fff-1078-7c2f-bda0-1daeb471bc52",
				"01972fff-1078-7494-8f0d-59e2ffb04049",
				"01972fff-1078-70a6-bcde-70f6500d5d38",
				"01972fff-1078-7eaa-869f-da551734d660",
				"01972fff-1078-7140-bfb2-69c72a82e8cb",
				"01972fff-1078-7699-9522-70c0a7c403f9",
				"01972fff-1078-7856-9a41-64fc0ffb0fa9",
				"01972fff-1078-752c-b100-cf2961bc3bc5"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7e14-bc48-04bd4d395cf5",
					"date": "2025-06-02T09:35:34.5195044Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-72db-a407-a74499a5f97d": {
			"id": "01972fff-1077-72db-a407-a74499a5f97d",
			"batchId": "01972fff-1072-723f-bf92-0fbb390a23b5",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-7849-bfce-a879e1415219",
				"01972fff-1078-75b8-8202-f2047fae6f98",
				"01972fff-1078-724e-a164-2c5a5c331c59",
				"01972fff-1078-704f-8e33-7e0a8008d265",
				"01972fff-1078-7d88-af82-58e67926a97d",
				"01972fff-1078-7cfd-a964-0093b1b3f95e",
				"01972fff-1078-77e7-a100-e98aa1d19ef6",
				"01972fff-1078-79f8-a294-80b025ba3b0e",
				"01972fff-1078-74d9-94c0-12909050ab78",
				"01972fff-1078-73c5-b343-edf015e2b424",
				"01972fff-1078-783a-8231-7cb6cf808c3f",
				"01972fff-1078-7711-8e48-2753780b1414",
				"01972fff-1078-7292-b585-bcf2f6f5e325",
				"01972fff-1078-7265-8618-814d0b581ca4",
				"01972fff-1078-7067-bb20-c78b6db25bb0",
				"01972fff-1078-7fc7-af22-8a68ea920ef3",
				"01972fff-1078-7178-a194-1a3946ec40bc",
				"01972fff-1078-71f0-8b95-56701a73e2d6"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7c8e-b264-cb81e1fa333c",
					"date": "2025-06-02T09:35:34.5194864Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7edd-9fdc-0d80938fa558": {
			"id": "01972fff-1077-7edd-9fdc-0d80938fa558",
			"batchId": "01972fff-1072-723f-bf92-0fbb390a23b5",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-747c-9397-df8ec4106a7e",
				"01972fff-1078-7fc6-8315-0d71fb60a38f",
				"01972fff-1078-797e-a286-74260d0c9bcd",
				"01972fff-1078-7896-9ccf-fb611e214913",
				"01972fff-1078-7f71-b645-5cd15a1e6835",
				"01972fff-1078-71db-8cca-215f39a199a0",
				"01972fff-1078-7dd0-bd97-aacb59161358",
				"01972fff-1078-7af9-809c-b12f627da173",
				"01972fff-1078-72c0-b5fd-c165a5062d03",
				"01972fff-1078-786d-836f-4a5af214a5a9",
				"01972fff-1078-77ff-8fce-fea62e9e7aac",
				"01972fff-1078-788f-8db9-88f4f5a8c272",
				"01972fff-1078-76d9-9f0a-e7ef8aa1347d",
				"01972fff-1078-74e8-9e0f-5db43dbd591c",
				"01972fff-1078-78cf-ad72-ced434f8b084",
				"01972fff-1078-7513-ad37-cb109420e346",
				"01972fff-1078-7af0-bf1e-54c1e6af3af6",
				"01972fff-1078-72e9-a6fc-9759a56e68b4"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7f1e-b228-dcb63556b04b",
					"date": "2025-06-02T09:35:34.5195048Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-754d-835e-69608aff28d8": {
			"id": "01972fff-1077-754d-835e-69608aff28d8",
			"batchId": "01972fff-1072-77e5-ba27-3485f4562677",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-7e36-ba5e-0a0afda70b00",
				"01972fff-1078-7a72-b298-5ee7f075f1f2",
				"01972fff-1078-70d7-820e-ec3a3bf87886",
				"01972fff-1078-7bf1-acdf-3ab6e05cbce8",
				"01972fff-1078-72fe-9c3f-e0a0cdfca862",
				"01972fff-1078-79df-ab1d-f61b2cdd0115",
				"01972fff-1078-7fc7-bfae-959176e8638b",
				"01972fff-1078-7284-8edc-eaa54f65d544",
				"01972fff-1078-7c3e-bc99-34e28e3edbc5",
				"01972fff-1078-7a80-aaba-35dbc7c1f0e5",
				"01972fff-1078-7bb3-b6c6-3f16126a8a07",
				"01972fff-1078-7b75-b414-deff1e8f8aa4",
				"01972fff-1078-7b23-a898-f067b74b8409",
				"01972fff-1078-72e2-93f7-c62d3cd709f6",
				"01972fff-1078-7556-a769-34da99c72146",
				"01972fff-1078-7117-aef2-8baa46bb2778",
				"01972fff-1078-7141-8ea4-ecf5d5b6dad0",
				"01972fff-1078-7516-9e51-435c5440ff1d"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7e5b-a4dd-9a257a2b17c0",
					"date": "2025-06-02T09:35:34.5194873Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7ffe-b44b-59de119b640e": {
			"id": "01972fff-1077-7ffe-b44b-59de119b640e",
			"batchId": "01972fff-1072-77e5-ba27-3485f4562677",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-76c0-acac-d6b050e86859",
				"01972fff-1078-7dbc-b59f-69137cecb237",
				"01972fff-1078-70c6-a95a-10acb1b49cf6",
				"01972fff-1078-7c0a-9c9b-5c71f0d0ec49",
				"01972fff-1078-7989-b42d-6018b4728bef",
				"01972fff-1078-7fb1-9567-423d59daf2e8",
				"01972fff-1078-7d11-8e86-77f896d47931",
				"01972fff-1078-7b0a-92f7-18aa551b5373",
				"01972fff-1078-784b-b12e-b502c867c02a",
				"01972fff-1078-7630-9444-8cc5dfec665b",
				"01972fff-1078-7915-9ffe-6080d4f16710",
				"01972fff-1078-79fb-866f-a6cfe39aa705",
				"01972fff-1078-7fc5-bc34-42362f880179",
				"01972fff-1078-7719-b0c9-829d63536487",
				"01972fff-1078-7494-86f9-f209a2cd5c8c",
				"01972fff-1078-7044-aebf-a78486e266a8",
				"01972fff-1078-7d8d-b0fe-bbc853325fee",
				"01972fff-1078-7b6a-8abe-4bdae1953e37"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7729-b7ad-3de09ab30af0",
					"date": "2025-06-02T09:35:34.5195054Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-77fd-bf38-144220df80a7": {
			"id": "01972fff-1077-77fd-bf38-144220df80a7",
			"batchId": "01972fff-1072-76bf-bd55-184bec22ba6d",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-7405-ba01-f3d6e242ac51",
				"01972fff-1078-784c-b4e6-1630f93c28a4",
				"01972fff-1078-7260-8e5e-6bf6bfb55e1d",
				"01972fff-1078-7270-b459-d824df887955",
				"01972fff-1078-790d-9efe-3f5afa0ee81d",
				"01972fff-1078-7eaa-b81a-53046a08f359",
				"01972fff-1078-7073-9bb9-aca5e8e5af64",
				"01972fff-1078-7cce-8d5f-535a559161f2",
				"01972fff-1078-7cf2-aedb-6e3ece7dee1b",
				"01972fff-1078-70f1-b8bc-0d872a5ff7ba",
				"01972fff-1078-7fba-a9d0-b16d8aa24fe6",
				"01972fff-1078-705f-96d2-36d67b270483"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7c90-8558-88075a1e5094",
					"date": "2025-06-02T09:35:34.5194878Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-70f1-a7fa-63dfeb0cb1c2": {
			"id": "01972fff-1077-70f1-a7fa-63dfeb0cb1c2",
			"batchId": "01972fff-1072-76bf-bd55-184bec22ba6d",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-76b9-9878-bc9d5e9f9e7d",
				"01972fff-1078-7e6d-bccd-55ab44436b61",
				"01972fff-1078-7531-ac4d-56a9837c903b",
				"01972fff-1078-7adf-b33a-70b0ba82b3de",
				"01972fff-1078-7108-84dc-e527d3d9035b",
				"01972fff-1078-71c1-a6dd-0ad076290f4e",
				"01972fff-1078-7bd0-bf5f-57e28b574046",
				"01972fff-1079-74de-a989-227b01dbd1bd",
				"01972fff-1079-783d-9692-51d9c2ae37e9",
				"01972fff-1079-7ca0-9098-406d8c84e794",
				"01972fff-1079-72fc-95e6-ea14d87a19cf",
				"01972fff-1079-757c-ab70-53a90dbb2139"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7de3-baf2-f5daf1ed8419",
					"date": "2025-06-02T09:35:34.5195059Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7f3a-bd5e-60d82c64add4": {
			"id": "01972fff-1077-7f3a-bd5e-60d82c64add4",
			"batchId": "01972fff-1072-76c0-8c8c-063cedd7777e",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-70a9-8abf-cc6d4d06c00a",
				"01972fff-1078-747e-9650-08e6e8723a89",
				"01972fff-1078-7d6b-9fec-a73ab9948800",
				"01972fff-1078-7032-9629-730ef397d91b",
				"01972fff-1078-77c0-a9a0-481a16675184",
				"01972fff-1078-781b-8fde-3e7e09e4ec16",
				"01972fff-1078-7017-b81d-b8ffacd0c2b4",
				"01972fff-1078-764b-b301-f651f634eaf5",
				"01972fff-1078-73d7-900a-a70bf6686de0",
				"01972fff-1078-7c4e-9dd5-cf4b8731cf1e",
				"01972fff-1078-7f31-9fa0-29bb4d417f7b",
				"01972fff-1078-7522-82f1-06a0e6424f4c"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7918-ab17-493cb83aaf56",
					"date": "2025-06-02T09:35:34.5194883Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7a5c-b890-595d5e609fd1": {
			"id": "01972fff-1077-7a5c-b890-595d5e609fd1",
			"batchId": "01972fff-1072-76c0-8c8c-063cedd7777e",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1079-7de7-ae73-530e160984d4",
				"01972fff-1079-74d8-9198-c595c32de220",
				"01972fff-1079-7138-9282-8bebddb25ea0",
				"01972fff-1079-7da7-aee4-fa4d27949f13",
				"01972fff-1079-75f6-812a-db878cf1fb4a",
				"01972fff-1079-7fe8-a965-f70c9df4e3ef",
				"01972fff-1079-7514-8b21-79e1d9f33804",
				"01972fff-1079-73aa-9699-c39d247fb16e",
				"01972fff-1079-764a-b6cc-22ac52cc0be1",
				"01972fff-1079-76d5-8ff8-777a0efba439",
				"01972fff-1079-7091-83be-6bdbfacb569e",
				"01972fff-1079-7edc-9f52-d813a899d754"
			],
			"approvals": [
				{
					"id": "01972fff-1077-78df-8360-0fd6c03876fd",
					"date": "2025-06-02T09:35:34.5195063Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7cb1-9c04-53847327e261": {
			"id": "01972fff-1077-7cb1-9c04-53847327e261",
			"batchId": "01972fff-1072-7207-851d-4e554e54be64",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-7765-a536-be19e5e1941b",
				"01972fff-1078-7714-be19-8195cc940823",
				"01972fff-1078-7d22-8bd5-0e2a5809faae",
				"01972fff-1078-7cb0-8caf-1f5c69009ee1",
				"01972fff-1078-7090-b723-83f8f9ca16de",
				"01972fff-1078-7f5a-9ef2-02fc2384e6ef",
				"01972fff-1078-741b-8509-6835524bbef3",
				"01972fff-1078-7230-8558-db87979b710e",
				"01972fff-1078-74bc-8dff-eba7a2d76ccd",
				"01972fff-1078-7bfe-8c02-dad2f2e553df",
				"01972fff-1078-7db3-837a-0164c8e57c22",
				"01972fff-1078-73df-a974-acdb7c226786"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7e93-9fae-432ccf8ca043",
					"date": "2025-06-02T09:35:34.5194888Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-786b-81bf-e4a88c430481": {
			"id": "01972fff-1077-786b-81bf-e4a88c430481",
			"batchId": "01972fff-1072-7207-851d-4e554e54be64",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1079-7fe3-a0ca-3b949db4a6f1",
				"01972fff-1079-7805-b753-07ada462db6b",
				"01972fff-1079-710c-badb-b32c95cb5dbd",
				"01972fff-1079-75ee-846c-b235e28efd57",
				"01972fff-1079-73fb-9477-b5fce6ca4ac0",
				"01972fff-1079-73e8-b088-294180ab429a",
				"01972fff-1079-7699-85be-a4bf69956160",
				"01972fff-1079-7c72-82ab-af43331e3870",
				"01972fff-1079-739f-a47d-2fdc9b4ca5ee",
				"01972fff-1079-7be4-a6a9-96f52137084a",
				"01972fff-1079-7da4-84d3-1341415a6302",
				"01972fff-1079-7434-808e-5e55e8eff823"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7b7d-ae06-00ead1a1033c",
					"date": "2025-06-02T09:35:34.5195066Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7a41-a08c-6f7f75254a8b": {
			"id": "01972fff-1077-7a41-a08c-6f7f75254a8b",
			"batchId": "01972fff-1072-760f-a512-523c99b96e40",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-756d-b3a2-3e9d0fd43ce0",
				"01972fff-1078-7144-a7f6-98a1fded4a3c",
				"01972fff-1078-798c-b9d3-8607a942b59a",
				"01972fff-1078-7710-9794-a0663d53a782",
				"01972fff-1078-714a-9206-4731443c936f",
				"01972fff-1078-7a00-a6e3-6cc4be3b035d",
				"01972fff-1078-7816-8188-2aa6f73046d9",
				"01972fff-1078-7725-bdde-f001fff7a23a",
				"01972fff-1078-7889-991b-446347ef981a",
				"01972fff-1078-78b0-acd3-9ce4dbcec289",
				"01972fff-1078-7e90-82d4-4c0081f3bb7e",
				"01972fff-1078-7b3c-84b8-c39002673f40"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7ef2-868d-24fe9597ba00",
					"date": "2025-06-02T09:35:34.5194894Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7b41-9642-433ed237a932": {
			"id": "01972fff-1077-7b41-9642-433ed237a932",
			"batchId": "01972fff-1072-760f-a512-523c99b96e40",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1079-7b9b-bce6-b2e0b9ecd2e1",
				"01972fff-1079-70d6-bf36-3b7b36e4730e",
				"01972fff-1079-7a78-8427-d63271de38eb",
				"01972fff-1079-716e-be7c-9ddf67db4dac",
				"01972fff-1079-78cc-b90c-a2814916e093",
				"01972fff-1079-7f72-99c3-0a880dc5d0fd",
				"01972fff-1079-724f-b81a-30c3b2edc91d",
				"01972fff-1079-74e3-8d09-1fcbd4201d91",
				"01972fff-1079-7adc-ad90-00680eda2d3e",
				"01972fff-1079-7d4b-baf2-09296a513565",
				"01972fff-1079-7dc0-84c5-eb66b42321a1",
				"01972fff-1079-7f7c-95fb-d2f1672a734c"
			],
			"approvals": [
				{
					"id": "01972fff-1077-740b-a88b-6eb631b55a18",
					"date": "2025-06-02T09:35:34.5195072Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7c50-bc49-418356585805": {
			"id": "01972fff-1077-7c50-bc49-418356585805",
			"batchId": "01972fff-1072-73b4-b5d3-c6ba8f076a2a",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-70ba-baed-832d93086f5a",
				"01972fff-1078-7e3b-86b9-cda40c51bf14",
				"01972fff-1078-7198-8c74-59255f65eabe",
				"01972fff-1078-7f53-b2b6-d12ede82b469",
				"01972fff-1078-7926-805e-4e59fca05dec",
				"01972fff-1078-7128-acd5-219556ccaf9e",
				"01972fff-1078-7168-83be-346e84ad5458",
				"01972fff-1078-7bec-ac29-04a4a1a4d74f",
				"01972fff-1078-7460-88af-bce0ce948dd4",
				"01972fff-1078-77f7-b6b4-c39e01410271",
				"01972fff-1078-784c-8049-70e70d8415de",
				"01972fff-1078-7c83-9b6b-4b6edcef177e",
				"01972fff-1078-78c8-8901-0fd1cdd4f0ea",
				"01972fff-1078-7f53-98a1-c401d840e525",
				"01972fff-1078-7cba-b039-01e617a3c418",
				"01972fff-1078-7bd2-94e6-a8a441c8beb3",
				"01972fff-1078-7004-9a90-b31e354c78ca",
				"01972fff-1078-73d9-abc2-41c0387501f2"
			],
			"approvals": [
				{
					"id": "01972fff-1077-74b3-9c98-2e39e4be7ee3",
					"date": "2025-06-02T09:35:34.5194899Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7311-83da-0b2ae8b325b8": {
			"id": "01972fff-1077-7311-83da-0b2ae8b325b8",
			"batchId": "01972fff-1072-73b4-b5d3-c6ba8f076a2a",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1079-7442-8f8c-d2bff40fd61d",
				"01972fff-1079-7aad-afbe-27c876d70e38",
				"01972fff-1079-7a4b-9f38-243392a4740c",
				"01972fff-1079-75da-b21e-d7cdec0352e4",
				"01972fff-1079-798a-8da5-6e2b486f4906",
				"01972fff-1079-7da6-a769-8fd9b577f0bd",
				"01972fff-1079-775b-9a52-ee2c932a689f",
				"01972fff-1079-7c2e-bb58-b11a67f850df",
				"01972fff-1079-73a4-96d2-6d5d1411b804",
				"01972fff-1079-7016-b7ed-0fb70bc9c201",
				"01972fff-1079-799a-a6bc-9b6ab742e4be",
				"01972fff-1079-7b36-ab61-681dcca5ebfa",
				"01972fff-1079-7b8b-b8ae-ac40426bfcb7",
				"01972fff-1079-78ff-8b88-f67ebbe38510",
				"01972fff-1079-78cc-a2fb-9b9d940d98aa",
				"01972fff-1079-76aa-a82b-18fb0b75cddf",
				"01972fff-1079-7c80-86f4-1ba5734fb147",
				"01972fff-1079-731d-8866-e761e53cf7b9"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7238-9f98-cb48151c5058",
					"date": "2025-06-02T09:35:34.5195076Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7a69-87b2-d469f7d4a8d8": {
			"id": "01972fff-1077-7a69-87b2-d469f7d4a8d8",
			"batchId": "01972fff-1072-7361-979a-2e3b556a08ef",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-7a88-8e72-8dfcdd890af8",
				"01972fff-1078-7caf-aee3-19ff94c97426",
				"01972fff-1078-7647-bc6c-aaa9a97af693",
				"01972fff-1078-76f4-b303-df7b9d09c485",
				"01972fff-1078-7268-8d6c-c87ae94c8d75",
				"01972fff-1078-7b83-81b8-caf562652bcd",
				"01972fff-1078-7276-8f69-e48108a40476",
				"01972fff-1078-7f22-8a14-57ed02d33a19",
				"01972fff-1078-7684-b0fd-d7011a2439a4",
				"01972fff-1078-7515-9ba1-4626f519f2bf",
				"01972fff-1078-789f-9fac-9fc4317fab51",
				"01972fff-1078-73ac-ae20-888af57af761",
				"01972fff-1078-75cf-8c14-ea227de68ed2",
				"01972fff-1078-78f6-9d40-e16c04275db4",
				"01972fff-1078-7bc9-b8c1-3df748ac39c8",
				"01972fff-1078-7ec8-81bd-f51d0983b7f4",
				"01972fff-1078-74cb-a2bd-e743d602fe50",
				"01972fff-1078-7808-8b9e-d9af92e5f936"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7bd3-9d09-6df7144cda9e",
					"date": "2025-06-02T09:35:34.5194903Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7d72-9459-ad623dca82fe": {
			"id": "01972fff-1077-7d72-9459-ad623dca82fe",
			"batchId": "01972fff-1072-7361-979a-2e3b556a08ef",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1079-72f9-bd1d-078e8b18d9ab",
				"01972fff-1079-7631-b35a-73eac51a906a",
				"01972fff-1079-779d-b174-89e809427cb6",
				"01972fff-1079-7c88-8bbe-ab8c6f733706",
				"01972fff-1079-7cf6-97ed-731f55db57e5",
				"01972fff-1079-7d36-b8b0-4965ce79df6b",
				"01972fff-1079-7bbb-91c4-3fe4abd9dc72",
				"01972fff-1079-7964-87b1-2a9c3c612068",
				"01972fff-1079-756e-98b7-52e8ef1f41cc",
				"01972fff-1079-7a08-9f2d-56665df249b9",
				"01972fff-1079-74b9-9333-e0a649800e62",
				"01972fff-1079-7033-be19-f078cd0169b3",
				"01972fff-1079-76d8-bded-1ab54b9ba6dd",
				"01972fff-1079-7468-9edd-8b74e2233da9",
				"01972fff-1079-79a8-a083-df469e6d93bc",
				"01972fff-1079-7604-b18a-1916c4ab57b9",
				"01972fff-1079-75ae-a9c3-b271d22a43a2",
				"01972fff-1079-7779-a83a-98e14489b174"
			],
			"approvals": [
				{
					"id": "01972fff-1077-74c6-a392-fa637db17c9b",
					"date": "2025-06-02T09:35:34.519508Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7856-a582-5e3748fda46c": {
			"id": "01972fff-1077-7856-a582-5e3748fda46c",
			"batchId": "01972fff-1072-7733-b572-54a0e07c9d58",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-75dc-8a10-9220fd50e8fb",
				"01972fff-1078-7406-8ce3-14c18d087044",
				"01972fff-1078-7815-9e28-05a1ba5941e8",
				"01972fff-1078-7fe2-9cee-07c2921eaa0a",
				"01972fff-1078-79d6-9ced-6fc45a945ba0",
				"01972fff-1078-794f-a22f-f2f75c953b97",
				"01972fff-1078-7cf8-b081-36c2a466c9fa",
				"01972fff-1078-795c-b977-7fcc5cf8d70a",
				"01972fff-1078-72ee-89a2-70a5d150d6c0",
				"01972fff-1078-7c7e-a65a-0423d7fcbbda",
				"01972fff-1078-7258-9b54-4a7094cde868",
				"01972fff-1078-7d0f-90ff-02dfd97d2741",
				"01972fff-1078-7ed9-b264-2012f30713fc",
				"01972fff-1078-7586-907e-ce14e5a13278",
				"01972fff-1078-7cf3-bb0e-9e9cb387db23",
				"01972fff-1078-7bd9-aa5f-3dbfe738c00f",
				"01972fff-1078-7bb7-910e-b18e6a864767",
				"01972fff-1078-7aa4-ab8b-9c04995e283b"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7d85-8703-6246849d7e71",
					"date": "2025-06-02T09:35:34.5194908Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7ce0-acb9-52c67f879ee0": {
			"id": "01972fff-1077-7ce0-acb9-52c67f879ee0",
			"batchId": "01972fff-1072-7733-b572-54a0e07c9d58",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1079-70cc-8234-c240989347e2",
				"01972fff-1079-77da-b77a-03b1787d12e7",
				"01972fff-1079-7389-a4a3-1fae6896fec7",
				"01972fff-1079-76ea-b47b-cd89f8de02ec",
				"01972fff-1079-77ce-9eeb-fc8a2d35139c",
				"01972fff-1079-7ea1-8f83-4b848e7c4aa9",
				"01972fff-1079-794f-843e-77a6c1f9818f",
				"01972fff-1079-7821-9a51-c60ea8762bec",
				"01972fff-1079-7592-bcb3-21690f474af5",
				"01972fff-1079-7a26-af31-7904fcaef9e0",
				"01972fff-1079-7d05-9eb8-3f26cd5e3417",
				"01972fff-1079-7591-a0cf-390dcdc2b1ab",
				"01972fff-1079-7fd8-a6a2-5dfd10b10cd4",
				"01972fff-1079-746f-a06d-38a2c1d48ccb",
				"01972fff-1079-7c5b-9bc1-52ef33b93ef6",
				"01972fff-1079-7cc1-a74f-169baf080eb7",
				"01972fff-1079-7ab7-894a-8e40889c92bc",
				"01972fff-1079-78ea-a6f2-8f9c532d5271"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7528-b423-e072d2aebb49",
					"date": "2025-06-02T09:35:34.5195084Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7896-b114-f902703f1f64": {
			"id": "01972fff-1077-7896-b114-f902703f1f64",
			"batchId": "01972fff-1072-7924-a458-e725174b75f4",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-75ea-b8c0-c76646fc1d8a",
				"01972fff-1078-7a0c-8d83-fac5c0edd8af",
				"01972fff-1078-7462-875f-ceb51144c010",
				"01972fff-1078-7704-9403-a1da5dfaa780",
				"01972fff-1078-7ede-8298-e1f0483c9143",
				"01972fff-1078-7ff6-9035-bb8f380dde60",
				"01972fff-1078-707f-9b57-0c303ef8b616",
				"01972fff-1078-74ff-9ba3-f75cee0ee6c2",
				"01972fff-1078-7ca0-94c2-6414edc11709",
				"01972fff-1078-7b1d-941e-d85f5790f406",
				"01972fff-1078-793d-84ac-94fd3a4aa449",
				"01972fff-1078-74a4-9caa-f002360dc82c",
				"01972fff-1078-7e3f-a908-87648dfc9f1b",
				"01972fff-1078-7a71-8998-b9d5ce633f5a",
				"01972fff-1078-7215-835f-d52bbe40fdef",
				"01972fff-1078-78e4-8682-650eeaba45e1",
				"01972fff-1078-723a-8d94-bde2d669e98a",
				"01972fff-1078-7266-9941-312af96fd67b"
			],
			"approvals": [
				{
					"id": "01972fff-1077-709b-9f93-cd27aebcc18a",
					"date": "2025-06-02T09:35:34.5194914Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-77ce-8d3b-63764dbc6677": {
			"id": "01972fff-1077-77ce-8d3b-63764dbc6677",
			"batchId": "01972fff-1072-7924-a458-e725174b75f4",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1079-7b0c-9d7b-4c1ebf40a2fb",
				"01972fff-1079-73e0-a9fd-9ec4415c61a7",
				"01972fff-1079-7591-aa77-bfd4ec118c6a",
				"01972fff-1079-7e40-ab20-67e2aeb9fbb9",
				"01972fff-1079-7692-820f-30e033e43353",
				"01972fff-1079-7049-a377-f8d1a22c5e96",
				"01972fff-1079-7092-908f-2cbc3fb122a3",
				"01972fff-1079-7b0d-9121-12aaa26e8753",
				"01972fff-1079-7374-ad41-ef1a2c363c31",
				"01972fff-1079-735c-9d30-f8814c32b070",
				"01972fff-1079-74f1-b4d1-db24f9c96531",
				"01972fff-1079-72f6-9076-fb51fe9443d4",
				"01972fff-1079-7020-91ae-3ca66c92e8b9",
				"01972fff-1079-7e2a-aeaf-03aec00ad9ec",
				"01972fff-1079-7fa0-82b9-cd7000bf871c",
				"01972fff-1079-7033-bef0-1f6784e669a0",
				"01972fff-1079-75f5-af52-17d9fcd7fe39",
				"01972fff-1079-7e30-82b2-f193c9d89020"
			],
			"approvals": [
				{
					"id": "01972fff-1077-73ad-9388-eb36bfd8fa22",
					"date": "2025-06-02T09:35:34.5195089Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7243-ac8b-4ec964988431": {
			"id": "01972fff-1077-7243-ac8b-4ec964988431",
			"batchId": "01972fff-1072-7e07-aa8f-50685fd96480",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-7747-8572-a83ba0648405",
				"01972fff-1078-7a5e-b425-b4c5c3204e1f",
				"01972fff-1078-7db2-83b6-dc6691d0c9b7",
				"01972fff-1078-78b1-9588-cfcd768ecd9f",
				"01972fff-1078-78ed-ac17-6ae7f089c272",
				"01972fff-1078-74d8-ad3d-7676f058bd6d",
				"01972fff-1078-7da9-a06f-f65efde4d98e",
				"01972fff-1078-7337-b678-8acaa495156a",
				"01972fff-1078-72ee-8e66-ab2fdecc8e43",
				"01972fff-1078-7e6c-8b5d-8b91d78172dc",
				"01972fff-1078-705c-9d35-6edd56d88df8",
				"01972fff-1078-739f-87c6-18f8325c9c8d"
			],
			"approvals": [
				{
					"id": "01972fff-1077-70cd-805d-58b7032359df",
					"date": "2025-06-02T09:35:34.5194919Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7aac-91c2-09946306b59e": {
			"id": "01972fff-1077-7aac-91c2-09946306b59e",
			"batchId": "01972fff-1072-7e07-aa8f-50685fd96480",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1079-7191-a789-1b1d7ba6e6a8",
				"01972fff-1079-73d1-9d37-ca3b9d0d2d50",
				"01972fff-1079-7a5e-bf23-b4bd278a7409",
				"01972fff-1079-79ed-8fa9-f4f04e0cb78b",
				"01972fff-1079-77dc-874f-154ce32ba2eb",
				"01972fff-1079-7876-862f-4c847b8f0ed9",
				"01972fff-1079-7793-8cd5-a97669dba486",
				"01972fff-1079-7fd1-8301-d38aaa61fabb",
				"01972fff-1079-7f49-8c2d-43f817cd87ce",
				"01972fff-1079-7827-8795-66c8a058d49c",
				"01972fff-1079-72b5-9c42-73e78da44592",
				"01972fff-1079-726f-a8bd-578d428b8ab8"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7488-9c7e-5e91257bfb29",
					"date": "2025-06-02T09:35:34.5195093Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7d86-b83f-f9696e491126": {
			"id": "01972fff-1077-7d86-b83f-f9696e491126",
			"batchId": "01972fff-1072-7ae0-a462-09127c3be72a",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-764e-89d3-057d29d98606",
				"01972fff-1078-743e-9ffb-2b22f025e3ad",
				"01972fff-1078-7ea9-840f-222f5afeec28",
				"01972fff-1078-739e-b690-9726ce9e77a5",
				"01972fff-1078-7947-ba8b-53afd3572587",
				"01972fff-1078-71a1-8ea4-67321e592dcc",
				"01972fff-1078-75b3-a645-81d7383a4f95",
				"01972fff-1078-7e40-8182-74f88eddb3fb",
				"01972fff-1078-789a-843e-aa03027b376d",
				"01972fff-1078-7240-8a6f-0b568b956f07",
				"01972fff-1078-74f5-87be-f76c4e3e4ca1",
				"01972fff-1078-743b-a617-7c6cdcb7feb4"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7616-9fda-a03e54665ba7",
					"date": "2025-06-02T09:35:34.5194924Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-727e-80a9-67dc4565d96f": {
			"id": "01972fff-1077-727e-80a9-67dc4565d96f",
			"batchId": "01972fff-1072-7ae0-a462-09127c3be72a",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1079-752f-8b37-7d3d96bf3367",
				"01972fff-1079-7311-87bd-a41bc69cf5b3",
				"01972fff-1079-7e24-8060-146c9adddc35",
				"01972fff-1079-7f6a-a5e6-6accc8c95d99",
				"01972fff-1079-759b-91b3-76c31967f15d",
				"01972fff-1079-73ca-a5d7-cdbea5bc55ba",
				"01972fff-1079-7998-b7bd-f72dbcc38a56",
				"01972fff-1079-79bb-9788-451390a8a25e",
				"01972fff-1079-7a8d-a3d1-628b41a82755",
				"01972fff-1079-7e6d-a37e-7d229906ecfc",
				"01972fff-1079-7351-b83f-89fa97ec11ae",
				"01972fff-1079-7887-b582-070730d5f16c"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7be3-82ab-553ca168bbbb",
					"date": "2025-06-02T09:35:34.5195097Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-77c4-8a9a-69f6d20da473": {
			"id": "01972fff-1077-77c4-8a9a-69f6d20da473",
			"batchId": "01972fff-1072-7dd8-bed6-7b5f680740c0",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-7338-ac86-00d7bd1dc4de",
				"01972fff-1078-7ec1-810e-9a5ab8ec6674",
				"01972fff-1078-78db-888c-ddda037fe5cb",
				"01972fff-1078-78c0-b535-b7681cada048",
				"01972fff-1078-7032-9fda-dfee17286619",
				"01972fff-1078-74dc-a87b-198d9fc24f79",
				"01972fff-1078-7702-937c-d58a5eef7dc4",
				"01972fff-1078-7c7c-a1c9-4285d367ce57",
				"01972fff-1078-74c7-8e81-9871938cdb17",
				"01972fff-1078-7865-8548-3c63f845bdaf",
				"01972fff-1078-7afe-94ae-70a545bb1822",
				"01972fff-1078-7d6b-981e-8d06c72b2066"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7ba1-813e-31b01be9ef8b",
					"date": "2025-06-02T09:35:34.5194928Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-75d6-939a-1def7970604d": {
			"id": "01972fff-1077-75d6-939a-1def7970604d",
			"batchId": "01972fff-1072-7dd8-bed6-7b5f680740c0",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1079-700a-9357-1332da030723",
				"01972fff-1079-76bf-9d7e-d2685bc36e0f",
				"01972fff-1079-7ad5-aad8-597d1f5e8865",
				"01972fff-1079-710a-9f62-90d883b1a1ab",
				"01972fff-1079-7415-ab87-d3b7f6277b52",
				"01972fff-1079-73a0-a31c-349223ded67e",
				"01972fff-1079-740f-8199-4faa1e8d2da1",
				"01972fff-1079-77d6-ac43-69dc738de478",
				"01972fff-1079-7c2a-a383-08c83611a3d3",
				"01972fff-1079-7bae-beb6-c5b344962e5d",
				"01972fff-1079-7caf-984c-06c68c929beb",
				"01972fff-1079-7e42-a247-98209326dece"
			],
			"approvals": [
				{
					"id": "01972fff-1077-704d-9ec2-3301a4610538",
					"date": "2025-06-02T09:35:34.5195101Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-768f-a955-afa738b49925": {
			"id": "01972fff-1077-768f-a955-afa738b49925",
			"batchId": "01972fff-1072-74dc-8bd5-688cfc58936a",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-7924-aa81-3f49a8e9bf34",
				"01972fff-1078-74fd-88ec-332e7e753c87",
				"01972fff-1078-7530-adcb-8c69c48ec1dc",
				"01972fff-1078-7517-8d69-b773097b3326",
				"01972fff-1078-75da-baca-72b9994ee0bc",
				"01972fff-1078-785d-8e05-db808ff8158b",
				"01972fff-1078-76fa-8246-239c8514b378",
				"01972fff-1078-744d-bb43-c35dd90d286d",
				"01972fff-1078-7297-a911-f5952af89560",
				"01972fff-1078-7f26-925f-98b3abd84a9e",
				"01972fff-1078-7df3-a61b-6581b2871179",
				"01972fff-1078-7009-a6e2-ea5048f6815d"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7571-9df2-209087e058e4",
					"date": "2025-06-02T09:35:34.5194938Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7a01-a92c-cbd729031f79": {
			"id": "01972fff-1077-7a01-a92c-cbd729031f79",
			"batchId": "01972fff-1072-74dc-8bd5-688cfc58936a",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1079-7e2e-897e-49799b9cb741",
				"01972fff-1079-76fb-b30b-58ee1292dbb9",
				"01972fff-1079-7d80-b0d2-2ef91c80ec57",
				"01972fff-1079-7d64-b460-639ff563c0df",
				"01972fff-1079-7202-939a-1896ec3c46e2",
				"01972fff-1079-7a29-9602-c3671b0f7a90",
				"01972fff-1079-7154-90af-b762b583687e",
				"01972fff-1079-71d9-ba9d-b977f5cfa70a",
				"01972fff-1079-72d2-96e7-4a6ec6458113",
				"01972fff-1079-7a0f-ac51-1b8303d2bc53",
				"01972fff-1079-7466-a16f-1742c2168102",
				"01972fff-1079-7da0-add5-c60c96f90b3a"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7a2f-b29e-6542b467be82",
					"date": "2025-06-02T09:35:34.5195107Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7729-8cc1-f1446313d9cb": {
			"id": "01972fff-1077-7729-8cc1-f1446313d9cb",
			"batchId": "01972fff-1072-76c5-827f-6772315e88e5",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-7bef-91c9-ac269b45b220",
				"01972fff-1078-7e82-8dc7-16df05f8b690",
				"01972fff-1078-7a25-b5c4-3aa3381ae78d",
				"01972fff-1078-7bc9-befd-26daba2af040",
				"01972fff-1078-73cf-a563-4671a4314afa",
				"01972fff-1078-7c9d-82cf-f98450ed183c",
				"01972fff-1078-7485-8bbc-4c6d5e786edc",
				"01972fff-1078-79d7-ae40-dc2cda2081e3",
				"01972fff-1078-7f7d-98f1-7cc0475fcaec",
				"01972fff-1078-79d8-8fba-f5b5cdbb9033",
				"01972fff-1078-7d0d-9996-89f58d0391e6",
				"01972fff-1078-7c7c-a764-410f90837df4",
				"01972fff-1078-740a-bd79-8158547fc691",
				"01972fff-1078-7891-ad14-d953b3728ab2",
				"01972fff-1078-7aa2-a17c-48f50bfb55e0",
				"01972fff-1078-741c-a54c-24c40907dee8",
				"01972fff-1078-7bca-b420-29a24d5a5321",
				"01972fff-1078-73d6-a402-027a3e5e5928"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7123-a40e-f01e6c8bbb70",
					"date": "2025-06-02T09:35:34.5194948Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-75b7-9b00-84389ba8aa3c": {
			"id": "01972fff-1077-75b7-9b00-84389ba8aa3c",
			"batchId": "01972fff-1072-76c5-827f-6772315e88e5",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1079-733f-93b4-94e4fa6e7860",
				"01972fff-1079-7e03-8038-9495ab94415c",
				"01972fff-1079-76c4-8d49-8aee8ce0475f",
				"01972fff-1079-7c9e-ac0d-b177a950c313",
				"01972fff-1079-7f29-848c-ff18bf1d9334",
				"01972fff-1079-78e7-b437-ada1c534aad8",
				"01972fff-1079-768d-9b70-8e9fd1ca9591",
				"01972fff-1079-7856-811b-dd6d7d69b8f3",
				"01972fff-1079-75ff-aa8e-3ce382674495",
				"01972fff-1079-7629-8f63-24658792e4df",
				"01972fff-1079-7674-af37-e91d2f4689af",
				"01972fff-1079-719d-a120-28cb7f309135",
				"01972fff-1079-7978-9999-053aab7ce61b",
				"01972fff-1079-7b18-b9f7-a6e3be1defbe",
				"01972fff-1079-7c90-8184-e4e1cfe52416",
				"01972fff-1079-75ed-b178-251226677a58",
				"01972fff-1079-79ef-bedc-119d8ed35e25",
				"01972fff-1079-773c-89ab-a7fdab8c9322"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7a98-9013-47add6f3aa8b",
					"date": "2025-06-02T09:35:34.5195111Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7626-8fb6-3025ecdae2e0": {
			"id": "01972fff-1077-7626-8fb6-3025ecdae2e0",
			"batchId": "01972fff-1072-7b3d-90e5-60763289a55f",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-7c92-bb0f-626c1d47805f",
				"01972fff-1078-7355-82be-57b39c528dc1",
				"01972fff-1078-726f-9ab4-696b69e093a3",
				"01972fff-1078-7c00-ae08-5a02e4b02c08",
				"01972fff-1078-7a7c-ba3a-3ffa7ea09357",
				"01972fff-1078-7ff5-9b67-68a53a588b34",
				"01972fff-1078-7b1a-a64f-22491eabc139",
				"01972fff-1078-7d22-be03-603de570b3a4",
				"01972fff-1078-7431-a15c-cc348335ac79",
				"01972fff-1078-74bf-92f1-2d3b6907118e",
				"01972fff-1078-7e1e-a54c-a618bd214aa6",
				"01972fff-1078-7a07-830d-b88b36a7fcbf",
				"01972fff-1078-7333-b9a1-c216395ad18a",
				"01972fff-1078-775c-817a-2076fcfc3edc",
				"01972fff-1078-72a6-9a44-19d0d31aeabb",
				"01972fff-1078-7cdc-86ba-81c3b7610d03",
				"01972fff-1078-7678-9f86-dc316396e156",
				"01972fff-1078-7a64-97fa-137be9347063"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7eaa-a804-d48394bc3634",
					"date": "2025-06-02T09:35:34.5194952Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7baf-b620-3863e7fb3583": {
			"id": "01972fff-1077-7baf-b620-3863e7fb3583",
			"batchId": "01972fff-1072-7b3d-90e5-60763289a55f",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1079-709b-9fe4-3180da814c94",
				"01972fff-1079-7dcf-806c-59df6abdb022",
				"01972fff-1079-7ef2-8ddb-ce7980e3e705",
				"01972fff-1079-7937-bf1c-210f61ecfa2f",
				"01972fff-1079-74bf-b5e5-6b119f160316",
				"01972fff-1079-7024-aaa9-864c720e5877",
				"01972fff-1079-7ef4-8502-67fd1bc9a859",
				"01972fff-1079-7c3f-a8ea-dee19b1d0b72",
				"01972fff-1079-7e91-a29c-d1a89c7e1160",
				"01972fff-1079-7131-87d5-370fc366e62b",
				"01972fff-1079-75bd-83b4-f7081d755db3",
				"01972fff-1079-7f49-8fb5-36b873f686bd",
				"01972fff-1079-74fe-974d-8343ab35464f",
				"01972fff-1079-7b19-9949-3d21c031927c",
				"01972fff-1079-7d1b-bf58-ea57a012101d",
				"01972fff-1079-7ea8-a08d-ca1970595d03",
				"01972fff-1079-7018-8892-ca4691ee309e",
				"01972fff-1079-709f-aea8-a56e3b64c358"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7cd2-96b8-1addfb47205a",
					"date": "2025-06-02T09:35:34.5195115Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-709d-9017-9fa9b924fb13": {
			"id": "01972fff-1077-709d-9017-9fa9b924fb13",
			"batchId": "01972fff-1072-7f41-9ca0-bca12b75021f",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-7f10-a908-df053ec67172",
				"01972fff-1078-78d1-aeac-f6499a0eb311",
				"01972fff-1078-7a0c-8894-fe184137cb84",
				"01972fff-1078-7ec8-a24f-bf218b25c768",
				"01972fff-1078-7ff8-b6dd-a95ae9c27489",
				"01972fff-1078-700e-90cd-2dc1442d46e5",
				"01972fff-1078-7068-9afb-b882d250d383",
				"01972fff-1078-77f1-a314-5d6927acd181",
				"01972fff-1078-7a98-b683-064b6062b2b5",
				"01972fff-1078-7167-951f-26ee43265ab5",
				"01972fff-1078-7ab9-ba6a-7aaa2be7dccf",
				"01972fff-1078-7fd4-ab1f-319adde4495d",
				"01972fff-1078-7435-a3fe-1e125a4ad0ce",
				"01972fff-1078-7694-8b61-194d0e96b021",
				"01972fff-1078-79ac-b064-dbe8df25dcb1",
				"01972fff-1078-7042-81d0-5e2de2847a26",
				"01972fff-1078-7602-91b0-04b54fb499fa",
				"01972fff-1078-7ef1-bb74-d594ef5757e2"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7df7-b35c-cdf7efc662bd",
					"date": "2025-06-02T09:35:34.5194957Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-726f-bb62-c5d2e419050d": {
			"id": "01972fff-1077-726f-bb62-c5d2e419050d",
			"batchId": "01972fff-1072-7f41-9ca0-bca12b75021f",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1079-7b65-9aec-caf312bfdd16",
				"01972fff-1079-7106-a61b-aec7699903fd",
				"01972fff-1079-781d-86fc-9535f7eb16a8",
				"01972fff-1079-7136-afc8-50c81e053bfe",
				"01972fff-1079-7dd3-adef-213b77ddb0f6",
				"01972fff-1079-767f-a89a-eab934602c78",
				"01972fff-1079-7d77-8fc0-b404cd690f35",
				"01972fff-1079-7d31-a51a-799c1db838db",
				"01972fff-1079-7902-8f9c-94b28a39a74f",
				"01972fff-1079-7cac-b344-e94617db6449",
				"01972fff-1079-7511-b1b9-e824744a5c36",
				"01972fff-1079-77e9-9546-d64bb3052180",
				"01972fff-1079-726a-98a4-6d213c9e933c",
				"01972fff-1079-76ad-b8fe-5aecbb48ddeb",
				"01972fff-1079-713b-a03f-e0ce0a545589",
				"01972fff-1079-7a7c-8c1b-7717551a1c75",
				"01972fff-1079-7faf-960e-54f5a7676c30",
				"01972fff-1079-73fa-898c-4ac9701d8f41"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7860-8596-be4f24147ebd",
					"date": "2025-06-02T09:35:34.519512Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-76d2-a82f-cee00eebeb52": {
			"id": "01972fff-1077-76d2-a82f-cee00eebeb52",
			"batchId": "01972fff-1072-73f1-a610-a81b67cc8cef",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-7e6b-bb4d-59b784a41766",
				"01972fff-1078-7b57-9907-d8431fda9428",
				"01972fff-1078-7b63-b52b-fe5610f9bab2",
				"01972fff-1078-7281-a0d6-5d6e823d7998",
				"01972fff-1078-7092-a709-9a30e7628c96",
				"01972fff-1078-7a66-884e-16a5657180de",
				"01972fff-1078-738b-9efb-327946505655",
				"01972fff-1078-7336-9905-94d28796169d",
				"01972fff-1078-7a32-8efe-8a0392957669",
				"01972fff-1078-7455-b924-4e123944f9ec",
				"01972fff-1078-7811-9adf-2022645fae13",
				"01972fff-1078-7cd3-bff2-83bb5191e221",
				"01972fff-1078-77fd-898b-e81b98ad14a7",
				"01972fff-1078-73a3-af45-33c178f1daaf",
				"01972fff-1078-7374-ae25-98639186caac",
				"01972fff-1078-7165-b3a4-be77de85b1a8",
				"01972fff-1078-7be6-a35c-486e57036383",
				"01972fff-1078-771a-a7b6-929878ecafee"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7795-8753-b62b257b43c9",
					"date": "2025-06-02T09:35:34.5194962Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7fc9-ac9c-ad32c3d8fe97": {
			"id": "01972fff-1077-7fc9-ac9c-ad32c3d8fe97",
			"batchId": "01972fff-1072-73f1-a610-a81b67cc8cef",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1079-7655-a470-4853e5cdf2cb",
				"01972fff-1079-709a-a060-5c4bcccdecf7",
				"01972fff-1079-74df-87ff-ed972534520d",
				"01972fff-1079-7ab3-883f-53c3637337b9",
				"01972fff-1079-75a3-92be-7eb73715d8e6",
				"01972fff-1079-7afa-957b-5a988e568aa1",
				"01972fff-1079-7972-a551-d820eb532706",
				"01972fff-1079-708c-ae42-985f7c9afebf",
				"01972fff-1079-72b9-abfa-ed9a6188d1bb",
				"01972fff-1079-7edc-8f12-bb85a692517e",
				"01972fff-1079-7ae6-a3d1-13beedc9c382",
				"01972fff-1079-726b-8ed7-4d326cf1a4d8",
				"01972fff-1079-7e23-8581-6f5074b44f92",
				"01972fff-1079-7308-a722-84069fc5dff6",
				"01972fff-1079-70cd-bf24-cefb0a4cd5c9",
				"01972fff-1079-758c-b753-6aa84b0b5abe",
				"01972fff-1079-78bb-9af9-805a94378f40",
				"01972fff-1079-7094-ac45-6db47f85ee4a"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7c7c-b41d-acd33c9fd5bf",
					"date": "2025-06-02T09:35:34.519513Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7929-9ef9-5968d1f0ae8f": {
			"id": "01972fff-1077-7929-9ef9-5968d1f0ae8f",
			"batchId": "01972fff-1072-7819-bbc5-19a6852bdb3a",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-73c5-8d7a-cb22f0011ce3",
				"01972fff-1078-76f3-ab87-c76a01448e35",
				"01972fff-1078-7c28-8391-a5890416a4e1",
				"01972fff-1078-75dc-8e1e-42e13c2f8414",
				"01972fff-1078-7057-b199-80ea76aa9808",
				"01972fff-1078-7026-b1ef-597da8ef1ff7",
				"01972fff-1078-7daf-bcd9-3acf56878661",
				"01972fff-1078-7e8b-8461-445585a9f25e",
				"01972fff-1078-759c-85ed-8734116abc24",
				"01972fff-1078-7990-95fa-1dfc6a2c0ba2",
				"01972fff-1078-788e-b6dd-84ece37ad91b",
				"01972fff-1078-7215-8b24-9733be49416c"
			],
			"approvals": [
				{
					"id": "01972fff-1077-73d5-bbd6-58f3385d9f3b",
					"date": "2025-06-02T09:35:34.5194967Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7bdd-adf5-05236192d8b6": {
			"id": "01972fff-1077-7bdd-adf5-05236192d8b6",
			"batchId": "01972fff-1072-7819-bbc5-19a6852bdb3a",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1079-725b-9319-388910597c37",
				"01972fff-1079-7156-9443-ca5a80e1d75e",
				"01972fff-1079-7167-b3e9-76c52c3ed7d6",
				"01972fff-1079-70aa-a03c-5644664c8337",
				"01972fff-1079-78a3-ad22-79f582af97d5",
				"01972fff-1079-7f88-a9ff-a06fb8b047e0",
				"01972fff-1079-74b7-9d28-f00298911704",
				"01972fff-1079-7ecb-8d62-75893defbc98",
				"01972fff-1079-726c-9338-091db8e35bc7",
				"01972fff-1079-756d-aefc-6eb072da6b0c",
				"01972fff-1079-767d-8d39-8c4a31adfcd9",
				"01972fff-1079-7ace-88ab-3018ae759bac"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7608-a716-d8655a34e1ad",
					"date": "2025-06-02T09:35:34.5195134Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7fde-9d4b-ca3f4a76dbd4": {
			"id": "01972fff-1077-7fde-9d4b-ca3f4a76dbd4",
			"batchId": "01972fff-1072-77ed-9e78-df3b31e6b183",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-7e80-8051-dde09ed01c58",
				"01972fff-1078-71d2-ac07-b9714d89e06d",
				"01972fff-1078-7dca-abc5-40464c93158f",
				"01972fff-1078-70f8-8c07-0d0ca2ae932a",
				"01972fff-1078-745b-a9d8-36614ba22dc8",
				"01972fff-1078-7936-8c20-ee5579f1ea30",
				"01972fff-1078-7272-9744-f775859974ed",
				"01972fff-1078-721e-8652-2f007ddf8444",
				"01972fff-1078-77f5-82f5-067ddc36825b",
				"01972fff-1078-77f4-9636-981aaf4f3ac7",
				"01972fff-1078-7a8d-bec3-d4ae6df8dd09",
				"01972fff-1078-7e69-92ea-0b2849148323"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7e56-995c-6f9430a47a02",
					"date": "2025-06-02T09:35:34.5194971Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7306-88cc-0740b056a341": {
			"id": "01972fff-1077-7306-88cc-0740b056a341",
			"batchId": "01972fff-1072-77ed-9e78-df3b31e6b183",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1079-766d-abe1-cd8712ae29cb",
				"01972fff-1079-74fb-970d-7c46c263859b",
				"01972fff-1079-7d98-8393-1e51c86323f5",
				"01972fff-1079-7d0c-b1c6-6fd78aaad863",
				"01972fff-1079-7114-ad29-7b8f8379e8f1",
				"01972fff-1079-70dd-9442-ef422addbd98",
				"01972fff-1079-7e1a-a053-de35405f662d",
				"01972fff-1079-76bb-b60d-38029176d1fd",
				"01972fff-1079-7c03-90d2-e2bd20f680cd",
				"01972fff-1079-73d7-82a8-3b882efe3a63",
				"01972fff-1079-76ce-9615-dca6b88cedd1",
				"01972fff-1079-777c-a88d-309c84c36016"
			],
			"approvals": [
				{
					"id": "01972fff-1077-772c-8266-2c63d0d78acf",
					"date": "2025-06-02T09:35:34.5195138Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7f61-b727-3d4d92f17810": {
			"id": "01972fff-1077-7f61-b727-3d4d92f17810",
			"batchId": "01972fff-1072-76f9-ad71-4bd032582c4b",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-7cc2-9d6b-3df96df00526",
				"01972fff-1078-7b9b-a914-9331193d97d1",
				"01972fff-1078-7297-898c-a1131b02540b",
				"01972fff-1078-7564-813a-b11adfaaa227",
				"01972fff-1078-7dae-9f01-468ecb82b99d",
				"01972fff-1078-7464-b896-2c541073b18d",
				"01972fff-1078-709a-be7d-ed8fa393e273",
				"01972fff-1078-776c-827f-88df6e209122",
				"01972fff-1078-7e21-a185-a3d6c66ed379",
				"01972fff-1078-7133-8dee-86eb8684169a",
				"01972fff-1078-7cc6-9a5d-5b90e58a3243",
				"01972fff-1078-7157-8c0d-412ca8cd73e9"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7790-97ec-dde58e08924a",
					"date": "2025-06-02T09:35:34.5194979Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-73ef-8555-802367637495": {
			"id": "01972fff-1077-73ef-8555-802367637495",
			"batchId": "01972fff-1072-76f9-ad71-4bd032582c4b",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1079-787f-8e72-8aa049089cdd",
				"01972fff-1079-7b82-ad61-36dbf871cdca",
				"01972fff-1079-79df-b49a-c9e6ccb8c662",
				"01972fff-1079-7c40-8507-0c6719d5c1bf",
				"01972fff-1079-7520-ae6d-21984f20570b",
				"01972fff-1079-7a5b-834c-a93e3e1f42e4",
				"01972fff-1079-7751-9c21-881e9c248a9c",
				"01972fff-1079-73f9-8263-c624da0b308f",
				"01972fff-1079-7fda-8cf7-76dae948bc58",
				"01972fff-1079-7030-81f3-c96e45ba88ef",
				"01972fff-1079-7e76-a6ef-0eef972ef310",
				"01972fff-1079-71e8-b63e-68f5b99dca19"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7683-8632-967ce8206b6c",
					"date": "2025-06-02T09:35:34.5195142Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-75a9-9407-8e3f301005f9": {
			"id": "01972fff-1077-75a9-9407-8e3f301005f9",
			"batchId": "01972fff-1072-7b36-a968-5fc75b06ae29",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-75b6-b7fe-0dadb3fdc18b",
				"01972fff-1078-7c86-b3c0-ec38004d6530",
				"01972fff-1078-78f0-9d2b-f6cac6c152bc",
				"01972fff-1078-79df-aa06-960c6eb15b49",
				"01972fff-1078-74d2-aa10-1f2b3256c5dd",
				"01972fff-1078-7b9d-b584-0f2f4d06ecb8",
				"01972fff-1078-75d9-82c9-574dcdd02236",
				"01972fff-1078-7c39-9fd0-8f91a8d30398",
				"01972fff-1078-79e1-8528-2248ca264448",
				"01972fff-1078-74ef-a0c8-59b1404d93ae",
				"01972fff-1078-7bff-bfe7-248b9bd433d9",
				"01972fff-1078-7169-834c-3390ea25b15a"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7899-a3bb-b26e7a2eab81",
					"date": "2025-06-02T09:35:34.5194985Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7091-99b1-7e6487ef5312": {
			"id": "01972fff-1077-7091-99b1-7e6487ef5312",
			"batchId": "01972fff-1072-7b36-a968-5fc75b06ae29",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1079-7477-b4b9-cca441f08c13",
				"01972fff-1079-7613-898d-e4e31459ab4b",
				"01972fff-1079-7ee1-a1bf-caf4ffc46fa2",
				"01972fff-1079-7c28-8109-9f70ee5ad86d",
				"01972fff-1079-7067-9007-718feedaa60e",
				"01972fff-1079-71a7-ac89-a1490e2b6bd2",
				"01972fff-1079-7bd9-b969-49ab07b6d7dd",
				"01972fff-1079-7433-af01-1074dffe1774",
				"01972fff-1079-7c36-87d7-b0a86f52f221",
				"01972fff-1079-7730-ac3f-abb4999b9a79",
				"01972fff-1079-7cf9-85a4-d46c1c44ea1a",
				"01972fff-1079-7dd4-8c4b-b42173875fe7"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7728-83e9-655b28eb7c19",
					"date": "2025-06-02T09:35:34.5195148Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-792a-b295-a3a819f5db54": {
			"id": "01972fff-1077-792a-b295-a3a819f5db54",
			"batchId": "01972fff-1072-79ac-85ba-c5062f178a1d",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-794f-ae67-5494c19d8f3a",
				"01972fff-1078-7bd3-8108-a7d864629bf2",
				"01972fff-1078-7252-99ca-05b0e810e68e",
				"01972fff-1078-7b08-8a59-48a987001a89",
				"01972fff-1078-7879-a552-2e36718909e0",
				"01972fff-1078-70f1-bcf6-b5c52c0adfe3",
				"01972fff-1078-74a8-b9a0-1cff23770cab",
				"01972fff-1078-7b83-8adc-735155f7b983",
				"01972fff-1078-7406-917c-106f8f2e14bd",
				"01972fff-1078-7a07-9455-caa109004cd3",
				"01972fff-1078-76f3-9d28-ed2a7fc7d161",
				"01972fff-1078-73b1-b2e0-bcc6eea4e425",
				"01972fff-1078-7aa4-bdaa-6dc8b269ae62",
				"01972fff-1078-7203-82d8-95e740a2366c",
				"01972fff-1078-7f96-ae20-092f1081b61e",
				"01972fff-1078-74dc-b6d6-247000b5625c",
				"01972fff-1078-781a-b868-cc2538f2d84e",
				"01972fff-1078-7343-b964-8453eb7d9864"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7539-a7b3-16bf61d962cb",
					"date": "2025-06-02T09:35:34.5194995Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7337-9559-e30fcc3c1941": {
			"id": "01972fff-1077-7337-9559-e30fcc3c1941",
			"batchId": "01972fff-1072-79ac-85ba-c5062f178a1d",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1079-7cd7-8fdb-cf7396eb0a2a",
				"01972fff-1079-70b3-ad6d-0844075cb34b",
				"01972fff-1079-7533-bc0f-498da3cc2d27",
				"01972fff-1079-7b87-905b-fbd3599d3671",
				"01972fff-1079-7f1d-975e-65c5618c528d",
				"01972fff-1079-75e0-a834-ab62eca21d20",
				"01972fff-1079-7a40-8d39-5e8a201cefba",
				"01972fff-1079-7081-843d-2edf4a148fb7",
				"01972fff-1079-755e-aa1d-09b6ea7ebf26",
				"01972fff-1079-7e1b-afb1-8c411a224bb8",
				"01972fff-1079-7245-8b14-ebc7857e7d8e",
				"01972fff-1079-7159-84fb-ee8c2311ce77",
				"01972fff-1079-7a61-8023-a6dd793af19f",
				"01972fff-1079-744a-9f94-31a4713750a8",
				"01972fff-1079-721e-89fb-6cc491037c62",
				"01972fff-1079-762c-9b6d-8fc2c93dcc59",
				"01972fff-1079-735c-a97f-639858619e1c",
				"01972fff-1079-7792-90bc-9d102e7b933a"
			],
			"approvals": [
				{
					"id": "01972fff-1077-761b-b468-1bab1f2258c7",
					"date": "2025-06-02T09:35:34.5195152Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7a74-8b73-c78299c6a553": {
			"id": "01972fff-1077-7a74-8b73-c78299c6a553",
			"batchId": "01972fff-1072-7929-aae1-3b314c5f4b94",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-7d55-a5cd-4e5582ece718",
				"01972fff-1078-7eda-b334-43a026ce3ca6",
				"01972fff-1078-717a-a8f4-21438141a8c3",
				"01972fff-1078-71b1-ae57-a7fc9211fb48",
				"01972fff-1078-72a7-aef1-43fcac7211f2",
				"01972fff-1078-70f8-9619-dd2ff4626266",
				"01972fff-1078-7093-b3c4-a23c4cb313ec",
				"01972fff-1078-70ab-8313-470f38aa9ea3",
				"01972fff-1078-70b1-9e65-b28991c47e9f",
				"01972fff-1078-72e9-a306-010be2228a24",
				"01972fff-1078-742c-a607-70b3f49aeb6d",
				"01972fff-1078-7d27-b0c9-1633825172e6",
				"01972fff-1078-767b-89ee-da49c085cc23",
				"01972fff-1078-74d5-9be4-f1c0f20c4e36",
				"01972fff-1078-798c-b007-446dd4ac87d3",
				"01972fff-1078-7ddb-8e1d-4eddb6067cd5",
				"01972fff-1078-762b-9adb-7b8e789f3a0d",
				"01972fff-1078-7ba4-b88c-60aabc6619fc"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7701-9052-81e44bb87cc9",
					"date": "2025-06-02T09:35:34.5194999Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-73f1-8a55-dc3991819df7": {
			"id": "01972fff-1077-73f1-8a55-dc3991819df7",
			"batchId": "01972fff-1072-7929-aae1-3b314c5f4b94",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1079-77fa-a80b-b90c257a28dd",
				"01972fff-1079-7027-8b30-1e30a8212a43",
				"01972fff-1079-7945-9360-3059ecc18736",
				"01972fff-1079-771d-87c0-43fd65145754",
				"01972fff-1079-718d-aeea-d0e5f4b13904",
				"01972fff-1079-7e80-a50c-cc63bba8a985",
				"01972fff-1079-7ae6-92d0-41f1e8932570",
				"01972fff-1079-7aef-972f-a9ab42acebdc",
				"01972fff-1079-7d92-ac3e-58078e4597e3",
				"01972fff-1079-7481-be11-724f845f7cb2",
				"01972fff-1079-7260-bdb7-59123941b8a6",
				"01972fff-1079-77e7-b248-9916fa64547a",
				"01972fff-1079-7fc8-87e2-0ac0a6725697",
				"01972fff-1079-7150-870e-598b566083d8",
				"01972fff-1079-7631-8487-980e3c58bf60",
				"01972fff-1079-7110-91de-657226c81400",
				"01972fff-1079-7f69-9941-9c6a1bd1a83b",
				"01972fff-1079-7bf1-8381-0b98d0daa50f"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7880-84e1-d5951a07296c",
					"date": "2025-06-02T09:35:34.5195156Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7c5c-843c-21b1c5b4a2e1": {
			"id": "01972fff-1077-7c5c-843c-21b1c5b4a2e1",
			"batchId": "01972fff-1072-7828-a5de-d61c01b89a9c",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-72c7-99f6-4846ae3b30ed",
				"01972fff-1078-729b-b109-edb2dadbf871",
				"01972fff-1078-77f1-99bf-97e65aaf577e",
				"01972fff-1078-7e14-9980-fc215f453fe7",
				"01972fff-1078-7e25-95d8-602865cb83b3",
				"01972fff-1078-7572-a374-f419628fc1f1",
				"01972fff-1078-7636-9a9e-cb54f625f111",
				"01972fff-1078-7ed1-a545-48b8914622ee",
				"01972fff-1078-78b8-924f-19938d948433",
				"01972fff-1078-7471-8c34-2df169a03d90",
				"01972fff-1078-714d-825a-356ec6aaf423",
				"01972fff-1078-7d71-a5fa-6acd52a716ca",
				"01972fff-1078-7014-9bd6-d611c262c0ab",
				"01972fff-1078-72a8-8e86-4e94e525d1cf",
				"01972fff-1078-7de2-94f6-32d453cf4153",
				"01972fff-1078-765a-8748-972d60131587",
				"01972fff-1078-7d22-84eb-913d2a7a2da3",
				"01972fff-1078-7883-8d72-7aeeffe5886d"
			],
			"approvals": [
				{
					"id": "01972fff-1077-730a-917f-1fcfa0225898",
					"date": "2025-06-02T09:35:34.5195003Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7d3a-9df2-6a612c1d3234": {
			"id": "01972fff-1077-7d3a-9df2-6a612c1d3234",
			"batchId": "01972fff-1072-7828-a5de-d61c01b89a9c",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1079-79b5-8484-fad72c28488d",
				"01972fff-1079-7d8b-a00d-fff0be9bde40",
				"01972fff-1079-74b9-a0c3-d09a4935592e",
				"01972fff-1079-7473-8193-1865f834325c",
				"01972fff-1079-7bae-bde3-1975e65984f2",
				"01972fff-1079-7100-ad43-68ddefbe7d65",
				"01972fff-1079-7fe5-a005-f82e06d932dd",
				"01972fff-1079-7548-982f-24e53eb11fb0",
				"01972fff-1079-7a9f-af91-6a9c55a0279c",
				"01972fff-1079-7b4e-b872-9150dac1adbf",
				"01972fff-1079-7926-9b80-f3c5e15f5d68",
				"01972fff-1079-7a8b-841a-91fed00a00af",
				"01972fff-1079-7206-a83a-31d1ba47e356",
				"01972fff-1079-7bda-8bfd-805b1f1c7cb6",
				"01972fff-1079-7883-8835-b0b66bcecb6c",
				"01972fff-1079-7d11-9fca-7e6336f558ed",
				"01972fff-1079-78db-aba3-dcca3b890f41",
				"01972fff-1079-782a-ad93-da7f993935eb"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7b3f-99f2-c264b9beb160",
					"date": "2025-06-02T09:35:34.519516Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-769d-8792-bb80fafc6420": {
			"id": "01972fff-1077-769d-8792-bb80fafc6420",
			"batchId": "01972fff-1072-7471-b6dc-059c3485d5fa",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-7da6-b8ad-1428475c123b",
				"01972fff-1078-725f-bd9b-6a5de9b2b4a9",
				"01972fff-1078-76af-87e5-850db9ce8e33",
				"01972fff-1078-74bd-9567-1a3d8c58b6e5",
				"01972fff-1078-71f7-a1bc-dd160de6adc2",
				"01972fff-1078-7836-8775-0d17acc69304",
				"01972fff-1078-74dc-986e-74f5d439dce1",
				"01972fff-1078-7c0a-bcfa-215367380353",
				"01972fff-1078-7ac7-9b9f-a47972c50e53",
				"01972fff-1078-7a4f-a9c8-e1485d30e97c",
				"01972fff-1078-75ab-a028-6051373e4e74",
				"01972fff-1078-799b-ad0d-bfb8bdb13010",
				"01972fff-1078-7db6-8489-201ade1c647d",
				"01972fff-1078-717d-bcd3-ec553ab4b11b",
				"01972fff-1078-7958-85a7-dcf0043661cf",
				"01972fff-1078-7455-ae55-4fba33d0dcd2",
				"01972fff-1078-71d7-b26e-b479b4b6879b",
				"01972fff-1078-7e00-bd24-d9d5cba5bd77"
			],
			"approvals": [
				{
					"id": "01972fff-1077-73ee-8ac7-f39a671c47e3",
					"date": "2025-06-02T09:35:34.5195009Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7dd1-81f9-1b92da554a04": {
			"id": "01972fff-1077-7dd1-81f9-1b92da554a04",
			"batchId": "01972fff-1072-7471-b6dc-059c3485d5fa",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1079-7b63-b4be-4897222c6a10",
				"01972fff-1079-7ce9-b41f-8826fd7b3b26",
				"01972fff-1079-7c31-8412-39e01e33105c",
				"01972fff-1079-78da-b4a5-01d95a3712b0",
				"01972fff-1079-799d-8f27-634191c07961",
				"01972fff-1079-7352-a52e-280bdbe723e3",
				"01972fff-1079-7bc1-96f3-38275c935f66",
				"01972fff-1079-783d-b717-0c348d3ca547",
				"01972fff-1079-72de-ab10-49a1ff491c02",
				"01972fff-1079-7ce4-986a-ecfe90a8cc1a",
				"01972fff-1079-7e74-80eb-5c8ae1025360",
				"01972fff-1079-7cf6-b190-c4493c697367",
				"01972fff-1079-7960-91ca-eed112e86c43",
				"01972fff-1079-7753-9bcd-0eb4a398633b",
				"01972fff-1079-7ff3-85af-0f36c923fad0",
				"01972fff-1079-79d6-8110-f42f203bc3c1",
				"01972fff-1079-77c0-b476-876ef441f175",
				"01972fff-1079-7b33-ba79-30f32e14af5b"
			],
			"approvals": [
				{
					"id": "01972fff-1077-79e3-b261-4f31d050194b",
					"date": "2025-06-02T09:35:34.5195165Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7b69-a7fc-04ba5e609c16": {
			"id": "01972fff-1077-7b69-a7fc-04ba5e609c16",
			"batchId": "01972fff-1072-761c-9bcd-767deb67e3aa",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-7eb6-a4dd-cc639b2fbbcb",
				"01972fff-1078-788f-be27-cbd368a47a87",
				"01972fff-1078-7421-8684-83775fb30778",
				"01972fff-1078-76e3-b96a-f4abfad899ac",
				"01972fff-1078-7625-9187-ac4f9d9d1048",
				"01972fff-1078-7fa1-a498-fd6fc8308fb7",
				"01972fff-1078-78b6-95d7-bde3aa9abfc6",
				"01972fff-1078-7d10-80cd-e35a8a79408e",
				"01972fff-1078-7b2d-b776-f7307577f6e1",
				"01972fff-1078-7079-acdf-5c1ac7b313aa",
				"01972fff-1078-7833-8a8c-6f596ca09879",
				"01972fff-1078-725a-b897-5be507629ef9"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7cc6-ba6e-c9c74beb807e",
					"date": "2025-06-02T09:35:34.5195014Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7804-ad9f-9e8c4ff69ba8": {
			"id": "01972fff-1077-7804-ad9f-9e8c4ff69ba8",
			"batchId": "01972fff-1072-761c-9bcd-767deb67e3aa",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1079-7566-a9fe-d6937ffd4215",
				"01972fff-1079-7e90-afd9-138d0e89db88",
				"01972fff-1079-77a5-9613-48679fa23547",
				"01972fff-1079-746a-9ba5-14461c6f4a30",
				"01972fff-1079-77af-89e6-49357e9aae3f",
				"01972fff-1079-7759-851d-e68d7d7cd0fd",
				"01972fff-1079-7acb-8216-26e0d8ab31ee",
				"01972fff-1079-7ca2-a776-6267bb84008f",
				"01972fff-1079-722c-bf3e-c2a69612af1c",
				"01972fff-1079-7b21-bf35-e2ea0257b8c2",
				"01972fff-1079-7ea0-a8b5-d8ee9aabb26b",
				"01972fff-1079-7d72-bfd4-4aae2167dbf0"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7e9b-8fb6-d980d23de95a",
					"date": "2025-06-02T09:35:34.5195169Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-7fb6-8fcd-7a60e5bf77e1": {
			"id": "01972fff-1077-7fb6-8fcd-7a60e5bf77e1",
			"batchId": "01972fff-1072-7138-a5c1-ba1a5227320e",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1078-7dfc-9189-762cdec8e55a",
				"01972fff-1078-780e-b499-bd77aa7b7514",
				"01972fff-1078-7dad-abad-f3daa6730010",
				"01972fff-1078-77aa-ae83-504ce088098c",
				"01972fff-1078-7ba8-a73d-74754612efee",
				"01972fff-1078-7001-a102-63b6bf52442a",
				"01972fff-1078-794e-8b3f-40c1caa6231c",
				"01972fff-1078-7732-bb9a-61a665e307b2",
				"01972fff-1078-7f2e-8dfb-e3c14d1f5eb0",
				"01972fff-1078-7518-8c3e-676d0e28491f",
				"01972fff-1078-7e64-9b8f-01c79131ceae",
				"01972fff-1078-7e97-a718-ec7e488219aa"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7882-9385-2e8d8a6c6cd9",
					"date": "2025-06-02T09:35:34.5195018Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InitialWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		},
		"01972fff-1077-74bf-bfd6-cca461010b16": {
			"id": "01972fff-1077-74bf-bfd6-cca461010b16",
			"batchId": "01972fff-1072-7138-a5c1-ba1a5227320e",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"animalWeighingIds": [
				"01972fff-1079-7b8a-9690-20c03dff38be",
				"01972fff-1079-7488-8f4b-1b6b956f8e9a",
				"01972fff-1079-7eb2-943e-621821ed608b",
				"01972fff-1079-7fdd-9a19-a8b72c470558",
				"01972fff-1079-7fa6-9ead-4e36e961175f",
				"01972fff-1079-78c2-9b32-1a8a1193a8f8",
				"01972fff-1079-78ad-80d7-cdcac7ea78d7",
				"01972fff-1079-78a5-ac40-4348daa33b31",
				"01972fff-1079-7a70-8bd2-333bf2d8d6ee",
				"01972fff-1079-7210-8595-8411ae69a50c",
				"01972fff-1079-7770-878d-e37c4413c3e3",
				"01972fff-1079-7c68-a42f-589127c3b591"
			],
			"approvals": [
				{
					"id": "01972fff-1077-7411-8f55-c2cd173c7887",
					"date": "2025-06-02T09:35:34.5195173Z",
					"approvedBy": {
						"userId": "",
						"name": ""
					},
					"status": {
						"status": "Pending"
					}
				}
			],
			"weighingType": {
				"type": "InterimWeighing"
			},
			"gender": {
				"id": -1,
				"name": "Unknown"
			},
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"sequenceNumber": 1
		}
	},
	"animalWeghings": {
		"01972fff-1078-78bf-b91b-a1faad413af5": {
			"id": "01972fff-1078-78bf-b91b-a1faad413af5",
			"batchWeighingId": "01972fff-1076-7ee7-a86e-0c68981a320c",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-738c-8002-80530c1c9c58",
			"groupId": "01972fff-1074-7d10-981d-df6e8166c11b",
			"feedId": "01972fff-1073-768e-a704-96b337a28dc8",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7ad0-be3c-3269452d87ee": {
			"id": "01972fff-1078-7ad0-be3c-3269452d87ee",
			"batchWeighingId": "01972fff-1076-7ee7-a86e-0c68981a320c",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7760-95c3-b5bd6aa3f3d5",
			"groupId": "01972fff-1074-7dd5-bee8-919b51ae9e46",
			"feedId": "01972fff-1073-7db7-80ac-8842ff8a10c4",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7b7e-bf1f-5f31b7c8cd85": {
			"id": "01972fff-1078-7b7e-bf1f-5f31b7c8cd85",
			"batchWeighingId": "01972fff-1076-7ee7-a86e-0c68981a320c",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7dae-b37e-ea59d076c941",
			"groupId": "01972fff-1074-7e10-a518-1774449f4a78",
			"feedId": "01972fff-1073-7b01-aeb2-d6e7a9fadc56",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7d7a-8d32-da2adcc6f112": {
			"id": "01972fff-1078-7d7a-8d32-da2adcc6f112",
			"batchWeighingId": "01972fff-1076-7ee7-a86e-0c68981a320c",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7975-8e6f-bae9f8a73b89",
			"groupId": "01972fff-1074-7177-bf46-a13f7214290a",
			"feedId": "01972fff-1073-7d55-88cd-5f895dc4abf8",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7126-98d9-4b7b73c88616": {
			"id": "01972fff-1078-7126-98d9-4b7b73c88616",
			"batchWeighingId": "01972fff-1076-7ee7-a86e-0c68981a320c",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c74-9543-da36591e073c",
			"groupId": "01972fff-1074-72f9-b40e-86c50d5bbbc5",
			"feedId": "01972fff-1073-7462-b75a-1795fa322e94",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-704c-ad5a-db2b045845a5": {
			"id": "01972fff-1078-704c-ad5a-db2b045845a5",
			"batchWeighingId": "01972fff-1076-7ee7-a86e-0c68981a320c",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f11-88c2-2496ae669d38",
			"groupId": "01972fff-1074-7d9c-a7e1-1032b8339868",
			"feedId": "01972fff-1073-72e1-98be-7c371f964ea3",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7e39-adac-db8ba23eac78": {
			"id": "01972fff-1078-7e39-adac-db8ba23eac78",
			"batchWeighingId": "01972fff-1076-7ee7-a86e-0c68981a320c",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-764a-a8eb-861dc377f79c",
			"groupId": "01972fff-1074-7d42-ba80-c8fff335e3aa",
			"feedId": "01972fff-1073-7b7a-895e-e2bb43ad02b8",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-71ec-bbf1-ef209a68fca8": {
			"id": "01972fff-1078-71ec-bbf1-ef209a68fca8",
			"batchWeighingId": "01972fff-1076-7ee7-a86e-0c68981a320c",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-73de-87e3-d46cdbe0c1fc",
			"groupId": "01972fff-1074-78c9-a90a-e669a9b391d6",
			"feedId": "01972fff-1073-7c17-adfb-dea545036534",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7471-99eb-398faf279512": {
			"id": "01972fff-1078-7471-99eb-398faf279512",
			"batchWeighingId": "01972fff-1076-7ee7-a86e-0c68981a320c",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-719c-936d-d0f6c8cd8310",
			"groupId": "01972fff-1074-76e2-8f0f-b627d7876d1b",
			"feedId": "01972fff-1073-71bb-9676-74b8ad38a7f5",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7a38-a18f-9ce2eca48fd3": {
			"id": "01972fff-1078-7a38-a18f-9ce2eca48fd3",
			"batchWeighingId": "01972fff-1076-7ee7-a86e-0c68981a320c",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7fef-b3f5-90e7bf54b8a8",
			"groupId": "01972fff-1074-789c-a4a5-038022c0a654",
			"feedId": "01972fff-1073-7143-b001-418161fc9afb",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7387-b95a-8f5e4fa8b040": {
			"id": "01972fff-1078-7387-b95a-8f5e4fa8b040",
			"batchWeighingId": "01972fff-1076-7ee7-a86e-0c68981a320c",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-70e9-a49e-1ebd31ce20ff",
			"groupId": "01972fff-1074-725d-86b7-e110dd1bbaf9",
			"feedId": "01972fff-1073-7b7e-913d-84011af660c6",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7d98-8fe8-bb0a52d48aaf": {
			"id": "01972fff-1078-7d98-8fe8-bb0a52d48aaf",
			"batchWeighingId": "01972fff-1076-7ee7-a86e-0c68981a320c",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7519-a311-5f7ab4f7711e",
			"groupId": "01972fff-1074-7453-b115-d3264654e675",
			"feedId": "01972fff-1073-7ce5-832d-17f4dd82207c",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7948-b5fd-752a19fce407": {
			"id": "01972fff-1078-7948-b5fd-752a19fce407",
			"batchWeighingId": "01972fff-1077-7457-91b7-8ae28cd562fe",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-738c-8002-80530c1c9c58",
			"groupId": "01972fff-1074-7d10-981d-df6e8166c11b",
			"feedId": "01972fff-1073-768e-a704-96b337a28dc8",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7881-aa8b-48669ed3b4fb": {
			"id": "01972fff-1078-7881-aa8b-48669ed3b4fb",
			"batchWeighingId": "01972fff-1077-7457-91b7-8ae28cd562fe",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7760-95c3-b5bd6aa3f3d5",
			"groupId": "01972fff-1074-7dd5-bee8-919b51ae9e46",
			"feedId": "01972fff-1073-7db7-80ac-8842ff8a10c4",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-72dd-9405-7567bd6c6619": {
			"id": "01972fff-1078-72dd-9405-7567bd6c6619",
			"batchWeighingId": "01972fff-1077-7457-91b7-8ae28cd562fe",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7dae-b37e-ea59d076c941",
			"groupId": "01972fff-1074-7e10-a518-1774449f4a78",
			"feedId": "01972fff-1073-7b01-aeb2-d6e7a9fadc56",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7934-b636-b256b675ffda": {
			"id": "01972fff-1078-7934-b636-b256b675ffda",
			"batchWeighingId": "01972fff-1077-7457-91b7-8ae28cd562fe",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7975-8e6f-bae9f8a73b89",
			"groupId": "01972fff-1074-7177-bf46-a13f7214290a",
			"feedId": "01972fff-1073-7d55-88cd-5f895dc4abf8",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7bc0-9ddb-baa81152b482": {
			"id": "01972fff-1078-7bc0-9ddb-baa81152b482",
			"batchWeighingId": "01972fff-1077-7457-91b7-8ae28cd562fe",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c74-9543-da36591e073c",
			"groupId": "01972fff-1074-72f9-b40e-86c50d5bbbc5",
			"feedId": "01972fff-1073-7462-b75a-1795fa322e94",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7445-986b-176bbadfd8e7": {
			"id": "01972fff-1078-7445-986b-176bbadfd8e7",
			"batchWeighingId": "01972fff-1077-7457-91b7-8ae28cd562fe",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f11-88c2-2496ae669d38",
			"groupId": "01972fff-1074-7d9c-a7e1-1032b8339868",
			"feedId": "01972fff-1073-72e1-98be-7c371f964ea3",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7677-ab06-1175669246fd": {
			"id": "01972fff-1078-7677-ab06-1175669246fd",
			"batchWeighingId": "01972fff-1077-7457-91b7-8ae28cd562fe",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-764a-a8eb-861dc377f79c",
			"groupId": "01972fff-1074-7d42-ba80-c8fff335e3aa",
			"feedId": "01972fff-1073-7b7a-895e-e2bb43ad02b8",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7457-87e1-995480402fe1": {
			"id": "01972fff-1078-7457-87e1-995480402fe1",
			"batchWeighingId": "01972fff-1077-7457-91b7-8ae28cd562fe",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-73de-87e3-d46cdbe0c1fc",
			"groupId": "01972fff-1074-78c9-a90a-e669a9b391d6",
			"feedId": "01972fff-1073-7c17-adfb-dea545036534",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-71ac-bdfe-76b411823a01": {
			"id": "01972fff-1078-71ac-bdfe-76b411823a01",
			"batchWeighingId": "01972fff-1077-7457-91b7-8ae28cd562fe",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-719c-936d-d0f6c8cd8310",
			"groupId": "01972fff-1074-76e2-8f0f-b627d7876d1b",
			"feedId": "01972fff-1073-71bb-9676-74b8ad38a7f5",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7fd6-9a4a-ee1f5a9bd258": {
			"id": "01972fff-1078-7fd6-9a4a-ee1f5a9bd258",
			"batchWeighingId": "01972fff-1077-7457-91b7-8ae28cd562fe",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7fef-b3f5-90e7bf54b8a8",
			"groupId": "01972fff-1074-789c-a4a5-038022c0a654",
			"feedId": "01972fff-1073-7143-b001-418161fc9afb",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7806-ad52-409e971bfe7f": {
			"id": "01972fff-1078-7806-ad52-409e971bfe7f",
			"batchWeighingId": "01972fff-1077-7457-91b7-8ae28cd562fe",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-70e9-a49e-1ebd31ce20ff",
			"groupId": "01972fff-1074-725d-86b7-e110dd1bbaf9",
			"feedId": "01972fff-1073-7b7e-913d-84011af660c6",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7062-a86f-dfb1231f0127": {
			"id": "01972fff-1078-7062-a86f-dfb1231f0127",
			"batchWeighingId": "01972fff-1077-7457-91b7-8ae28cd562fe",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7519-a311-5f7ab4f7711e",
			"groupId": "01972fff-1074-7453-b115-d3264654e675",
			"feedId": "01972fff-1073-7ce5-832d-17f4dd82207c",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7abf-ae65-6f9a6b8fcb0d": {
			"id": "01972fff-1078-7abf-ae65-6f9a6b8fcb0d",
			"batchWeighingId": "01972fff-1077-76a5-b5a9-6786d1169fdc",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7eba-9776-82691d10b223",
			"groupId": "01972fff-1074-7df4-bcac-95bdc5a11fce",
			"feedId": "01972fff-1073-73a6-8a70-97ef8536f835",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-75ca-8419-22ab7580d14c": {
			"id": "01972fff-1078-75ca-8419-22ab7580d14c",
			"batchWeighingId": "01972fff-1077-76a5-b5a9-6786d1169fdc",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ab5-b24d-428d7d28ce64",
			"groupId": "01972fff-1074-78f0-bba5-a1316d26e785",
			"feedId": "01972fff-1073-736c-a710-27875801f006",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7654-8d1f-b779e5640b87": {
			"id": "01972fff-1078-7654-8d1f-b779e5640b87",
			"batchWeighingId": "01972fff-1077-76a5-b5a9-6786d1169fdc",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7417-939c-f98b0727e8e2",
			"groupId": "01972fff-1074-7dcb-9176-bfcc1b1d3003",
			"feedId": "01972fff-1073-7dca-a739-5974d1cec08a",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7d6d-83ca-7795f8972196": {
			"id": "01972fff-1078-7d6d-83ca-7795f8972196",
			"batchWeighingId": "01972fff-1077-76a5-b5a9-6786d1169fdc",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7312-8ebe-b2c789cd0651",
			"groupId": "01972fff-1074-74e8-a28c-caa1f88d3e19",
			"feedId": "01972fff-1073-78cc-812f-e00712c04d46",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-77f9-b5ef-ad7ae8ec79e5": {
			"id": "01972fff-1078-77f9-b5ef-ad7ae8ec79e5",
			"batchWeighingId": "01972fff-1077-76a5-b5a9-6786d1169fdc",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7a0b-bef2-e3752acd058c",
			"groupId": "01972fff-1074-79a5-85c0-aa8eb41ab55b",
			"feedId": "01972fff-1073-71ba-8ab2-123d4b06af14",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7de0-8cd9-74ecc565c01b": {
			"id": "01972fff-1078-7de0-8cd9-74ecc565c01b",
			"batchWeighingId": "01972fff-1077-76a5-b5a9-6786d1169fdc",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-735b-a125-253a52f704a3",
			"groupId": "01972fff-1074-7e49-a410-a914f5601901",
			"feedId": "01972fff-1073-7db8-8c5a-55955aaa3e75",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7dfe-b308-4c1acd436349": {
			"id": "01972fff-1078-7dfe-b308-4c1acd436349",
			"batchWeighingId": "01972fff-1077-76a5-b5a9-6786d1169fdc",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b25-990f-8dead42552b1",
			"groupId": "01972fff-1074-7016-a0d3-43cf60310750",
			"feedId": "01972fff-1073-7d3f-8934-70e67e234d0b",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7e21-ab3d-2d1a58c75fd9": {
			"id": "01972fff-1078-7e21-ab3d-2d1a58c75fd9",
			"batchWeighingId": "01972fff-1077-76a5-b5a9-6786d1169fdc",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7506-b926-195a1917c8ee",
			"groupId": "01972fff-1074-768a-b957-6b679dcbde1a",
			"feedId": "01972fff-1073-767c-9d38-738c611aa257",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7515-b38f-0149d04acb12": {
			"id": "01972fff-1078-7515-b38f-0149d04acb12",
			"batchWeighingId": "01972fff-1077-76a5-b5a9-6786d1169fdc",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f48-895d-81d248190670",
			"groupId": "01972fff-1074-7da2-9468-06b6ae96cc3e",
			"feedId": "01972fff-1073-73c8-9a9e-f4417b34b91a",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-744f-a390-ea18e3c6ffa0": {
			"id": "01972fff-1078-744f-a390-ea18e3c6ffa0",
			"batchWeighingId": "01972fff-1077-76a5-b5a9-6786d1169fdc",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-75f4-b9c1-70879f2393e8",
			"groupId": "01972fff-1074-7a16-9a77-141d6f238d7a",
			"feedId": "01972fff-1073-7914-83ab-8d5b1f8b8233",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7156-a47b-e8c5cfc68fd3": {
			"id": "01972fff-1078-7156-a47b-e8c5cfc68fd3",
			"batchWeighingId": "01972fff-1077-76a5-b5a9-6786d1169fdc",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7038-9b04-c008ec5447da",
			"groupId": "01972fff-1074-7ffe-bbf8-004d982c3415",
			"feedId": "01972fff-1073-75b0-9145-ecc03fea2159",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7a3c-b6b4-233a8a2d3680": {
			"id": "01972fff-1078-7a3c-b6b4-233a8a2d3680",
			"batchWeighingId": "01972fff-1077-76a5-b5a9-6786d1169fdc",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-763e-a057-586b9f940469",
			"groupId": "01972fff-1074-7b77-b8fa-d3e8316a684e",
			"feedId": "01972fff-1073-70e4-906b-2d9ae5015a8d",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7006-8757-070205ece31a": {
			"id": "01972fff-1078-7006-8757-070205ece31a",
			"batchWeighingId": "01972fff-1077-70ba-adf8-71118e0771f3",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7eba-9776-82691d10b223",
			"groupId": "01972fff-1074-7df4-bcac-95bdc5a11fce",
			"feedId": "01972fff-1073-73a6-8a70-97ef8536f835",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-78e1-81d5-16d1b7265b75": {
			"id": "01972fff-1078-78e1-81d5-16d1b7265b75",
			"batchWeighingId": "01972fff-1077-70ba-adf8-71118e0771f3",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ab5-b24d-428d7d28ce64",
			"groupId": "01972fff-1074-78f0-bba5-a1316d26e785",
			"feedId": "01972fff-1073-736c-a710-27875801f006",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7d11-ae4b-2b56f97e621d": {
			"id": "01972fff-1078-7d11-ae4b-2b56f97e621d",
			"batchWeighingId": "01972fff-1077-70ba-adf8-71118e0771f3",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7417-939c-f98b0727e8e2",
			"groupId": "01972fff-1074-7dcb-9176-bfcc1b1d3003",
			"feedId": "01972fff-1073-7dca-a739-5974d1cec08a",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-788f-a103-986aea387bd8": {
			"id": "01972fff-1078-788f-a103-986aea387bd8",
			"batchWeighingId": "01972fff-1077-70ba-adf8-71118e0771f3",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7312-8ebe-b2c789cd0651",
			"groupId": "01972fff-1074-74e8-a28c-caa1f88d3e19",
			"feedId": "01972fff-1073-78cc-812f-e00712c04d46",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-74a7-aeea-e350b8f68cf1": {
			"id": "01972fff-1078-74a7-aeea-e350b8f68cf1",
			"batchWeighingId": "01972fff-1077-70ba-adf8-71118e0771f3",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7a0b-bef2-e3752acd058c",
			"groupId": "01972fff-1074-79a5-85c0-aa8eb41ab55b",
			"feedId": "01972fff-1073-71ba-8ab2-123d4b06af14",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7ecd-90b9-76996819a74b": {
			"id": "01972fff-1078-7ecd-90b9-76996819a74b",
			"batchWeighingId": "01972fff-1077-70ba-adf8-71118e0771f3",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-735b-a125-253a52f704a3",
			"groupId": "01972fff-1074-7e49-a410-a914f5601901",
			"feedId": "01972fff-1073-7db8-8c5a-55955aaa3e75",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7059-b528-25daae415435": {
			"id": "01972fff-1078-7059-b528-25daae415435",
			"batchWeighingId": "01972fff-1077-70ba-adf8-71118e0771f3",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b25-990f-8dead42552b1",
			"groupId": "01972fff-1074-7016-a0d3-43cf60310750",
			"feedId": "01972fff-1073-7d3f-8934-70e67e234d0b",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-70d3-abdf-e67b260ad99d": {
			"id": "01972fff-1078-70d3-abdf-e67b260ad99d",
			"batchWeighingId": "01972fff-1077-70ba-adf8-71118e0771f3",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7506-b926-195a1917c8ee",
			"groupId": "01972fff-1074-768a-b957-6b679dcbde1a",
			"feedId": "01972fff-1073-767c-9d38-738c611aa257",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-73d7-87f0-760b83901bd0": {
			"id": "01972fff-1078-73d7-87f0-760b83901bd0",
			"batchWeighingId": "01972fff-1077-70ba-adf8-71118e0771f3",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f48-895d-81d248190670",
			"groupId": "01972fff-1074-7da2-9468-06b6ae96cc3e",
			"feedId": "01972fff-1073-73c8-9a9e-f4417b34b91a",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7b4a-bc83-85029e251d33": {
			"id": "01972fff-1078-7b4a-bc83-85029e251d33",
			"batchWeighingId": "01972fff-1077-70ba-adf8-71118e0771f3",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-75f4-b9c1-70879f2393e8",
			"groupId": "01972fff-1074-7a16-9a77-141d6f238d7a",
			"feedId": "01972fff-1073-7914-83ab-8d5b1f8b8233",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7862-856b-3528e90f4f56": {
			"id": "01972fff-1078-7862-856b-3528e90f4f56",
			"batchWeighingId": "01972fff-1077-70ba-adf8-71118e0771f3",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7038-9b04-c008ec5447da",
			"groupId": "01972fff-1074-7ffe-bbf8-004d982c3415",
			"feedId": "01972fff-1073-75b0-9145-ecc03fea2159",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7fa6-8bdf-69751d41797b": {
			"id": "01972fff-1078-7fa6-8bdf-69751d41797b",
			"batchWeighingId": "01972fff-1077-70ba-adf8-71118e0771f3",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-763e-a057-586b9f940469",
			"groupId": "01972fff-1074-7b77-b8fa-d3e8316a684e",
			"feedId": "01972fff-1073-70e4-906b-2d9ae5015a8d",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-763d-9ddb-b06b13a1cd8b": {
			"id": "01972fff-1078-763d-9ddb-b06b13a1cd8b",
			"batchWeighingId": "01972fff-1077-784e-b475-8696fb687e2f",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7cc0-8f09-74e5c8d3e0c8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-70d5-928e-3c193b49531e": {
			"id": "01972fff-1078-70d5-928e-3c193b49531e",
			"batchWeighingId": "01972fff-1077-784e-b475-8696fb687e2f",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72a9-9660-c9530e27c9c4",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7052-8361-7a32a15b74fa": {
			"id": "01972fff-1078-7052-8361-7a32a15b74fa",
			"batchWeighingId": "01972fff-1077-784e-b475-8696fb687e2f",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c80-b927-c4dd6a802201",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-78c6-97ea-befb4db0b13c": {
			"id": "01972fff-1078-78c6-97ea-befb4db0b13c",
			"batchWeighingId": "01972fff-1077-784e-b475-8696fb687e2f",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7de0-a2c2-04b18d96cf1c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-772c-913e-171aeadde30f": {
			"id": "01972fff-1078-772c-913e-171aeadde30f",
			"batchWeighingId": "01972fff-1077-784e-b475-8696fb687e2f",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-78e4-bf20-7df89055c146",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-728c-aa1e-97fed8459c8d": {
			"id": "01972fff-1078-728c-aa1e-97fed8459c8d",
			"batchWeighingId": "01972fff-1077-784e-b475-8696fb687e2f",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bb2-9afa-2aaca02d4cd1",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-75bb-b8a5-5d6147a89d07": {
			"id": "01972fff-1078-75bb-b8a5-5d6147a89d07",
			"batchWeighingId": "01972fff-1077-784e-b475-8696fb687e2f",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-73a5-a585-dbd6c2beaca5",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-741a-8043-354d657f64ba": {
			"id": "01972fff-1078-741a-8043-354d657f64ba",
			"batchWeighingId": "01972fff-1077-784e-b475-8696fb687e2f",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e0c-8e4a-4574c3d0def1",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-79c3-82b4-047c5b286e3a": {
			"id": "01972fff-1078-79c3-82b4-047c5b286e3a",
			"batchWeighingId": "01972fff-1077-784e-b475-8696fb687e2f",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b5c-b9c3-a8646cef2411",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-781d-bd12-582eb744b6e3": {
			"id": "01972fff-1078-781d-bd12-582eb744b6e3",
			"batchWeighingId": "01972fff-1077-784e-b475-8696fb687e2f",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bf7-9a2d-255c32e6bab6",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7547-af36-68265cc07b0b": {
			"id": "01972fff-1078-7547-af36-68265cc07b0b",
			"batchWeighingId": "01972fff-1077-784e-b475-8696fb687e2f",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-77e5-8abc-31b7064e18f9",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7dc8-b04b-1c5fc865d7f7": {
			"id": "01972fff-1078-7dc8-b04b-1c5fc865d7f7",
			"batchWeighingId": "01972fff-1077-784e-b475-8696fb687e2f",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-79c5-85e8-41ce5450a00e",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7447-98d6-385b3b101738": {
			"id": "01972fff-1078-7447-98d6-385b3b101738",
			"batchWeighingId": "01972fff-1077-784e-b475-8696fb687e2f",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7254-9a40-bce0b6095f36",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7b68-be24-1530439df78f": {
			"id": "01972fff-1078-7b68-be24-1530439df78f",
			"batchWeighingId": "01972fff-1077-784e-b475-8696fb687e2f",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7de7-b6c1-f86afe274a36",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-758c-a623-c330d636091c": {
			"id": "01972fff-1078-758c-a623-c330d636091c",
			"batchWeighingId": "01972fff-1077-784e-b475-8696fb687e2f",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e91-85c6-54515cbe68e8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7b4d-b1a9-4c86e75b646c": {
			"id": "01972fff-1078-7b4d-b1a9-4c86e75b646c",
			"batchWeighingId": "01972fff-1077-784e-b475-8696fb687e2f",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7eac-bd4c-8e83837951e7",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7fba-9010-85fa1c1ed894": {
			"id": "01972fff-1078-7fba-9010-85fa1c1ed894",
			"batchWeighingId": "01972fff-1077-784e-b475-8696fb687e2f",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f7f-be3e-d0da05b69a77",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7ae6-9538-2627d7a7c3d0": {
			"id": "01972fff-1078-7ae6-9538-2627d7a7c3d0",
			"batchWeighingId": "01972fff-1077-784e-b475-8696fb687e2f",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-76b4-be3e-26e9330abc8c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7fb1-b709-cefa0ac2b180": {
			"id": "01972fff-1078-7fb1-b709-cefa0ac2b180",
			"batchWeighingId": "01972fff-1077-7065-b662-6eafb71f91d4",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7cc0-8f09-74e5c8d3e0c8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-792c-b021-a691b6564d87": {
			"id": "01972fff-1078-792c-b021-a691b6564d87",
			"batchWeighingId": "01972fff-1077-7065-b662-6eafb71f91d4",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72a9-9660-c9530e27c9c4",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7319-b756-acd7e41fc408": {
			"id": "01972fff-1078-7319-b756-acd7e41fc408",
			"batchWeighingId": "01972fff-1077-7065-b662-6eafb71f91d4",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c80-b927-c4dd6a802201",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7149-a404-5c2431c4a764": {
			"id": "01972fff-1078-7149-a404-5c2431c4a764",
			"batchWeighingId": "01972fff-1077-7065-b662-6eafb71f91d4",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7de0-a2c2-04b18d96cf1c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7160-8f80-3c353f2a13d7": {
			"id": "01972fff-1078-7160-8f80-3c353f2a13d7",
			"batchWeighingId": "01972fff-1077-7065-b662-6eafb71f91d4",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-78e4-bf20-7df89055c146",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7028-8c14-2c8ec0a49899": {
			"id": "01972fff-1078-7028-8c14-2c8ec0a49899",
			"batchWeighingId": "01972fff-1077-7065-b662-6eafb71f91d4",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bb2-9afa-2aaca02d4cd1",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-73ad-aacb-90a60eeae3e2": {
			"id": "01972fff-1078-73ad-aacb-90a60eeae3e2",
			"batchWeighingId": "01972fff-1077-7065-b662-6eafb71f91d4",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-73a5-a585-dbd6c2beaca5",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7743-8a35-ca4cb2d64c19": {
			"id": "01972fff-1078-7743-8a35-ca4cb2d64c19",
			"batchWeighingId": "01972fff-1077-7065-b662-6eafb71f91d4",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e0c-8e4a-4574c3d0def1",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7100-baf7-9c8f1e53ac46": {
			"id": "01972fff-1078-7100-baf7-9c8f1e53ac46",
			"batchWeighingId": "01972fff-1077-7065-b662-6eafb71f91d4",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b5c-b9c3-a8646cef2411",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7e4a-873c-3f8b1a303745": {
			"id": "01972fff-1078-7e4a-873c-3f8b1a303745",
			"batchWeighingId": "01972fff-1077-7065-b662-6eafb71f91d4",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bf7-9a2d-255c32e6bab6",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7340-b26e-7056b27965fd": {
			"id": "01972fff-1078-7340-b26e-7056b27965fd",
			"batchWeighingId": "01972fff-1077-7065-b662-6eafb71f91d4",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-77e5-8abc-31b7064e18f9",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7044-be56-74cd23718012": {
			"id": "01972fff-1078-7044-be56-74cd23718012",
			"batchWeighingId": "01972fff-1077-7065-b662-6eafb71f91d4",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-79c5-85e8-41ce5450a00e",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7095-a163-ff04eff6d963": {
			"id": "01972fff-1078-7095-a163-ff04eff6d963",
			"batchWeighingId": "01972fff-1077-7065-b662-6eafb71f91d4",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7254-9a40-bce0b6095f36",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-70a6-a353-d19a3bf387cc": {
			"id": "01972fff-1078-70a6-a353-d19a3bf387cc",
			"batchWeighingId": "01972fff-1077-7065-b662-6eafb71f91d4",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7de7-b6c1-f86afe274a36",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7659-93f6-93ea4e6e2d24": {
			"id": "01972fff-1078-7659-93f6-93ea4e6e2d24",
			"batchWeighingId": "01972fff-1077-7065-b662-6eafb71f91d4",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e91-85c6-54515cbe68e8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7142-8fce-04c9aa62da22": {
			"id": "01972fff-1078-7142-8fce-04c9aa62da22",
			"batchWeighingId": "01972fff-1077-7065-b662-6eafb71f91d4",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7eac-bd4c-8e83837951e7",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7b28-8f9c-00fe872c442f": {
			"id": "01972fff-1078-7b28-8f9c-00fe872c442f",
			"batchWeighingId": "01972fff-1077-7065-b662-6eafb71f91d4",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f7f-be3e-d0da05b69a77",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7903-8f0a-33c70a41d984": {
			"id": "01972fff-1078-7903-8f0a-33c70a41d984",
			"batchWeighingId": "01972fff-1077-7065-b662-6eafb71f91d4",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-76b4-be3e-26e9330abc8c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7626-b302-d24c78c25d68": {
			"id": "01972fff-1078-7626-b302-d24c78c25d68",
			"batchWeighingId": "01972fff-1077-7dc5-a171-848b262f8cf9",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d52-8551-bea41c2d42b7",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7725-9526-7c303ab224cc": {
			"id": "01972fff-1078-7725-9526-7c303ab224cc",
			"batchWeighingId": "01972fff-1077-7dc5-a171-848b262f8cf9",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-706f-9aff-3adda18d98cc",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7ae9-b992-084d1b467083": {
			"id": "01972fff-1078-7ae9-b992-084d1b467083",
			"batchWeighingId": "01972fff-1077-7dc5-a171-848b262f8cf9",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-77b4-94ec-f73a7ffeb862",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-77d9-a5b0-e62c8179b416": {
			"id": "01972fff-1078-77d9-a5b0-e62c8179b416",
			"batchWeighingId": "01972fff-1077-7dc5-a171-848b262f8cf9",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d7d-9eca-281a03d35c29",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7536-a4b5-331768f1a249": {
			"id": "01972fff-1078-7536-a4b5-331768f1a249",
			"batchWeighingId": "01972fff-1077-7dc5-a171-848b262f8cf9",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7183-94ca-d5898205c039",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7791-879f-4115336db563": {
			"id": "01972fff-1078-7791-879f-4115336db563",
			"batchWeighingId": "01972fff-1077-7dc5-a171-848b262f8cf9",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-705b-ad87-dfc04abf7f79",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-735c-8eef-41f80a365b17": {
			"id": "01972fff-1078-735c-8eef-41f80a365b17",
			"batchWeighingId": "01972fff-1077-7dc5-a171-848b262f8cf9",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-700c-a74d-921798039d33",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7c19-8eae-a724495d8ce4": {
			"id": "01972fff-1078-7c19-8eae-a724495d8ce4",
			"batchWeighingId": "01972fff-1077-7dc5-a171-848b262f8cf9",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-743a-807e-8525fbe3ddf6",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-72d9-833a-7d8472f7ecf3": {
			"id": "01972fff-1078-72d9-833a-7d8472f7ecf3",
			"batchWeighingId": "01972fff-1077-7dc5-a171-848b262f8cf9",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c55-ac86-4f1b8ea1eddd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-761a-8cf8-c179ac0c14b4": {
			"id": "01972fff-1078-761a-8cf8-c179ac0c14b4",
			"batchWeighingId": "01972fff-1077-7dc5-a171-848b262f8cf9",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-705c-a42a-57982cfdaf67",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7b3e-993f-644f1d95e140": {
			"id": "01972fff-1078-7b3e-993f-644f1d95e140",
			"batchWeighingId": "01972fff-1077-7dc5-a171-848b262f8cf9",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-760e-a723-6e0f16df5266",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7249-a7ba-7a6c4a77d849": {
			"id": "01972fff-1078-7249-a7ba-7a6c4a77d849",
			"batchWeighingId": "01972fff-1077-7dc5-a171-848b262f8cf9",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7070-a724-9868e4e676ac",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-748b-bfdd-446d16ff39f9": {
			"id": "01972fff-1078-748b-bfdd-446d16ff39f9",
			"batchWeighingId": "01972fff-1077-7dc5-a171-848b262f8cf9",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7397-a4ac-2d286c030acb",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7e33-b62e-674e2fc37fdb": {
			"id": "01972fff-1078-7e33-b62e-674e2fc37fdb",
			"batchWeighingId": "01972fff-1077-7dc5-a171-848b262f8cf9",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-791f-a265-9cdd4121d220",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7f92-94bc-97c687c97562": {
			"id": "01972fff-1078-7f92-94bc-97c687c97562",
			"batchWeighingId": "01972fff-1077-7dc5-a171-848b262f8cf9",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ba2-84f7-ab4adbfeaf6b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7b3e-b6a9-a74abb2cb2d1": {
			"id": "01972fff-1078-7b3e-b6a9-a74abb2cb2d1",
			"batchWeighingId": "01972fff-1077-7dc5-a171-848b262f8cf9",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7543-9639-80c738150ab9",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7234-bf07-9b23ff5ce6f0": {
			"id": "01972fff-1078-7234-bf07-9b23ff5ce6f0",
			"batchWeighingId": "01972fff-1077-7dc5-a171-848b262f8cf9",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-758f-8ad0-025a138f650a",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-72f9-a807-6f340904da45": {
			"id": "01972fff-1078-72f9-a807-6f340904da45",
			"batchWeighingId": "01972fff-1077-7dc5-a171-848b262f8cf9",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-753e-b982-ef834631ddce",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7d16-8ce0-8e0977266c17": {
			"id": "01972fff-1078-7d16-8ce0-8e0977266c17",
			"batchWeighingId": "01972fff-1077-73e9-97b0-ff34ca31a16a",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d52-8551-bea41c2d42b7",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7fd4-80fb-06b330dc24ef": {
			"id": "01972fff-1078-7fd4-80fb-06b330dc24ef",
			"batchWeighingId": "01972fff-1077-73e9-97b0-ff34ca31a16a",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-706f-9aff-3adda18d98cc",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-76cf-8531-4add2df3530a": {
			"id": "01972fff-1078-76cf-8531-4add2df3530a",
			"batchWeighingId": "01972fff-1077-73e9-97b0-ff34ca31a16a",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-77b4-94ec-f73a7ffeb862",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7f6c-af9d-0afc19f5805b": {
			"id": "01972fff-1078-7f6c-af9d-0afc19f5805b",
			"batchWeighingId": "01972fff-1077-73e9-97b0-ff34ca31a16a",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d7d-9eca-281a03d35c29",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-76d2-aaf5-6c5432c2216d": {
			"id": "01972fff-1078-76d2-aaf5-6c5432c2216d",
			"batchWeighingId": "01972fff-1077-73e9-97b0-ff34ca31a16a",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7183-94ca-d5898205c039",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7e4f-b3be-33d0e37fdc72": {
			"id": "01972fff-1078-7e4f-b3be-33d0e37fdc72",
			"batchWeighingId": "01972fff-1077-73e9-97b0-ff34ca31a16a",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-705b-ad87-dfc04abf7f79",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-784c-95a9-218ea2949bf7": {
			"id": "01972fff-1078-784c-95a9-218ea2949bf7",
			"batchWeighingId": "01972fff-1077-73e9-97b0-ff34ca31a16a",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-700c-a74d-921798039d33",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7299-b157-3e3ebf9ccc59": {
			"id": "01972fff-1078-7299-b157-3e3ebf9ccc59",
			"batchWeighingId": "01972fff-1077-73e9-97b0-ff34ca31a16a",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-743a-807e-8525fbe3ddf6",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-77b2-b783-b2002fc3703b": {
			"id": "01972fff-1078-77b2-b783-b2002fc3703b",
			"batchWeighingId": "01972fff-1077-73e9-97b0-ff34ca31a16a",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c55-ac86-4f1b8ea1eddd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7b64-a811-6cac0a0158cb": {
			"id": "01972fff-1078-7b64-a811-6cac0a0158cb",
			"batchWeighingId": "01972fff-1077-73e9-97b0-ff34ca31a16a",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-705c-a42a-57982cfdaf67",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7c2f-bda0-1daeb471bc52": {
			"id": "01972fff-1078-7c2f-bda0-1daeb471bc52",
			"batchWeighingId": "01972fff-1077-73e9-97b0-ff34ca31a16a",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-760e-a723-6e0f16df5266",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7494-8f0d-59e2ffb04049": {
			"id": "01972fff-1078-7494-8f0d-59e2ffb04049",
			"batchWeighingId": "01972fff-1077-73e9-97b0-ff34ca31a16a",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7070-a724-9868e4e676ac",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-70a6-bcde-70f6500d5d38": {
			"id": "01972fff-1078-70a6-bcde-70f6500d5d38",
			"batchWeighingId": "01972fff-1077-73e9-97b0-ff34ca31a16a",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7397-a4ac-2d286c030acb",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7eaa-869f-da551734d660": {
			"id": "01972fff-1078-7eaa-869f-da551734d660",
			"batchWeighingId": "01972fff-1077-73e9-97b0-ff34ca31a16a",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-791f-a265-9cdd4121d220",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7140-bfb2-69c72a82e8cb": {
			"id": "01972fff-1078-7140-bfb2-69c72a82e8cb",
			"batchWeighingId": "01972fff-1077-73e9-97b0-ff34ca31a16a",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ba2-84f7-ab4adbfeaf6b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7699-9522-70c0a7c403f9": {
			"id": "01972fff-1078-7699-9522-70c0a7c403f9",
			"batchWeighingId": "01972fff-1077-73e9-97b0-ff34ca31a16a",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7543-9639-80c738150ab9",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7856-9a41-64fc0ffb0fa9": {
			"id": "01972fff-1078-7856-9a41-64fc0ffb0fa9",
			"batchWeighingId": "01972fff-1077-73e9-97b0-ff34ca31a16a",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-758f-8ad0-025a138f650a",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-752c-b100-cf2961bc3bc5": {
			"id": "01972fff-1078-752c-b100-cf2961bc3bc5",
			"batchWeighingId": "01972fff-1077-73e9-97b0-ff34ca31a16a",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-753e-b982-ef834631ddce",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7849-bfce-a879e1415219": {
			"id": "01972fff-1078-7849-bfce-a879e1415219",
			"batchWeighingId": "01972fff-1077-72db-a407-a74499a5f97d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7588-8948-d019938cabcf",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-75b8-8202-f2047fae6f98": {
			"id": "01972fff-1078-75b8-8202-f2047fae6f98",
			"batchWeighingId": "01972fff-1077-72db-a407-a74499a5f97d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7793-be98-5b3a0f57f68c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-724e-a164-2c5a5c331c59": {
			"id": "01972fff-1078-724e-a164-2c5a5c331c59",
			"batchWeighingId": "01972fff-1077-72db-a407-a74499a5f97d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7fd5-87a6-05a93ab71b2f",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-704f-8e33-7e0a8008d265": {
			"id": "01972fff-1078-704f-8e33-7e0a8008d265",
			"batchWeighingId": "01972fff-1077-72db-a407-a74499a5f97d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7aaa-99a1-c17c58bbf637",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7d88-af82-58e67926a97d": {
			"id": "01972fff-1078-7d88-af82-58e67926a97d",
			"batchWeighingId": "01972fff-1077-72db-a407-a74499a5f97d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-756e-a1fc-12f249a87226",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7cfd-a964-0093b1b3f95e": {
			"id": "01972fff-1078-7cfd-a964-0093b1b3f95e",
			"batchWeighingId": "01972fff-1077-72db-a407-a74499a5f97d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-74ee-8acd-2950986e209b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-77e7-a100-e98aa1d19ef6": {
			"id": "01972fff-1078-77e7-a100-e98aa1d19ef6",
			"batchWeighingId": "01972fff-1077-72db-a407-a74499a5f97d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-759a-b3bf-d087463fcac5",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-79f8-a294-80b025ba3b0e": {
			"id": "01972fff-1078-79f8-a294-80b025ba3b0e",
			"batchWeighingId": "01972fff-1077-72db-a407-a74499a5f97d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72f7-9fd9-51851a3f6e0e",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-74d9-94c0-12909050ab78": {
			"id": "01972fff-1078-74d9-94c0-12909050ab78",
			"batchWeighingId": "01972fff-1077-72db-a407-a74499a5f97d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-73af-b25b-4244838049fd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-73c5-b343-edf015e2b424": {
			"id": "01972fff-1078-73c5-b343-edf015e2b424",
			"batchWeighingId": "01972fff-1077-72db-a407-a74499a5f97d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f8d-a674-968ede5f4929",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-783a-8231-7cb6cf808c3f": {
			"id": "01972fff-1078-783a-8231-7cb6cf808c3f",
			"batchWeighingId": "01972fff-1077-72db-a407-a74499a5f97d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ebd-ba0d-78821fa95a34",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7711-8e48-2753780b1414": {
			"id": "01972fff-1078-7711-8e48-2753780b1414",
			"batchWeighingId": "01972fff-1077-72db-a407-a74499a5f97d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-715e-ada5-30bf34cd667d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7292-b585-bcf2f6f5e325": {
			"id": "01972fff-1078-7292-b585-bcf2f6f5e325",
			"batchWeighingId": "01972fff-1077-72db-a407-a74499a5f97d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-78b6-888f-d279b7ab60bd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7265-8618-814d0b581ca4": {
			"id": "01972fff-1078-7265-8618-814d0b581ca4",
			"batchWeighingId": "01972fff-1077-72db-a407-a74499a5f97d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-735a-b9e6-ec3de3e1594a",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7067-bb20-c78b6db25bb0": {
			"id": "01972fff-1078-7067-bb20-c78b6db25bb0",
			"batchWeighingId": "01972fff-1077-72db-a407-a74499a5f97d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e69-975a-290d0743efef",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7fc7-af22-8a68ea920ef3": {
			"id": "01972fff-1078-7fc7-af22-8a68ea920ef3",
			"batchWeighingId": "01972fff-1077-72db-a407-a74499a5f97d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-786d-8513-0664c3ccad98",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7178-a194-1a3946ec40bc": {
			"id": "01972fff-1078-7178-a194-1a3946ec40bc",
			"batchWeighingId": "01972fff-1077-72db-a407-a74499a5f97d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7db6-ac89-92b6bcde462b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-71f0-8b95-56701a73e2d6": {
			"id": "01972fff-1078-71f0-8b95-56701a73e2d6",
			"batchWeighingId": "01972fff-1077-72db-a407-a74499a5f97d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7cd8-b9b2-b52c2dd90d20",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-747c-9397-df8ec4106a7e": {
			"id": "01972fff-1078-747c-9397-df8ec4106a7e",
			"batchWeighingId": "01972fff-1077-7edd-9fdc-0d80938fa558",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7588-8948-d019938cabcf",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7fc6-8315-0d71fb60a38f": {
			"id": "01972fff-1078-7fc6-8315-0d71fb60a38f",
			"batchWeighingId": "01972fff-1077-7edd-9fdc-0d80938fa558",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7793-be98-5b3a0f57f68c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-797e-a286-74260d0c9bcd": {
			"id": "01972fff-1078-797e-a286-74260d0c9bcd",
			"batchWeighingId": "01972fff-1077-7edd-9fdc-0d80938fa558",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7fd5-87a6-05a93ab71b2f",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7896-9ccf-fb611e214913": {
			"id": "01972fff-1078-7896-9ccf-fb611e214913",
			"batchWeighingId": "01972fff-1077-7edd-9fdc-0d80938fa558",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7aaa-99a1-c17c58bbf637",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7f71-b645-5cd15a1e6835": {
			"id": "01972fff-1078-7f71-b645-5cd15a1e6835",
			"batchWeighingId": "01972fff-1077-7edd-9fdc-0d80938fa558",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-756e-a1fc-12f249a87226",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-71db-8cca-215f39a199a0": {
			"id": "01972fff-1078-71db-8cca-215f39a199a0",
			"batchWeighingId": "01972fff-1077-7edd-9fdc-0d80938fa558",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-74ee-8acd-2950986e209b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7dd0-bd97-aacb59161358": {
			"id": "01972fff-1078-7dd0-bd97-aacb59161358",
			"batchWeighingId": "01972fff-1077-7edd-9fdc-0d80938fa558",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-759a-b3bf-d087463fcac5",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7af9-809c-b12f627da173": {
			"id": "01972fff-1078-7af9-809c-b12f627da173",
			"batchWeighingId": "01972fff-1077-7edd-9fdc-0d80938fa558",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72f7-9fd9-51851a3f6e0e",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-72c0-b5fd-c165a5062d03": {
			"id": "01972fff-1078-72c0-b5fd-c165a5062d03",
			"batchWeighingId": "01972fff-1077-7edd-9fdc-0d80938fa558",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-73af-b25b-4244838049fd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-786d-836f-4a5af214a5a9": {
			"id": "01972fff-1078-786d-836f-4a5af214a5a9",
			"batchWeighingId": "01972fff-1077-7edd-9fdc-0d80938fa558",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f8d-a674-968ede5f4929",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-77ff-8fce-fea62e9e7aac": {
			"id": "01972fff-1078-77ff-8fce-fea62e9e7aac",
			"batchWeighingId": "01972fff-1077-7edd-9fdc-0d80938fa558",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ebd-ba0d-78821fa95a34",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-788f-8db9-88f4f5a8c272": {
			"id": "01972fff-1078-788f-8db9-88f4f5a8c272",
			"batchWeighingId": "01972fff-1077-7edd-9fdc-0d80938fa558",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-715e-ada5-30bf34cd667d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-76d9-9f0a-e7ef8aa1347d": {
			"id": "01972fff-1078-76d9-9f0a-e7ef8aa1347d",
			"batchWeighingId": "01972fff-1077-7edd-9fdc-0d80938fa558",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-78b6-888f-d279b7ab60bd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-74e8-9e0f-5db43dbd591c": {
			"id": "01972fff-1078-74e8-9e0f-5db43dbd591c",
			"batchWeighingId": "01972fff-1077-7edd-9fdc-0d80938fa558",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-735a-b9e6-ec3de3e1594a",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-78cf-ad72-ced434f8b084": {
			"id": "01972fff-1078-78cf-ad72-ced434f8b084",
			"batchWeighingId": "01972fff-1077-7edd-9fdc-0d80938fa558",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e69-975a-290d0743efef",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7513-ad37-cb109420e346": {
			"id": "01972fff-1078-7513-ad37-cb109420e346",
			"batchWeighingId": "01972fff-1077-7edd-9fdc-0d80938fa558",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-786d-8513-0664c3ccad98",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7af0-bf1e-54c1e6af3af6": {
			"id": "01972fff-1078-7af0-bf1e-54c1e6af3af6",
			"batchWeighingId": "01972fff-1077-7edd-9fdc-0d80938fa558",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7db6-ac89-92b6bcde462b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-72e9-a6fc-9759a56e68b4": {
			"id": "01972fff-1078-72e9-a6fc-9759a56e68b4",
			"batchWeighingId": "01972fff-1077-7edd-9fdc-0d80938fa558",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7cd8-b9b2-b52c2dd90d20",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7e36-ba5e-0a0afda70b00": {
			"id": "01972fff-1078-7e36-ba5e-0a0afda70b00",
			"batchWeighingId": "01972fff-1077-754d-835e-69608aff28d8",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72d3-8b30-e0ab83e8d37d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7a72-b298-5ee7f075f1f2": {
			"id": "01972fff-1078-7a72-b298-5ee7f075f1f2",
			"batchWeighingId": "01972fff-1077-754d-835e-69608aff28d8",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ac9-b2dd-13c1750b4fac",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-70d7-820e-ec3a3bf87886": {
			"id": "01972fff-1078-70d7-820e-ec3a3bf87886",
			"batchWeighingId": "01972fff-1077-754d-835e-69608aff28d8",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7220-8bd9-19935e9b4527",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7bf1-acdf-3ab6e05cbce8": {
			"id": "01972fff-1078-7bf1-acdf-3ab6e05cbce8",
			"batchWeighingId": "01972fff-1077-754d-835e-69608aff28d8",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7251-ad3c-0cf9dfddd06c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-72fe-9c3f-e0a0cdfca862": {
			"id": "01972fff-1078-72fe-9c3f-e0a0cdfca862",
			"batchWeighingId": "01972fff-1077-754d-835e-69608aff28d8",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-756f-b159-cc0612f285c8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-79df-ab1d-f61b2cdd0115": {
			"id": "01972fff-1078-79df-ab1d-f61b2cdd0115",
			"batchWeighingId": "01972fff-1077-754d-835e-69608aff28d8",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72fa-bf32-652bf5bf8d5b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7fc7-bfae-959176e8638b": {
			"id": "01972fff-1078-7fc7-bfae-959176e8638b",
			"batchWeighingId": "01972fff-1077-754d-835e-69608aff28d8",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-736b-850a-0f073660b996",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7284-8edc-eaa54f65d544": {
			"id": "01972fff-1078-7284-8edc-eaa54f65d544",
			"batchWeighingId": "01972fff-1077-754d-835e-69608aff28d8",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-769c-977d-a08eba7e9622",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7c3e-bc99-34e28e3edbc5": {
			"id": "01972fff-1078-7c3e-bc99-34e28e3edbc5",
			"batchWeighingId": "01972fff-1077-754d-835e-69608aff28d8",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7834-b8ae-bbf502ec6115",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7a80-aaba-35dbc7c1f0e5": {
			"id": "01972fff-1078-7a80-aaba-35dbc7c1f0e5",
			"batchWeighingId": "01972fff-1077-754d-835e-69608aff28d8",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-725a-9159-dcc67d810756",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7bb3-b6c6-3f16126a8a07": {
			"id": "01972fff-1078-7bb3-b6c6-3f16126a8a07",
			"batchWeighingId": "01972fff-1077-754d-835e-69608aff28d8",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ca3-9f3b-9c24d52fcf77",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7b75-b414-deff1e8f8aa4": {
			"id": "01972fff-1078-7b75-b414-deff1e8f8aa4",
			"batchWeighingId": "01972fff-1077-754d-835e-69608aff28d8",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7baa-9842-af256f4506e0",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7b23-a898-f067b74b8409": {
			"id": "01972fff-1078-7b23-a898-f067b74b8409",
			"batchWeighingId": "01972fff-1077-754d-835e-69608aff28d8",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-741f-83bf-c4acd2f30d37",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-72e2-93f7-c62d3cd709f6": {
			"id": "01972fff-1078-72e2-93f7-c62d3cd709f6",
			"batchWeighingId": "01972fff-1077-754d-835e-69608aff28d8",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-704e-bfa5-366faf7530bd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7556-a769-34da99c72146": {
			"id": "01972fff-1078-7556-a769-34da99c72146",
			"batchWeighingId": "01972fff-1077-754d-835e-69608aff28d8",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7293-be3c-09d702091eda",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7117-aef2-8baa46bb2778": {
			"id": "01972fff-1078-7117-aef2-8baa46bb2778",
			"batchWeighingId": "01972fff-1077-754d-835e-69608aff28d8",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b4b-8037-8939efa37fc3",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7141-8ea4-ecf5d5b6dad0": {
			"id": "01972fff-1078-7141-8ea4-ecf5d5b6dad0",
			"batchWeighingId": "01972fff-1077-754d-835e-69608aff28d8",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7542-b533-b57facd55fc7",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7516-9e51-435c5440ff1d": {
			"id": "01972fff-1078-7516-9e51-435c5440ff1d",
			"batchWeighingId": "01972fff-1077-754d-835e-69608aff28d8",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7fbc-af18-3cdac7a0cc1d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-76c0-acac-d6b050e86859": {
			"id": "01972fff-1078-76c0-acac-d6b050e86859",
			"batchWeighingId": "01972fff-1077-7ffe-b44b-59de119b640e",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72d3-8b30-e0ab83e8d37d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7dbc-b59f-69137cecb237": {
			"id": "01972fff-1078-7dbc-b59f-69137cecb237",
			"batchWeighingId": "01972fff-1077-7ffe-b44b-59de119b640e",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ac9-b2dd-13c1750b4fac",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-70c6-a95a-10acb1b49cf6": {
			"id": "01972fff-1078-70c6-a95a-10acb1b49cf6",
			"batchWeighingId": "01972fff-1077-7ffe-b44b-59de119b640e",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7220-8bd9-19935e9b4527",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7c0a-9c9b-5c71f0d0ec49": {
			"id": "01972fff-1078-7c0a-9c9b-5c71f0d0ec49",
			"batchWeighingId": "01972fff-1077-7ffe-b44b-59de119b640e",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7251-ad3c-0cf9dfddd06c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7989-b42d-6018b4728bef": {
			"id": "01972fff-1078-7989-b42d-6018b4728bef",
			"batchWeighingId": "01972fff-1077-7ffe-b44b-59de119b640e",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-756f-b159-cc0612f285c8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7fb1-9567-423d59daf2e8": {
			"id": "01972fff-1078-7fb1-9567-423d59daf2e8",
			"batchWeighingId": "01972fff-1077-7ffe-b44b-59de119b640e",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72fa-bf32-652bf5bf8d5b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7d11-8e86-77f896d47931": {
			"id": "01972fff-1078-7d11-8e86-77f896d47931",
			"batchWeighingId": "01972fff-1077-7ffe-b44b-59de119b640e",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-736b-850a-0f073660b996",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7b0a-92f7-18aa551b5373": {
			"id": "01972fff-1078-7b0a-92f7-18aa551b5373",
			"batchWeighingId": "01972fff-1077-7ffe-b44b-59de119b640e",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-769c-977d-a08eba7e9622",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-784b-b12e-b502c867c02a": {
			"id": "01972fff-1078-784b-b12e-b502c867c02a",
			"batchWeighingId": "01972fff-1077-7ffe-b44b-59de119b640e",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7834-b8ae-bbf502ec6115",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7630-9444-8cc5dfec665b": {
			"id": "01972fff-1078-7630-9444-8cc5dfec665b",
			"batchWeighingId": "01972fff-1077-7ffe-b44b-59de119b640e",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-725a-9159-dcc67d810756",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7915-9ffe-6080d4f16710": {
			"id": "01972fff-1078-7915-9ffe-6080d4f16710",
			"batchWeighingId": "01972fff-1077-7ffe-b44b-59de119b640e",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ca3-9f3b-9c24d52fcf77",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-79fb-866f-a6cfe39aa705": {
			"id": "01972fff-1078-79fb-866f-a6cfe39aa705",
			"batchWeighingId": "01972fff-1077-7ffe-b44b-59de119b640e",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7baa-9842-af256f4506e0",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7fc5-bc34-42362f880179": {
			"id": "01972fff-1078-7fc5-bc34-42362f880179",
			"batchWeighingId": "01972fff-1077-7ffe-b44b-59de119b640e",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-741f-83bf-c4acd2f30d37",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7719-b0c9-829d63536487": {
			"id": "01972fff-1078-7719-b0c9-829d63536487",
			"batchWeighingId": "01972fff-1077-7ffe-b44b-59de119b640e",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-704e-bfa5-366faf7530bd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7494-86f9-f209a2cd5c8c": {
			"id": "01972fff-1078-7494-86f9-f209a2cd5c8c",
			"batchWeighingId": "01972fff-1077-7ffe-b44b-59de119b640e",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7293-be3c-09d702091eda",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7044-aebf-a78486e266a8": {
			"id": "01972fff-1078-7044-aebf-a78486e266a8",
			"batchWeighingId": "01972fff-1077-7ffe-b44b-59de119b640e",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b4b-8037-8939efa37fc3",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7d8d-b0fe-bbc853325fee": {
			"id": "01972fff-1078-7d8d-b0fe-bbc853325fee",
			"batchWeighingId": "01972fff-1077-7ffe-b44b-59de119b640e",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7542-b533-b57facd55fc7",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7b6a-8abe-4bdae1953e37": {
			"id": "01972fff-1078-7b6a-8abe-4bdae1953e37",
			"batchWeighingId": "01972fff-1077-7ffe-b44b-59de119b640e",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7fbc-af18-3cdac7a0cc1d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7405-ba01-f3d6e242ac51": {
			"id": "01972fff-1078-7405-ba01-f3d6e242ac51",
			"batchWeighingId": "01972fff-1077-77fd-bf38-144220df80a7",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-791f-8133-0da1c1775cc1",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-784c-b4e6-1630f93c28a4": {
			"id": "01972fff-1078-784c-b4e6-1630f93c28a4",
			"batchWeighingId": "01972fff-1077-77fd-bf38-144220df80a7",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-785f-a996-3528e8721a65",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7260-8e5e-6bf6bfb55e1d": {
			"id": "01972fff-1078-7260-8e5e-6bf6bfb55e1d",
			"batchWeighingId": "01972fff-1077-77fd-bf38-144220df80a7",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-76fa-b086-05bdfdf5ceac",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7270-b459-d824df887955": {
			"id": "01972fff-1078-7270-b459-d824df887955",
			"batchWeighingId": "01972fff-1077-77fd-bf38-144220df80a7",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-759d-aee4-7ef4826f8848",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-790d-9efe-3f5afa0ee81d": {
			"id": "01972fff-1078-790d-9efe-3f5afa0ee81d",
			"batchWeighingId": "01972fff-1077-77fd-bf38-144220df80a7",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-747b-8adb-bd455ba79531",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7eaa-b81a-53046a08f359": {
			"id": "01972fff-1078-7eaa-b81a-53046a08f359",
			"batchWeighingId": "01972fff-1077-77fd-bf38-144220df80a7",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d0e-ae8e-266abac6fb6c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7073-9bb9-aca5e8e5af64": {
			"id": "01972fff-1078-7073-9bb9-aca5e8e5af64",
			"batchWeighingId": "01972fff-1077-77fd-bf38-144220df80a7",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7183-9ac0-fde99a456d9e",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7cce-8d5f-535a559161f2": {
			"id": "01972fff-1078-7cce-8d5f-535a559161f2",
			"batchWeighingId": "01972fff-1077-77fd-bf38-144220df80a7",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bf4-bbb1-08943a23cb9d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7cf2-aedb-6e3ece7dee1b": {
			"id": "01972fff-1078-7cf2-aedb-6e3ece7dee1b",
			"batchWeighingId": "01972fff-1077-77fd-bf38-144220df80a7",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7791-8b3f-d4206701ca8a",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-70f1-b8bc-0d872a5ff7ba": {
			"id": "01972fff-1078-70f1-b8bc-0d872a5ff7ba",
			"batchWeighingId": "01972fff-1077-77fd-bf38-144220df80a7",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e92-8c88-0ca0d3695405",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7fba-a9d0-b16d8aa24fe6": {
			"id": "01972fff-1078-7fba-a9d0-b16d8aa24fe6",
			"batchWeighingId": "01972fff-1077-77fd-bf38-144220df80a7",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b00-b171-5d7dca8bad24",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-705f-96d2-36d67b270483": {
			"id": "01972fff-1078-705f-96d2-36d67b270483",
			"batchWeighingId": "01972fff-1077-77fd-bf38-144220df80a7",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7cb5-9b6b-584a83e4fa96",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-76b9-9878-bc9d5e9f9e7d": {
			"id": "01972fff-1078-76b9-9878-bc9d5e9f9e7d",
			"batchWeighingId": "01972fff-1077-70f1-a7fa-63dfeb0cb1c2",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-791f-8133-0da1c1775cc1",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7e6d-bccd-55ab44436b61": {
			"id": "01972fff-1078-7e6d-bccd-55ab44436b61",
			"batchWeighingId": "01972fff-1077-70f1-a7fa-63dfeb0cb1c2",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-785f-a996-3528e8721a65",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7531-ac4d-56a9837c903b": {
			"id": "01972fff-1078-7531-ac4d-56a9837c903b",
			"batchWeighingId": "01972fff-1077-70f1-a7fa-63dfeb0cb1c2",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-76fa-b086-05bdfdf5ceac",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7adf-b33a-70b0ba82b3de": {
			"id": "01972fff-1078-7adf-b33a-70b0ba82b3de",
			"batchWeighingId": "01972fff-1077-70f1-a7fa-63dfeb0cb1c2",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-759d-aee4-7ef4826f8848",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7108-84dc-e527d3d9035b": {
			"id": "01972fff-1078-7108-84dc-e527d3d9035b",
			"batchWeighingId": "01972fff-1077-70f1-a7fa-63dfeb0cb1c2",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-747b-8adb-bd455ba79531",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-71c1-a6dd-0ad076290f4e": {
			"id": "01972fff-1078-71c1-a6dd-0ad076290f4e",
			"batchWeighingId": "01972fff-1077-70f1-a7fa-63dfeb0cb1c2",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d0e-ae8e-266abac6fb6c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7bd0-bf5f-57e28b574046": {
			"id": "01972fff-1078-7bd0-bf5f-57e28b574046",
			"batchWeighingId": "01972fff-1077-70f1-a7fa-63dfeb0cb1c2",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7183-9ac0-fde99a456d9e",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-74de-a989-227b01dbd1bd": {
			"id": "01972fff-1079-74de-a989-227b01dbd1bd",
			"batchWeighingId": "01972fff-1077-70f1-a7fa-63dfeb0cb1c2",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bf4-bbb1-08943a23cb9d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-783d-9692-51d9c2ae37e9": {
			"id": "01972fff-1079-783d-9692-51d9c2ae37e9",
			"batchWeighingId": "01972fff-1077-70f1-a7fa-63dfeb0cb1c2",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7791-8b3f-d4206701ca8a",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7ca0-9098-406d8c84e794": {
			"id": "01972fff-1079-7ca0-9098-406d8c84e794",
			"batchWeighingId": "01972fff-1077-70f1-a7fa-63dfeb0cb1c2",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e92-8c88-0ca0d3695405",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-72fc-95e6-ea14d87a19cf": {
			"id": "01972fff-1079-72fc-95e6-ea14d87a19cf",
			"batchWeighingId": "01972fff-1077-70f1-a7fa-63dfeb0cb1c2",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b00-b171-5d7dca8bad24",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-757c-ab70-53a90dbb2139": {
			"id": "01972fff-1079-757c-ab70-53a90dbb2139",
			"batchWeighingId": "01972fff-1077-70f1-a7fa-63dfeb0cb1c2",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7cb5-9b6b-584a83e4fa96",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-70a9-8abf-cc6d4d06c00a": {
			"id": "01972fff-1078-70a9-8abf-cc6d4d06c00a",
			"batchWeighingId": "01972fff-1077-7f3a-bd5e-60d82c64add4",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c5a-8407-dfd45f9b13be",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-747e-9650-08e6e8723a89": {
			"id": "01972fff-1078-747e-9650-08e6e8723a89",
			"batchWeighingId": "01972fff-1077-7f3a-bd5e-60d82c64add4",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-70da-8dbd-231ca75278c2",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7d6b-9fec-a73ab9948800": {
			"id": "01972fff-1078-7d6b-9fec-a73ab9948800",
			"batchWeighingId": "01972fff-1077-7f3a-bd5e-60d82c64add4",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7440-a0ba-9c08606f2a20",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7032-9629-730ef397d91b": {
			"id": "01972fff-1078-7032-9629-730ef397d91b",
			"batchWeighingId": "01972fff-1077-7f3a-bd5e-60d82c64add4",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b91-9a5e-901bc6790db4",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-77c0-a9a0-481a16675184": {
			"id": "01972fff-1078-77c0-a9a0-481a16675184",
			"batchWeighingId": "01972fff-1077-7f3a-bd5e-60d82c64add4",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d17-976e-1c4a59fe50cf",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-781b-8fde-3e7e09e4ec16": {
			"id": "01972fff-1078-781b-8fde-3e7e09e4ec16",
			"batchWeighingId": "01972fff-1077-7f3a-bd5e-60d82c64add4",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e57-ae47-50e29926c1da",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7017-b81d-b8ffacd0c2b4": {
			"id": "01972fff-1078-7017-b81d-b8ffacd0c2b4",
			"batchWeighingId": "01972fff-1077-7f3a-bd5e-60d82c64add4",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7af3-8559-3a60c752184c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-764b-b301-f651f634eaf5": {
			"id": "01972fff-1078-764b-b301-f651f634eaf5",
			"batchWeighingId": "01972fff-1077-7f3a-bd5e-60d82c64add4",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f40-82c8-df11c4507261",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-73d7-900a-a70bf6686de0": {
			"id": "01972fff-1078-73d7-900a-a70bf6686de0",
			"batchWeighingId": "01972fff-1077-7f3a-bd5e-60d82c64add4",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bbe-92ae-b7a8cb3f4256",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7c4e-9dd5-cf4b8731cf1e": {
			"id": "01972fff-1078-7c4e-9dd5-cf4b8731cf1e",
			"batchWeighingId": "01972fff-1077-7f3a-bd5e-60d82c64add4",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-70c9-a367-822ddf7ab517",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7f31-9fa0-29bb4d417f7b": {
			"id": "01972fff-1078-7f31-9fa0-29bb4d417f7b",
			"batchWeighingId": "01972fff-1077-7f3a-bd5e-60d82c64add4",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f84-ae7e-b13efb25ca6c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7522-82f1-06a0e6424f4c": {
			"id": "01972fff-1078-7522-82f1-06a0e6424f4c",
			"batchWeighingId": "01972fff-1077-7f3a-bd5e-60d82c64add4",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-79ed-b1c7-97f006625806",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7de7-ae73-530e160984d4": {
			"id": "01972fff-1079-7de7-ae73-530e160984d4",
			"batchWeighingId": "01972fff-1077-7a5c-b890-595d5e609fd1",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c5a-8407-dfd45f9b13be",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-74d8-9198-c595c32de220": {
			"id": "01972fff-1079-74d8-9198-c595c32de220",
			"batchWeighingId": "01972fff-1077-7a5c-b890-595d5e609fd1",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-70da-8dbd-231ca75278c2",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7138-9282-8bebddb25ea0": {
			"id": "01972fff-1079-7138-9282-8bebddb25ea0",
			"batchWeighingId": "01972fff-1077-7a5c-b890-595d5e609fd1",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7440-a0ba-9c08606f2a20",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7da7-aee4-fa4d27949f13": {
			"id": "01972fff-1079-7da7-aee4-fa4d27949f13",
			"batchWeighingId": "01972fff-1077-7a5c-b890-595d5e609fd1",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b91-9a5e-901bc6790db4",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-75f6-812a-db878cf1fb4a": {
			"id": "01972fff-1079-75f6-812a-db878cf1fb4a",
			"batchWeighingId": "01972fff-1077-7a5c-b890-595d5e609fd1",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d17-976e-1c4a59fe50cf",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7fe8-a965-f70c9df4e3ef": {
			"id": "01972fff-1079-7fe8-a965-f70c9df4e3ef",
			"batchWeighingId": "01972fff-1077-7a5c-b890-595d5e609fd1",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e57-ae47-50e29926c1da",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7514-8b21-79e1d9f33804": {
			"id": "01972fff-1079-7514-8b21-79e1d9f33804",
			"batchWeighingId": "01972fff-1077-7a5c-b890-595d5e609fd1",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7af3-8559-3a60c752184c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-73aa-9699-c39d247fb16e": {
			"id": "01972fff-1079-73aa-9699-c39d247fb16e",
			"batchWeighingId": "01972fff-1077-7a5c-b890-595d5e609fd1",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f40-82c8-df11c4507261",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-764a-b6cc-22ac52cc0be1": {
			"id": "01972fff-1079-764a-b6cc-22ac52cc0be1",
			"batchWeighingId": "01972fff-1077-7a5c-b890-595d5e609fd1",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bbe-92ae-b7a8cb3f4256",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-76d5-8ff8-777a0efba439": {
			"id": "01972fff-1079-76d5-8ff8-777a0efba439",
			"batchWeighingId": "01972fff-1077-7a5c-b890-595d5e609fd1",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-70c9-a367-822ddf7ab517",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7091-83be-6bdbfacb569e": {
			"id": "01972fff-1079-7091-83be-6bdbfacb569e",
			"batchWeighingId": "01972fff-1077-7a5c-b890-595d5e609fd1",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f84-ae7e-b13efb25ca6c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7edc-9f52-d813a899d754": {
			"id": "01972fff-1079-7edc-9f52-d813a899d754",
			"batchWeighingId": "01972fff-1077-7a5c-b890-595d5e609fd1",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-79ed-b1c7-97f006625806",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7765-a536-be19e5e1941b": {
			"id": "01972fff-1078-7765-a536-be19e5e1941b",
			"batchWeighingId": "01972fff-1077-7cb1-9c04-53847327e261",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-738c-8002-80530c1c9c58",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7714-be19-8195cc940823": {
			"id": "01972fff-1078-7714-be19-8195cc940823",
			"batchWeighingId": "01972fff-1077-7cb1-9c04-53847327e261",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7760-95c3-b5bd6aa3f3d5",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7d22-8bd5-0e2a5809faae": {
			"id": "01972fff-1078-7d22-8bd5-0e2a5809faae",
			"batchWeighingId": "01972fff-1077-7cb1-9c04-53847327e261",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7dae-b37e-ea59d076c941",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7cb0-8caf-1f5c69009ee1": {
			"id": "01972fff-1078-7cb0-8caf-1f5c69009ee1",
			"batchWeighingId": "01972fff-1077-7cb1-9c04-53847327e261",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7975-8e6f-bae9f8a73b89",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7090-b723-83f8f9ca16de": {
			"id": "01972fff-1078-7090-b723-83f8f9ca16de",
			"batchWeighingId": "01972fff-1077-7cb1-9c04-53847327e261",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c74-9543-da36591e073c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7f5a-9ef2-02fc2384e6ef": {
			"id": "01972fff-1078-7f5a-9ef2-02fc2384e6ef",
			"batchWeighingId": "01972fff-1077-7cb1-9c04-53847327e261",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f11-88c2-2496ae669d38",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-741b-8509-6835524bbef3": {
			"id": "01972fff-1078-741b-8509-6835524bbef3",
			"batchWeighingId": "01972fff-1077-7cb1-9c04-53847327e261",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-764a-a8eb-861dc377f79c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7230-8558-db87979b710e": {
			"id": "01972fff-1078-7230-8558-db87979b710e",
			"batchWeighingId": "01972fff-1077-7cb1-9c04-53847327e261",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-73de-87e3-d46cdbe0c1fc",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-74bc-8dff-eba7a2d76ccd": {
			"id": "01972fff-1078-74bc-8dff-eba7a2d76ccd",
			"batchWeighingId": "01972fff-1077-7cb1-9c04-53847327e261",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-719c-936d-d0f6c8cd8310",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7bfe-8c02-dad2f2e553df": {
			"id": "01972fff-1078-7bfe-8c02-dad2f2e553df",
			"batchWeighingId": "01972fff-1077-7cb1-9c04-53847327e261",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7fef-b3f5-90e7bf54b8a8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7db3-837a-0164c8e57c22": {
			"id": "01972fff-1078-7db3-837a-0164c8e57c22",
			"batchWeighingId": "01972fff-1077-7cb1-9c04-53847327e261",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-70e9-a49e-1ebd31ce20ff",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-73df-a974-acdb7c226786": {
			"id": "01972fff-1078-73df-a974-acdb7c226786",
			"batchWeighingId": "01972fff-1077-7cb1-9c04-53847327e261",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7519-a311-5f7ab4f7711e",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7fe3-a0ca-3b949db4a6f1": {
			"id": "01972fff-1079-7fe3-a0ca-3b949db4a6f1",
			"batchWeighingId": "01972fff-1077-786b-81bf-e4a88c430481",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-738c-8002-80530c1c9c58",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7805-b753-07ada462db6b": {
			"id": "01972fff-1079-7805-b753-07ada462db6b",
			"batchWeighingId": "01972fff-1077-786b-81bf-e4a88c430481",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7760-95c3-b5bd6aa3f3d5",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-710c-badb-b32c95cb5dbd": {
			"id": "01972fff-1079-710c-badb-b32c95cb5dbd",
			"batchWeighingId": "01972fff-1077-786b-81bf-e4a88c430481",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7dae-b37e-ea59d076c941",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-75ee-846c-b235e28efd57": {
			"id": "01972fff-1079-75ee-846c-b235e28efd57",
			"batchWeighingId": "01972fff-1077-786b-81bf-e4a88c430481",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7975-8e6f-bae9f8a73b89",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-73fb-9477-b5fce6ca4ac0": {
			"id": "01972fff-1079-73fb-9477-b5fce6ca4ac0",
			"batchWeighingId": "01972fff-1077-786b-81bf-e4a88c430481",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c74-9543-da36591e073c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-73e8-b088-294180ab429a": {
			"id": "01972fff-1079-73e8-b088-294180ab429a",
			"batchWeighingId": "01972fff-1077-786b-81bf-e4a88c430481",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f11-88c2-2496ae669d38",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7699-85be-a4bf69956160": {
			"id": "01972fff-1079-7699-85be-a4bf69956160",
			"batchWeighingId": "01972fff-1077-786b-81bf-e4a88c430481",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-764a-a8eb-861dc377f79c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7c72-82ab-af43331e3870": {
			"id": "01972fff-1079-7c72-82ab-af43331e3870",
			"batchWeighingId": "01972fff-1077-786b-81bf-e4a88c430481",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-73de-87e3-d46cdbe0c1fc",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-739f-a47d-2fdc9b4ca5ee": {
			"id": "01972fff-1079-739f-a47d-2fdc9b4ca5ee",
			"batchWeighingId": "01972fff-1077-786b-81bf-e4a88c430481",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-719c-936d-d0f6c8cd8310",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7be4-a6a9-96f52137084a": {
			"id": "01972fff-1079-7be4-a6a9-96f52137084a",
			"batchWeighingId": "01972fff-1077-786b-81bf-e4a88c430481",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7fef-b3f5-90e7bf54b8a8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7da4-84d3-1341415a6302": {
			"id": "01972fff-1079-7da4-84d3-1341415a6302",
			"batchWeighingId": "01972fff-1077-786b-81bf-e4a88c430481",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-70e9-a49e-1ebd31ce20ff",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7434-808e-5e55e8eff823": {
			"id": "01972fff-1079-7434-808e-5e55e8eff823",
			"batchWeighingId": "01972fff-1077-786b-81bf-e4a88c430481",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7519-a311-5f7ab4f7711e",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-756d-b3a2-3e9d0fd43ce0": {
			"id": "01972fff-1078-756d-b3a2-3e9d0fd43ce0",
			"batchWeighingId": "01972fff-1077-7a41-a08c-6f7f75254a8b",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7eba-9776-82691d10b223",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7144-a7f6-98a1fded4a3c": {
			"id": "01972fff-1078-7144-a7f6-98a1fded4a3c",
			"batchWeighingId": "01972fff-1077-7a41-a08c-6f7f75254a8b",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ab5-b24d-428d7d28ce64",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-798c-b9d3-8607a942b59a": {
			"id": "01972fff-1078-798c-b9d3-8607a942b59a",
			"batchWeighingId": "01972fff-1077-7a41-a08c-6f7f75254a8b",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7417-939c-f98b0727e8e2",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7710-9794-a0663d53a782": {
			"id": "01972fff-1078-7710-9794-a0663d53a782",
			"batchWeighingId": "01972fff-1077-7a41-a08c-6f7f75254a8b",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7312-8ebe-b2c789cd0651",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-714a-9206-4731443c936f": {
			"id": "01972fff-1078-714a-9206-4731443c936f",
			"batchWeighingId": "01972fff-1077-7a41-a08c-6f7f75254a8b",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7a0b-bef2-e3752acd058c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7a00-a6e3-6cc4be3b035d": {
			"id": "01972fff-1078-7a00-a6e3-6cc4be3b035d",
			"batchWeighingId": "01972fff-1077-7a41-a08c-6f7f75254a8b",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-735b-a125-253a52f704a3",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7816-8188-2aa6f73046d9": {
			"id": "01972fff-1078-7816-8188-2aa6f73046d9",
			"batchWeighingId": "01972fff-1077-7a41-a08c-6f7f75254a8b",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b25-990f-8dead42552b1",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7725-bdde-f001fff7a23a": {
			"id": "01972fff-1078-7725-bdde-f001fff7a23a",
			"batchWeighingId": "01972fff-1077-7a41-a08c-6f7f75254a8b",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7506-b926-195a1917c8ee",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7889-991b-446347ef981a": {
			"id": "01972fff-1078-7889-991b-446347ef981a",
			"batchWeighingId": "01972fff-1077-7a41-a08c-6f7f75254a8b",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f48-895d-81d248190670",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-78b0-acd3-9ce4dbcec289": {
			"id": "01972fff-1078-78b0-acd3-9ce4dbcec289",
			"batchWeighingId": "01972fff-1077-7a41-a08c-6f7f75254a8b",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-75f4-b9c1-70879f2393e8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7e90-82d4-4c0081f3bb7e": {
			"id": "01972fff-1078-7e90-82d4-4c0081f3bb7e",
			"batchWeighingId": "01972fff-1077-7a41-a08c-6f7f75254a8b",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7038-9b04-c008ec5447da",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7b3c-84b8-c39002673f40": {
			"id": "01972fff-1078-7b3c-84b8-c39002673f40",
			"batchWeighingId": "01972fff-1077-7a41-a08c-6f7f75254a8b",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-763e-a057-586b9f940469",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7b9b-bce6-b2e0b9ecd2e1": {
			"id": "01972fff-1079-7b9b-bce6-b2e0b9ecd2e1",
			"batchWeighingId": "01972fff-1077-7b41-9642-433ed237a932",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7eba-9776-82691d10b223",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-70d6-bf36-3b7b36e4730e": {
			"id": "01972fff-1079-70d6-bf36-3b7b36e4730e",
			"batchWeighingId": "01972fff-1077-7b41-9642-433ed237a932",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ab5-b24d-428d7d28ce64",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7a78-8427-d63271de38eb": {
			"id": "01972fff-1079-7a78-8427-d63271de38eb",
			"batchWeighingId": "01972fff-1077-7b41-9642-433ed237a932",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7417-939c-f98b0727e8e2",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-716e-be7c-9ddf67db4dac": {
			"id": "01972fff-1079-716e-be7c-9ddf67db4dac",
			"batchWeighingId": "01972fff-1077-7b41-9642-433ed237a932",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7312-8ebe-b2c789cd0651",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-78cc-b90c-a2814916e093": {
			"id": "01972fff-1079-78cc-b90c-a2814916e093",
			"batchWeighingId": "01972fff-1077-7b41-9642-433ed237a932",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7a0b-bef2-e3752acd058c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7f72-99c3-0a880dc5d0fd": {
			"id": "01972fff-1079-7f72-99c3-0a880dc5d0fd",
			"batchWeighingId": "01972fff-1077-7b41-9642-433ed237a932",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-735b-a125-253a52f704a3",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-724f-b81a-30c3b2edc91d": {
			"id": "01972fff-1079-724f-b81a-30c3b2edc91d",
			"batchWeighingId": "01972fff-1077-7b41-9642-433ed237a932",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b25-990f-8dead42552b1",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-74e3-8d09-1fcbd4201d91": {
			"id": "01972fff-1079-74e3-8d09-1fcbd4201d91",
			"batchWeighingId": "01972fff-1077-7b41-9642-433ed237a932",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7506-b926-195a1917c8ee",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7adc-ad90-00680eda2d3e": {
			"id": "01972fff-1079-7adc-ad90-00680eda2d3e",
			"batchWeighingId": "01972fff-1077-7b41-9642-433ed237a932",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f48-895d-81d248190670",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7d4b-baf2-09296a513565": {
			"id": "01972fff-1079-7d4b-baf2-09296a513565",
			"batchWeighingId": "01972fff-1077-7b41-9642-433ed237a932",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-75f4-b9c1-70879f2393e8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7dc0-84c5-eb66b42321a1": {
			"id": "01972fff-1079-7dc0-84c5-eb66b42321a1",
			"batchWeighingId": "01972fff-1077-7b41-9642-433ed237a932",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7038-9b04-c008ec5447da",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7f7c-95fb-d2f1672a734c": {
			"id": "01972fff-1079-7f7c-95fb-d2f1672a734c",
			"batchWeighingId": "01972fff-1077-7b41-9642-433ed237a932",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-763e-a057-586b9f940469",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-70ba-baed-832d93086f5a": {
			"id": "01972fff-1078-70ba-baed-832d93086f5a",
			"batchWeighingId": "01972fff-1077-7c50-bc49-418356585805",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7cc0-8f09-74e5c8d3e0c8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7e3b-86b9-cda40c51bf14": {
			"id": "01972fff-1078-7e3b-86b9-cda40c51bf14",
			"batchWeighingId": "01972fff-1077-7c50-bc49-418356585805",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72a9-9660-c9530e27c9c4",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7198-8c74-59255f65eabe": {
			"id": "01972fff-1078-7198-8c74-59255f65eabe",
			"batchWeighingId": "01972fff-1077-7c50-bc49-418356585805",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c80-b927-c4dd6a802201",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7f53-b2b6-d12ede82b469": {
			"id": "01972fff-1078-7f53-b2b6-d12ede82b469",
			"batchWeighingId": "01972fff-1077-7c50-bc49-418356585805",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7de0-a2c2-04b18d96cf1c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7926-805e-4e59fca05dec": {
			"id": "01972fff-1078-7926-805e-4e59fca05dec",
			"batchWeighingId": "01972fff-1077-7c50-bc49-418356585805",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-78e4-bf20-7df89055c146",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7128-acd5-219556ccaf9e": {
			"id": "01972fff-1078-7128-acd5-219556ccaf9e",
			"batchWeighingId": "01972fff-1077-7c50-bc49-418356585805",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bb2-9afa-2aaca02d4cd1",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7168-83be-346e84ad5458": {
			"id": "01972fff-1078-7168-83be-346e84ad5458",
			"batchWeighingId": "01972fff-1077-7c50-bc49-418356585805",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-73a5-a585-dbd6c2beaca5",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7bec-ac29-04a4a1a4d74f": {
			"id": "01972fff-1078-7bec-ac29-04a4a1a4d74f",
			"batchWeighingId": "01972fff-1077-7c50-bc49-418356585805",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e0c-8e4a-4574c3d0def1",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7460-88af-bce0ce948dd4": {
			"id": "01972fff-1078-7460-88af-bce0ce948dd4",
			"batchWeighingId": "01972fff-1077-7c50-bc49-418356585805",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b5c-b9c3-a8646cef2411",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-77f7-b6b4-c39e01410271": {
			"id": "01972fff-1078-77f7-b6b4-c39e01410271",
			"batchWeighingId": "01972fff-1077-7c50-bc49-418356585805",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bf7-9a2d-255c32e6bab6",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-784c-8049-70e70d8415de": {
			"id": "01972fff-1078-784c-8049-70e70d8415de",
			"batchWeighingId": "01972fff-1077-7c50-bc49-418356585805",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-77e5-8abc-31b7064e18f9",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7c83-9b6b-4b6edcef177e": {
			"id": "01972fff-1078-7c83-9b6b-4b6edcef177e",
			"batchWeighingId": "01972fff-1077-7c50-bc49-418356585805",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-79c5-85e8-41ce5450a00e",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-78c8-8901-0fd1cdd4f0ea": {
			"id": "01972fff-1078-78c8-8901-0fd1cdd4f0ea",
			"batchWeighingId": "01972fff-1077-7c50-bc49-418356585805",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7254-9a40-bce0b6095f36",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7f53-98a1-c401d840e525": {
			"id": "01972fff-1078-7f53-98a1-c401d840e525",
			"batchWeighingId": "01972fff-1077-7c50-bc49-418356585805",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7de7-b6c1-f86afe274a36",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7cba-b039-01e617a3c418": {
			"id": "01972fff-1078-7cba-b039-01e617a3c418",
			"batchWeighingId": "01972fff-1077-7c50-bc49-418356585805",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e91-85c6-54515cbe68e8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7bd2-94e6-a8a441c8beb3": {
			"id": "01972fff-1078-7bd2-94e6-a8a441c8beb3",
			"batchWeighingId": "01972fff-1077-7c50-bc49-418356585805",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7eac-bd4c-8e83837951e7",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7004-9a90-b31e354c78ca": {
			"id": "01972fff-1078-7004-9a90-b31e354c78ca",
			"batchWeighingId": "01972fff-1077-7c50-bc49-418356585805",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f7f-be3e-d0da05b69a77",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-73d9-abc2-41c0387501f2": {
			"id": "01972fff-1078-73d9-abc2-41c0387501f2",
			"batchWeighingId": "01972fff-1077-7c50-bc49-418356585805",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-76b4-be3e-26e9330abc8c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7442-8f8c-d2bff40fd61d": {
			"id": "01972fff-1079-7442-8f8c-d2bff40fd61d",
			"batchWeighingId": "01972fff-1077-7311-83da-0b2ae8b325b8",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7cc0-8f09-74e5c8d3e0c8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7aad-afbe-27c876d70e38": {
			"id": "01972fff-1079-7aad-afbe-27c876d70e38",
			"batchWeighingId": "01972fff-1077-7311-83da-0b2ae8b325b8",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72a9-9660-c9530e27c9c4",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7a4b-9f38-243392a4740c": {
			"id": "01972fff-1079-7a4b-9f38-243392a4740c",
			"batchWeighingId": "01972fff-1077-7311-83da-0b2ae8b325b8",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c80-b927-c4dd6a802201",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-75da-b21e-d7cdec0352e4": {
			"id": "01972fff-1079-75da-b21e-d7cdec0352e4",
			"batchWeighingId": "01972fff-1077-7311-83da-0b2ae8b325b8",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7de0-a2c2-04b18d96cf1c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-798a-8da5-6e2b486f4906": {
			"id": "01972fff-1079-798a-8da5-6e2b486f4906",
			"batchWeighingId": "01972fff-1077-7311-83da-0b2ae8b325b8",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-78e4-bf20-7df89055c146",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7da6-a769-8fd9b577f0bd": {
			"id": "01972fff-1079-7da6-a769-8fd9b577f0bd",
			"batchWeighingId": "01972fff-1077-7311-83da-0b2ae8b325b8",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bb2-9afa-2aaca02d4cd1",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-775b-9a52-ee2c932a689f": {
			"id": "01972fff-1079-775b-9a52-ee2c932a689f",
			"batchWeighingId": "01972fff-1077-7311-83da-0b2ae8b325b8",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-73a5-a585-dbd6c2beaca5",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7c2e-bb58-b11a67f850df": {
			"id": "01972fff-1079-7c2e-bb58-b11a67f850df",
			"batchWeighingId": "01972fff-1077-7311-83da-0b2ae8b325b8",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e0c-8e4a-4574c3d0def1",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-73a4-96d2-6d5d1411b804": {
			"id": "01972fff-1079-73a4-96d2-6d5d1411b804",
			"batchWeighingId": "01972fff-1077-7311-83da-0b2ae8b325b8",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b5c-b9c3-a8646cef2411",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7016-b7ed-0fb70bc9c201": {
			"id": "01972fff-1079-7016-b7ed-0fb70bc9c201",
			"batchWeighingId": "01972fff-1077-7311-83da-0b2ae8b325b8",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bf7-9a2d-255c32e6bab6",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-799a-a6bc-9b6ab742e4be": {
			"id": "01972fff-1079-799a-a6bc-9b6ab742e4be",
			"batchWeighingId": "01972fff-1077-7311-83da-0b2ae8b325b8",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-77e5-8abc-31b7064e18f9",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7b36-ab61-681dcca5ebfa": {
			"id": "01972fff-1079-7b36-ab61-681dcca5ebfa",
			"batchWeighingId": "01972fff-1077-7311-83da-0b2ae8b325b8",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-79c5-85e8-41ce5450a00e",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7b8b-b8ae-ac40426bfcb7": {
			"id": "01972fff-1079-7b8b-b8ae-ac40426bfcb7",
			"batchWeighingId": "01972fff-1077-7311-83da-0b2ae8b325b8",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7254-9a40-bce0b6095f36",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-78ff-8b88-f67ebbe38510": {
			"id": "01972fff-1079-78ff-8b88-f67ebbe38510",
			"batchWeighingId": "01972fff-1077-7311-83da-0b2ae8b325b8",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7de7-b6c1-f86afe274a36",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-78cc-a2fb-9b9d940d98aa": {
			"id": "01972fff-1079-78cc-a2fb-9b9d940d98aa",
			"batchWeighingId": "01972fff-1077-7311-83da-0b2ae8b325b8",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e91-85c6-54515cbe68e8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-76aa-a82b-18fb0b75cddf": {
			"id": "01972fff-1079-76aa-a82b-18fb0b75cddf",
			"batchWeighingId": "01972fff-1077-7311-83da-0b2ae8b325b8",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7eac-bd4c-8e83837951e7",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7c80-86f4-1ba5734fb147": {
			"id": "01972fff-1079-7c80-86f4-1ba5734fb147",
			"batchWeighingId": "01972fff-1077-7311-83da-0b2ae8b325b8",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f7f-be3e-d0da05b69a77",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-731d-8866-e761e53cf7b9": {
			"id": "01972fff-1079-731d-8866-e761e53cf7b9",
			"batchWeighingId": "01972fff-1077-7311-83da-0b2ae8b325b8",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-76b4-be3e-26e9330abc8c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7a88-8e72-8dfcdd890af8": {
			"id": "01972fff-1078-7a88-8e72-8dfcdd890af8",
			"batchWeighingId": "01972fff-1077-7a69-87b2-d469f7d4a8d8",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d52-8551-bea41c2d42b7",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7caf-aee3-19ff94c97426": {
			"id": "01972fff-1078-7caf-aee3-19ff94c97426",
			"batchWeighingId": "01972fff-1077-7a69-87b2-d469f7d4a8d8",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-706f-9aff-3adda18d98cc",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7647-bc6c-aaa9a97af693": {
			"id": "01972fff-1078-7647-bc6c-aaa9a97af693",
			"batchWeighingId": "01972fff-1077-7a69-87b2-d469f7d4a8d8",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-77b4-94ec-f73a7ffeb862",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-76f4-b303-df7b9d09c485": {
			"id": "01972fff-1078-76f4-b303-df7b9d09c485",
			"batchWeighingId": "01972fff-1077-7a69-87b2-d469f7d4a8d8",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d7d-9eca-281a03d35c29",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7268-8d6c-c87ae94c8d75": {
			"id": "01972fff-1078-7268-8d6c-c87ae94c8d75",
			"batchWeighingId": "01972fff-1077-7a69-87b2-d469f7d4a8d8",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7183-94ca-d5898205c039",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7b83-81b8-caf562652bcd": {
			"id": "01972fff-1078-7b83-81b8-caf562652bcd",
			"batchWeighingId": "01972fff-1077-7a69-87b2-d469f7d4a8d8",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-705b-ad87-dfc04abf7f79",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7276-8f69-e48108a40476": {
			"id": "01972fff-1078-7276-8f69-e48108a40476",
			"batchWeighingId": "01972fff-1077-7a69-87b2-d469f7d4a8d8",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-700c-a74d-921798039d33",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7f22-8a14-57ed02d33a19": {
			"id": "01972fff-1078-7f22-8a14-57ed02d33a19",
			"batchWeighingId": "01972fff-1077-7a69-87b2-d469f7d4a8d8",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-743a-807e-8525fbe3ddf6",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7684-b0fd-d7011a2439a4": {
			"id": "01972fff-1078-7684-b0fd-d7011a2439a4",
			"batchWeighingId": "01972fff-1077-7a69-87b2-d469f7d4a8d8",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c55-ac86-4f1b8ea1eddd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7515-9ba1-4626f519f2bf": {
			"id": "01972fff-1078-7515-9ba1-4626f519f2bf",
			"batchWeighingId": "01972fff-1077-7a69-87b2-d469f7d4a8d8",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-705c-a42a-57982cfdaf67",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-789f-9fac-9fc4317fab51": {
			"id": "01972fff-1078-789f-9fac-9fc4317fab51",
			"batchWeighingId": "01972fff-1077-7a69-87b2-d469f7d4a8d8",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-760e-a723-6e0f16df5266",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-73ac-ae20-888af57af761": {
			"id": "01972fff-1078-73ac-ae20-888af57af761",
			"batchWeighingId": "01972fff-1077-7a69-87b2-d469f7d4a8d8",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7070-a724-9868e4e676ac",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-75cf-8c14-ea227de68ed2": {
			"id": "01972fff-1078-75cf-8c14-ea227de68ed2",
			"batchWeighingId": "01972fff-1077-7a69-87b2-d469f7d4a8d8",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7397-a4ac-2d286c030acb",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-78f6-9d40-e16c04275db4": {
			"id": "01972fff-1078-78f6-9d40-e16c04275db4",
			"batchWeighingId": "01972fff-1077-7a69-87b2-d469f7d4a8d8",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-791f-a265-9cdd4121d220",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7bc9-b8c1-3df748ac39c8": {
			"id": "01972fff-1078-7bc9-b8c1-3df748ac39c8",
			"batchWeighingId": "01972fff-1077-7a69-87b2-d469f7d4a8d8",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ba2-84f7-ab4adbfeaf6b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7ec8-81bd-f51d0983b7f4": {
			"id": "01972fff-1078-7ec8-81bd-f51d0983b7f4",
			"batchWeighingId": "01972fff-1077-7a69-87b2-d469f7d4a8d8",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7543-9639-80c738150ab9",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-74cb-a2bd-e743d602fe50": {
			"id": "01972fff-1078-74cb-a2bd-e743d602fe50",
			"batchWeighingId": "01972fff-1077-7a69-87b2-d469f7d4a8d8",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-758f-8ad0-025a138f650a",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7808-8b9e-d9af92e5f936": {
			"id": "01972fff-1078-7808-8b9e-d9af92e5f936",
			"batchWeighingId": "01972fff-1077-7a69-87b2-d469f7d4a8d8",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-753e-b982-ef834631ddce",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-72f9-bd1d-078e8b18d9ab": {
			"id": "01972fff-1079-72f9-bd1d-078e8b18d9ab",
			"batchWeighingId": "01972fff-1077-7d72-9459-ad623dca82fe",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d52-8551-bea41c2d42b7",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7631-b35a-73eac51a906a": {
			"id": "01972fff-1079-7631-b35a-73eac51a906a",
			"batchWeighingId": "01972fff-1077-7d72-9459-ad623dca82fe",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-706f-9aff-3adda18d98cc",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-779d-b174-89e809427cb6": {
			"id": "01972fff-1079-779d-b174-89e809427cb6",
			"batchWeighingId": "01972fff-1077-7d72-9459-ad623dca82fe",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-77b4-94ec-f73a7ffeb862",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7c88-8bbe-ab8c6f733706": {
			"id": "01972fff-1079-7c88-8bbe-ab8c6f733706",
			"batchWeighingId": "01972fff-1077-7d72-9459-ad623dca82fe",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d7d-9eca-281a03d35c29",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7cf6-97ed-731f55db57e5": {
			"id": "01972fff-1079-7cf6-97ed-731f55db57e5",
			"batchWeighingId": "01972fff-1077-7d72-9459-ad623dca82fe",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7183-94ca-d5898205c039",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7d36-b8b0-4965ce79df6b": {
			"id": "01972fff-1079-7d36-b8b0-4965ce79df6b",
			"batchWeighingId": "01972fff-1077-7d72-9459-ad623dca82fe",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-705b-ad87-dfc04abf7f79",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7bbb-91c4-3fe4abd9dc72": {
			"id": "01972fff-1079-7bbb-91c4-3fe4abd9dc72",
			"batchWeighingId": "01972fff-1077-7d72-9459-ad623dca82fe",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-700c-a74d-921798039d33",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7964-87b1-2a9c3c612068": {
			"id": "01972fff-1079-7964-87b1-2a9c3c612068",
			"batchWeighingId": "01972fff-1077-7d72-9459-ad623dca82fe",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-743a-807e-8525fbe3ddf6",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-756e-98b7-52e8ef1f41cc": {
			"id": "01972fff-1079-756e-98b7-52e8ef1f41cc",
			"batchWeighingId": "01972fff-1077-7d72-9459-ad623dca82fe",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c55-ac86-4f1b8ea1eddd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7a08-9f2d-56665df249b9": {
			"id": "01972fff-1079-7a08-9f2d-56665df249b9",
			"batchWeighingId": "01972fff-1077-7d72-9459-ad623dca82fe",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-705c-a42a-57982cfdaf67",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-74b9-9333-e0a649800e62": {
			"id": "01972fff-1079-74b9-9333-e0a649800e62",
			"batchWeighingId": "01972fff-1077-7d72-9459-ad623dca82fe",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-760e-a723-6e0f16df5266",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7033-be19-f078cd0169b3": {
			"id": "01972fff-1079-7033-be19-f078cd0169b3",
			"batchWeighingId": "01972fff-1077-7d72-9459-ad623dca82fe",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7070-a724-9868e4e676ac",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-76d8-bded-1ab54b9ba6dd": {
			"id": "01972fff-1079-76d8-bded-1ab54b9ba6dd",
			"batchWeighingId": "01972fff-1077-7d72-9459-ad623dca82fe",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7397-a4ac-2d286c030acb",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7468-9edd-8b74e2233da9": {
			"id": "01972fff-1079-7468-9edd-8b74e2233da9",
			"batchWeighingId": "01972fff-1077-7d72-9459-ad623dca82fe",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-791f-a265-9cdd4121d220",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-79a8-a083-df469e6d93bc": {
			"id": "01972fff-1079-79a8-a083-df469e6d93bc",
			"batchWeighingId": "01972fff-1077-7d72-9459-ad623dca82fe",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ba2-84f7-ab4adbfeaf6b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7604-b18a-1916c4ab57b9": {
			"id": "01972fff-1079-7604-b18a-1916c4ab57b9",
			"batchWeighingId": "01972fff-1077-7d72-9459-ad623dca82fe",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7543-9639-80c738150ab9",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-75ae-a9c3-b271d22a43a2": {
			"id": "01972fff-1079-75ae-a9c3-b271d22a43a2",
			"batchWeighingId": "01972fff-1077-7d72-9459-ad623dca82fe",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-758f-8ad0-025a138f650a",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7779-a83a-98e14489b174": {
			"id": "01972fff-1079-7779-a83a-98e14489b174",
			"batchWeighingId": "01972fff-1077-7d72-9459-ad623dca82fe",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-753e-b982-ef834631ddce",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-75dc-8a10-9220fd50e8fb": {
			"id": "01972fff-1078-75dc-8a10-9220fd50e8fb",
			"batchWeighingId": "01972fff-1077-7856-a582-5e3748fda46c",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7588-8948-d019938cabcf",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7406-8ce3-14c18d087044": {
			"id": "01972fff-1078-7406-8ce3-14c18d087044",
			"batchWeighingId": "01972fff-1077-7856-a582-5e3748fda46c",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7793-be98-5b3a0f57f68c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7815-9e28-05a1ba5941e8": {
			"id": "01972fff-1078-7815-9e28-05a1ba5941e8",
			"batchWeighingId": "01972fff-1077-7856-a582-5e3748fda46c",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7fd5-87a6-05a93ab71b2f",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7fe2-9cee-07c2921eaa0a": {
			"id": "01972fff-1078-7fe2-9cee-07c2921eaa0a",
			"batchWeighingId": "01972fff-1077-7856-a582-5e3748fda46c",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7aaa-99a1-c17c58bbf637",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-79d6-9ced-6fc45a945ba0": {
			"id": "01972fff-1078-79d6-9ced-6fc45a945ba0",
			"batchWeighingId": "01972fff-1077-7856-a582-5e3748fda46c",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-756e-a1fc-12f249a87226",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-794f-a22f-f2f75c953b97": {
			"id": "01972fff-1078-794f-a22f-f2f75c953b97",
			"batchWeighingId": "01972fff-1077-7856-a582-5e3748fda46c",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-74ee-8acd-2950986e209b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7cf8-b081-36c2a466c9fa": {
			"id": "01972fff-1078-7cf8-b081-36c2a466c9fa",
			"batchWeighingId": "01972fff-1077-7856-a582-5e3748fda46c",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-759a-b3bf-d087463fcac5",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-795c-b977-7fcc5cf8d70a": {
			"id": "01972fff-1078-795c-b977-7fcc5cf8d70a",
			"batchWeighingId": "01972fff-1077-7856-a582-5e3748fda46c",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72f7-9fd9-51851a3f6e0e",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-72ee-89a2-70a5d150d6c0": {
			"id": "01972fff-1078-72ee-89a2-70a5d150d6c0",
			"batchWeighingId": "01972fff-1077-7856-a582-5e3748fda46c",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-73af-b25b-4244838049fd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7c7e-a65a-0423d7fcbbda": {
			"id": "01972fff-1078-7c7e-a65a-0423d7fcbbda",
			"batchWeighingId": "01972fff-1077-7856-a582-5e3748fda46c",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f8d-a674-968ede5f4929",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7258-9b54-4a7094cde868": {
			"id": "01972fff-1078-7258-9b54-4a7094cde868",
			"batchWeighingId": "01972fff-1077-7856-a582-5e3748fda46c",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ebd-ba0d-78821fa95a34",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7d0f-90ff-02dfd97d2741": {
			"id": "01972fff-1078-7d0f-90ff-02dfd97d2741",
			"batchWeighingId": "01972fff-1077-7856-a582-5e3748fda46c",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-715e-ada5-30bf34cd667d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7ed9-b264-2012f30713fc": {
			"id": "01972fff-1078-7ed9-b264-2012f30713fc",
			"batchWeighingId": "01972fff-1077-7856-a582-5e3748fda46c",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-78b6-888f-d279b7ab60bd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7586-907e-ce14e5a13278": {
			"id": "01972fff-1078-7586-907e-ce14e5a13278",
			"batchWeighingId": "01972fff-1077-7856-a582-5e3748fda46c",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-735a-b9e6-ec3de3e1594a",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7cf3-bb0e-9e9cb387db23": {
			"id": "01972fff-1078-7cf3-bb0e-9e9cb387db23",
			"batchWeighingId": "01972fff-1077-7856-a582-5e3748fda46c",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e69-975a-290d0743efef",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7bd9-aa5f-3dbfe738c00f": {
			"id": "01972fff-1078-7bd9-aa5f-3dbfe738c00f",
			"batchWeighingId": "01972fff-1077-7856-a582-5e3748fda46c",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-786d-8513-0664c3ccad98",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7bb7-910e-b18e6a864767": {
			"id": "01972fff-1078-7bb7-910e-b18e6a864767",
			"batchWeighingId": "01972fff-1077-7856-a582-5e3748fda46c",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7db6-ac89-92b6bcde462b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7aa4-ab8b-9c04995e283b": {
			"id": "01972fff-1078-7aa4-ab8b-9c04995e283b",
			"batchWeighingId": "01972fff-1077-7856-a582-5e3748fda46c",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7cd8-b9b2-b52c2dd90d20",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-70cc-8234-c240989347e2": {
			"id": "01972fff-1079-70cc-8234-c240989347e2",
			"batchWeighingId": "01972fff-1077-7ce0-acb9-52c67f879ee0",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7588-8948-d019938cabcf",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-77da-b77a-03b1787d12e7": {
			"id": "01972fff-1079-77da-b77a-03b1787d12e7",
			"batchWeighingId": "01972fff-1077-7ce0-acb9-52c67f879ee0",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7793-be98-5b3a0f57f68c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7389-a4a3-1fae6896fec7": {
			"id": "01972fff-1079-7389-a4a3-1fae6896fec7",
			"batchWeighingId": "01972fff-1077-7ce0-acb9-52c67f879ee0",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7fd5-87a6-05a93ab71b2f",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-76ea-b47b-cd89f8de02ec": {
			"id": "01972fff-1079-76ea-b47b-cd89f8de02ec",
			"batchWeighingId": "01972fff-1077-7ce0-acb9-52c67f879ee0",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7aaa-99a1-c17c58bbf637",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-77ce-9eeb-fc8a2d35139c": {
			"id": "01972fff-1079-77ce-9eeb-fc8a2d35139c",
			"batchWeighingId": "01972fff-1077-7ce0-acb9-52c67f879ee0",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-756e-a1fc-12f249a87226",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7ea1-8f83-4b848e7c4aa9": {
			"id": "01972fff-1079-7ea1-8f83-4b848e7c4aa9",
			"batchWeighingId": "01972fff-1077-7ce0-acb9-52c67f879ee0",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-74ee-8acd-2950986e209b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-794f-843e-77a6c1f9818f": {
			"id": "01972fff-1079-794f-843e-77a6c1f9818f",
			"batchWeighingId": "01972fff-1077-7ce0-acb9-52c67f879ee0",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-759a-b3bf-d087463fcac5",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7821-9a51-c60ea8762bec": {
			"id": "01972fff-1079-7821-9a51-c60ea8762bec",
			"batchWeighingId": "01972fff-1077-7ce0-acb9-52c67f879ee0",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72f7-9fd9-51851a3f6e0e",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7592-bcb3-21690f474af5": {
			"id": "01972fff-1079-7592-bcb3-21690f474af5",
			"batchWeighingId": "01972fff-1077-7ce0-acb9-52c67f879ee0",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-73af-b25b-4244838049fd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7a26-af31-7904fcaef9e0": {
			"id": "01972fff-1079-7a26-af31-7904fcaef9e0",
			"batchWeighingId": "01972fff-1077-7ce0-acb9-52c67f879ee0",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f8d-a674-968ede5f4929",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7d05-9eb8-3f26cd5e3417": {
			"id": "01972fff-1079-7d05-9eb8-3f26cd5e3417",
			"batchWeighingId": "01972fff-1077-7ce0-acb9-52c67f879ee0",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ebd-ba0d-78821fa95a34",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7591-a0cf-390dcdc2b1ab": {
			"id": "01972fff-1079-7591-a0cf-390dcdc2b1ab",
			"batchWeighingId": "01972fff-1077-7ce0-acb9-52c67f879ee0",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-715e-ada5-30bf34cd667d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7fd8-a6a2-5dfd10b10cd4": {
			"id": "01972fff-1079-7fd8-a6a2-5dfd10b10cd4",
			"batchWeighingId": "01972fff-1077-7ce0-acb9-52c67f879ee0",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-78b6-888f-d279b7ab60bd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-746f-a06d-38a2c1d48ccb": {
			"id": "01972fff-1079-746f-a06d-38a2c1d48ccb",
			"batchWeighingId": "01972fff-1077-7ce0-acb9-52c67f879ee0",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-735a-b9e6-ec3de3e1594a",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7c5b-9bc1-52ef33b93ef6": {
			"id": "01972fff-1079-7c5b-9bc1-52ef33b93ef6",
			"batchWeighingId": "01972fff-1077-7ce0-acb9-52c67f879ee0",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e69-975a-290d0743efef",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7cc1-a74f-169baf080eb7": {
			"id": "01972fff-1079-7cc1-a74f-169baf080eb7",
			"batchWeighingId": "01972fff-1077-7ce0-acb9-52c67f879ee0",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-786d-8513-0664c3ccad98",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7ab7-894a-8e40889c92bc": {
			"id": "01972fff-1079-7ab7-894a-8e40889c92bc",
			"batchWeighingId": "01972fff-1077-7ce0-acb9-52c67f879ee0",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7db6-ac89-92b6bcde462b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-78ea-a6f2-8f9c532d5271": {
			"id": "01972fff-1079-78ea-a6f2-8f9c532d5271",
			"batchWeighingId": "01972fff-1077-7ce0-acb9-52c67f879ee0",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7cd8-b9b2-b52c2dd90d20",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-75ea-b8c0-c76646fc1d8a": {
			"id": "01972fff-1078-75ea-b8c0-c76646fc1d8a",
			"batchWeighingId": "01972fff-1077-7896-b114-f902703f1f64",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72d3-8b30-e0ab83e8d37d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7a0c-8d83-fac5c0edd8af": {
			"id": "01972fff-1078-7a0c-8d83-fac5c0edd8af",
			"batchWeighingId": "01972fff-1077-7896-b114-f902703f1f64",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ac9-b2dd-13c1750b4fac",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7462-875f-ceb51144c010": {
			"id": "01972fff-1078-7462-875f-ceb51144c010",
			"batchWeighingId": "01972fff-1077-7896-b114-f902703f1f64",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7220-8bd9-19935e9b4527",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7704-9403-a1da5dfaa780": {
			"id": "01972fff-1078-7704-9403-a1da5dfaa780",
			"batchWeighingId": "01972fff-1077-7896-b114-f902703f1f64",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7251-ad3c-0cf9dfddd06c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7ede-8298-e1f0483c9143": {
			"id": "01972fff-1078-7ede-8298-e1f0483c9143",
			"batchWeighingId": "01972fff-1077-7896-b114-f902703f1f64",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-756f-b159-cc0612f285c8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7ff6-9035-bb8f380dde60": {
			"id": "01972fff-1078-7ff6-9035-bb8f380dde60",
			"batchWeighingId": "01972fff-1077-7896-b114-f902703f1f64",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72fa-bf32-652bf5bf8d5b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-707f-9b57-0c303ef8b616": {
			"id": "01972fff-1078-707f-9b57-0c303ef8b616",
			"batchWeighingId": "01972fff-1077-7896-b114-f902703f1f64",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-736b-850a-0f073660b996",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-74ff-9ba3-f75cee0ee6c2": {
			"id": "01972fff-1078-74ff-9ba3-f75cee0ee6c2",
			"batchWeighingId": "01972fff-1077-7896-b114-f902703f1f64",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-769c-977d-a08eba7e9622",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7ca0-94c2-6414edc11709": {
			"id": "01972fff-1078-7ca0-94c2-6414edc11709",
			"batchWeighingId": "01972fff-1077-7896-b114-f902703f1f64",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7834-b8ae-bbf502ec6115",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7b1d-941e-d85f5790f406": {
			"id": "01972fff-1078-7b1d-941e-d85f5790f406",
			"batchWeighingId": "01972fff-1077-7896-b114-f902703f1f64",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-725a-9159-dcc67d810756",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-793d-84ac-94fd3a4aa449": {
			"id": "01972fff-1078-793d-84ac-94fd3a4aa449",
			"batchWeighingId": "01972fff-1077-7896-b114-f902703f1f64",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ca3-9f3b-9c24d52fcf77",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-74a4-9caa-f002360dc82c": {
			"id": "01972fff-1078-74a4-9caa-f002360dc82c",
			"batchWeighingId": "01972fff-1077-7896-b114-f902703f1f64",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7baa-9842-af256f4506e0",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7e3f-a908-87648dfc9f1b": {
			"id": "01972fff-1078-7e3f-a908-87648dfc9f1b",
			"batchWeighingId": "01972fff-1077-7896-b114-f902703f1f64",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-741f-83bf-c4acd2f30d37",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7a71-8998-b9d5ce633f5a": {
			"id": "01972fff-1078-7a71-8998-b9d5ce633f5a",
			"batchWeighingId": "01972fff-1077-7896-b114-f902703f1f64",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-704e-bfa5-366faf7530bd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7215-835f-d52bbe40fdef": {
			"id": "01972fff-1078-7215-835f-d52bbe40fdef",
			"batchWeighingId": "01972fff-1077-7896-b114-f902703f1f64",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7293-be3c-09d702091eda",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-78e4-8682-650eeaba45e1": {
			"id": "01972fff-1078-78e4-8682-650eeaba45e1",
			"batchWeighingId": "01972fff-1077-7896-b114-f902703f1f64",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b4b-8037-8939efa37fc3",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-723a-8d94-bde2d669e98a": {
			"id": "01972fff-1078-723a-8d94-bde2d669e98a",
			"batchWeighingId": "01972fff-1077-7896-b114-f902703f1f64",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7542-b533-b57facd55fc7",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7266-9941-312af96fd67b": {
			"id": "01972fff-1078-7266-9941-312af96fd67b",
			"batchWeighingId": "01972fff-1077-7896-b114-f902703f1f64",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7fbc-af18-3cdac7a0cc1d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7b0c-9d7b-4c1ebf40a2fb": {
			"id": "01972fff-1079-7b0c-9d7b-4c1ebf40a2fb",
			"batchWeighingId": "01972fff-1077-77ce-8d3b-63764dbc6677",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72d3-8b30-e0ab83e8d37d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-73e0-a9fd-9ec4415c61a7": {
			"id": "01972fff-1079-73e0-a9fd-9ec4415c61a7",
			"batchWeighingId": "01972fff-1077-77ce-8d3b-63764dbc6677",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ac9-b2dd-13c1750b4fac",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7591-aa77-bfd4ec118c6a": {
			"id": "01972fff-1079-7591-aa77-bfd4ec118c6a",
			"batchWeighingId": "01972fff-1077-77ce-8d3b-63764dbc6677",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7220-8bd9-19935e9b4527",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7e40-ab20-67e2aeb9fbb9": {
			"id": "01972fff-1079-7e40-ab20-67e2aeb9fbb9",
			"batchWeighingId": "01972fff-1077-77ce-8d3b-63764dbc6677",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7251-ad3c-0cf9dfddd06c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7692-820f-30e033e43353": {
			"id": "01972fff-1079-7692-820f-30e033e43353",
			"batchWeighingId": "01972fff-1077-77ce-8d3b-63764dbc6677",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-756f-b159-cc0612f285c8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7049-a377-f8d1a22c5e96": {
			"id": "01972fff-1079-7049-a377-f8d1a22c5e96",
			"batchWeighingId": "01972fff-1077-77ce-8d3b-63764dbc6677",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72fa-bf32-652bf5bf8d5b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7092-908f-2cbc3fb122a3": {
			"id": "01972fff-1079-7092-908f-2cbc3fb122a3",
			"batchWeighingId": "01972fff-1077-77ce-8d3b-63764dbc6677",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-736b-850a-0f073660b996",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7b0d-9121-12aaa26e8753": {
			"id": "01972fff-1079-7b0d-9121-12aaa26e8753",
			"batchWeighingId": "01972fff-1077-77ce-8d3b-63764dbc6677",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-769c-977d-a08eba7e9622",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7374-ad41-ef1a2c363c31": {
			"id": "01972fff-1079-7374-ad41-ef1a2c363c31",
			"batchWeighingId": "01972fff-1077-77ce-8d3b-63764dbc6677",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7834-b8ae-bbf502ec6115",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-735c-9d30-f8814c32b070": {
			"id": "01972fff-1079-735c-9d30-f8814c32b070",
			"batchWeighingId": "01972fff-1077-77ce-8d3b-63764dbc6677",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-725a-9159-dcc67d810756",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-74f1-b4d1-db24f9c96531": {
			"id": "01972fff-1079-74f1-b4d1-db24f9c96531",
			"batchWeighingId": "01972fff-1077-77ce-8d3b-63764dbc6677",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ca3-9f3b-9c24d52fcf77",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-72f6-9076-fb51fe9443d4": {
			"id": "01972fff-1079-72f6-9076-fb51fe9443d4",
			"batchWeighingId": "01972fff-1077-77ce-8d3b-63764dbc6677",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7baa-9842-af256f4506e0",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7020-91ae-3ca66c92e8b9": {
			"id": "01972fff-1079-7020-91ae-3ca66c92e8b9",
			"batchWeighingId": "01972fff-1077-77ce-8d3b-63764dbc6677",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-741f-83bf-c4acd2f30d37",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7e2a-aeaf-03aec00ad9ec": {
			"id": "01972fff-1079-7e2a-aeaf-03aec00ad9ec",
			"batchWeighingId": "01972fff-1077-77ce-8d3b-63764dbc6677",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-704e-bfa5-366faf7530bd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7fa0-82b9-cd7000bf871c": {
			"id": "01972fff-1079-7fa0-82b9-cd7000bf871c",
			"batchWeighingId": "01972fff-1077-77ce-8d3b-63764dbc6677",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7293-be3c-09d702091eda",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7033-bef0-1f6784e669a0": {
			"id": "01972fff-1079-7033-bef0-1f6784e669a0",
			"batchWeighingId": "01972fff-1077-77ce-8d3b-63764dbc6677",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b4b-8037-8939efa37fc3",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-75f5-af52-17d9fcd7fe39": {
			"id": "01972fff-1079-75f5-af52-17d9fcd7fe39",
			"batchWeighingId": "01972fff-1077-77ce-8d3b-63764dbc6677",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7542-b533-b57facd55fc7",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7e30-82b2-f193c9d89020": {
			"id": "01972fff-1079-7e30-82b2-f193c9d89020",
			"batchWeighingId": "01972fff-1077-77ce-8d3b-63764dbc6677",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7fbc-af18-3cdac7a0cc1d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7747-8572-a83ba0648405": {
			"id": "01972fff-1078-7747-8572-a83ba0648405",
			"batchWeighingId": "01972fff-1077-7243-ac8b-4ec964988431",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-791f-8133-0da1c1775cc1",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7a5e-b425-b4c5c3204e1f": {
			"id": "01972fff-1078-7a5e-b425-b4c5c3204e1f",
			"batchWeighingId": "01972fff-1077-7243-ac8b-4ec964988431",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-785f-a996-3528e8721a65",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7db2-83b6-dc6691d0c9b7": {
			"id": "01972fff-1078-7db2-83b6-dc6691d0c9b7",
			"batchWeighingId": "01972fff-1077-7243-ac8b-4ec964988431",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-76fa-b086-05bdfdf5ceac",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-78b1-9588-cfcd768ecd9f": {
			"id": "01972fff-1078-78b1-9588-cfcd768ecd9f",
			"batchWeighingId": "01972fff-1077-7243-ac8b-4ec964988431",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-759d-aee4-7ef4826f8848",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-78ed-ac17-6ae7f089c272": {
			"id": "01972fff-1078-78ed-ac17-6ae7f089c272",
			"batchWeighingId": "01972fff-1077-7243-ac8b-4ec964988431",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-747b-8adb-bd455ba79531",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-74d8-ad3d-7676f058bd6d": {
			"id": "01972fff-1078-74d8-ad3d-7676f058bd6d",
			"batchWeighingId": "01972fff-1077-7243-ac8b-4ec964988431",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d0e-ae8e-266abac6fb6c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7da9-a06f-f65efde4d98e": {
			"id": "01972fff-1078-7da9-a06f-f65efde4d98e",
			"batchWeighingId": "01972fff-1077-7243-ac8b-4ec964988431",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7183-9ac0-fde99a456d9e",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7337-b678-8acaa495156a": {
			"id": "01972fff-1078-7337-b678-8acaa495156a",
			"batchWeighingId": "01972fff-1077-7243-ac8b-4ec964988431",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bf4-bbb1-08943a23cb9d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-72ee-8e66-ab2fdecc8e43": {
			"id": "01972fff-1078-72ee-8e66-ab2fdecc8e43",
			"batchWeighingId": "01972fff-1077-7243-ac8b-4ec964988431",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7791-8b3f-d4206701ca8a",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7e6c-8b5d-8b91d78172dc": {
			"id": "01972fff-1078-7e6c-8b5d-8b91d78172dc",
			"batchWeighingId": "01972fff-1077-7243-ac8b-4ec964988431",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e92-8c88-0ca0d3695405",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-705c-9d35-6edd56d88df8": {
			"id": "01972fff-1078-705c-9d35-6edd56d88df8",
			"batchWeighingId": "01972fff-1077-7243-ac8b-4ec964988431",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b00-b171-5d7dca8bad24",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-739f-87c6-18f8325c9c8d": {
			"id": "01972fff-1078-739f-87c6-18f8325c9c8d",
			"batchWeighingId": "01972fff-1077-7243-ac8b-4ec964988431",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7cb5-9b6b-584a83e4fa96",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7191-a789-1b1d7ba6e6a8": {
			"id": "01972fff-1079-7191-a789-1b1d7ba6e6a8",
			"batchWeighingId": "01972fff-1077-7aac-91c2-09946306b59e",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-791f-8133-0da1c1775cc1",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-73d1-9d37-ca3b9d0d2d50": {
			"id": "01972fff-1079-73d1-9d37-ca3b9d0d2d50",
			"batchWeighingId": "01972fff-1077-7aac-91c2-09946306b59e",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-785f-a996-3528e8721a65",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7a5e-bf23-b4bd278a7409": {
			"id": "01972fff-1079-7a5e-bf23-b4bd278a7409",
			"batchWeighingId": "01972fff-1077-7aac-91c2-09946306b59e",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-76fa-b086-05bdfdf5ceac",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-79ed-8fa9-f4f04e0cb78b": {
			"id": "01972fff-1079-79ed-8fa9-f4f04e0cb78b",
			"batchWeighingId": "01972fff-1077-7aac-91c2-09946306b59e",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-759d-aee4-7ef4826f8848",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-77dc-874f-154ce32ba2eb": {
			"id": "01972fff-1079-77dc-874f-154ce32ba2eb",
			"batchWeighingId": "01972fff-1077-7aac-91c2-09946306b59e",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-747b-8adb-bd455ba79531",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7876-862f-4c847b8f0ed9": {
			"id": "01972fff-1079-7876-862f-4c847b8f0ed9",
			"batchWeighingId": "01972fff-1077-7aac-91c2-09946306b59e",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d0e-ae8e-266abac6fb6c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7793-8cd5-a97669dba486": {
			"id": "01972fff-1079-7793-8cd5-a97669dba486",
			"batchWeighingId": "01972fff-1077-7aac-91c2-09946306b59e",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7183-9ac0-fde99a456d9e",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7fd1-8301-d38aaa61fabb": {
			"id": "01972fff-1079-7fd1-8301-d38aaa61fabb",
			"batchWeighingId": "01972fff-1077-7aac-91c2-09946306b59e",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bf4-bbb1-08943a23cb9d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7f49-8c2d-43f817cd87ce": {
			"id": "01972fff-1079-7f49-8c2d-43f817cd87ce",
			"batchWeighingId": "01972fff-1077-7aac-91c2-09946306b59e",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7791-8b3f-d4206701ca8a",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7827-8795-66c8a058d49c": {
			"id": "01972fff-1079-7827-8795-66c8a058d49c",
			"batchWeighingId": "01972fff-1077-7aac-91c2-09946306b59e",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e92-8c88-0ca0d3695405",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-72b5-9c42-73e78da44592": {
			"id": "01972fff-1079-72b5-9c42-73e78da44592",
			"batchWeighingId": "01972fff-1077-7aac-91c2-09946306b59e",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b00-b171-5d7dca8bad24",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-726f-a8bd-578d428b8ab8": {
			"id": "01972fff-1079-726f-a8bd-578d428b8ab8",
			"batchWeighingId": "01972fff-1077-7aac-91c2-09946306b59e",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7cb5-9b6b-584a83e4fa96",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-764e-89d3-057d29d98606": {
			"id": "01972fff-1078-764e-89d3-057d29d98606",
			"batchWeighingId": "01972fff-1077-7d86-b83f-f9696e491126",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c5a-8407-dfd45f9b13be",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-743e-9ffb-2b22f025e3ad": {
			"id": "01972fff-1078-743e-9ffb-2b22f025e3ad",
			"batchWeighingId": "01972fff-1077-7d86-b83f-f9696e491126",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-70da-8dbd-231ca75278c2",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7ea9-840f-222f5afeec28": {
			"id": "01972fff-1078-7ea9-840f-222f5afeec28",
			"batchWeighingId": "01972fff-1077-7d86-b83f-f9696e491126",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7440-a0ba-9c08606f2a20",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-739e-b690-9726ce9e77a5": {
			"id": "01972fff-1078-739e-b690-9726ce9e77a5",
			"batchWeighingId": "01972fff-1077-7d86-b83f-f9696e491126",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b91-9a5e-901bc6790db4",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7947-ba8b-53afd3572587": {
			"id": "01972fff-1078-7947-ba8b-53afd3572587",
			"batchWeighingId": "01972fff-1077-7d86-b83f-f9696e491126",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d17-976e-1c4a59fe50cf",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-71a1-8ea4-67321e592dcc": {
			"id": "01972fff-1078-71a1-8ea4-67321e592dcc",
			"batchWeighingId": "01972fff-1077-7d86-b83f-f9696e491126",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e57-ae47-50e29926c1da",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-75b3-a645-81d7383a4f95": {
			"id": "01972fff-1078-75b3-a645-81d7383a4f95",
			"batchWeighingId": "01972fff-1077-7d86-b83f-f9696e491126",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7af3-8559-3a60c752184c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7e40-8182-74f88eddb3fb": {
			"id": "01972fff-1078-7e40-8182-74f88eddb3fb",
			"batchWeighingId": "01972fff-1077-7d86-b83f-f9696e491126",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f40-82c8-df11c4507261",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-789a-843e-aa03027b376d": {
			"id": "01972fff-1078-789a-843e-aa03027b376d",
			"batchWeighingId": "01972fff-1077-7d86-b83f-f9696e491126",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bbe-92ae-b7a8cb3f4256",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7240-8a6f-0b568b956f07": {
			"id": "01972fff-1078-7240-8a6f-0b568b956f07",
			"batchWeighingId": "01972fff-1077-7d86-b83f-f9696e491126",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-70c9-a367-822ddf7ab517",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-74f5-87be-f76c4e3e4ca1": {
			"id": "01972fff-1078-74f5-87be-f76c4e3e4ca1",
			"batchWeighingId": "01972fff-1077-7d86-b83f-f9696e491126",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f84-ae7e-b13efb25ca6c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-743b-a617-7c6cdcb7feb4": {
			"id": "01972fff-1078-743b-a617-7c6cdcb7feb4",
			"batchWeighingId": "01972fff-1077-7d86-b83f-f9696e491126",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-79ed-b1c7-97f006625806",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-752f-8b37-7d3d96bf3367": {
			"id": "01972fff-1079-752f-8b37-7d3d96bf3367",
			"batchWeighingId": "01972fff-1077-727e-80a9-67dc4565d96f",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c5a-8407-dfd45f9b13be",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7311-87bd-a41bc69cf5b3": {
			"id": "01972fff-1079-7311-87bd-a41bc69cf5b3",
			"batchWeighingId": "01972fff-1077-727e-80a9-67dc4565d96f",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-70da-8dbd-231ca75278c2",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7e24-8060-146c9adddc35": {
			"id": "01972fff-1079-7e24-8060-146c9adddc35",
			"batchWeighingId": "01972fff-1077-727e-80a9-67dc4565d96f",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7440-a0ba-9c08606f2a20",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7f6a-a5e6-6accc8c95d99": {
			"id": "01972fff-1079-7f6a-a5e6-6accc8c95d99",
			"batchWeighingId": "01972fff-1077-727e-80a9-67dc4565d96f",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b91-9a5e-901bc6790db4",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-759b-91b3-76c31967f15d": {
			"id": "01972fff-1079-759b-91b3-76c31967f15d",
			"batchWeighingId": "01972fff-1077-727e-80a9-67dc4565d96f",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d17-976e-1c4a59fe50cf",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-73ca-a5d7-cdbea5bc55ba": {
			"id": "01972fff-1079-73ca-a5d7-cdbea5bc55ba",
			"batchWeighingId": "01972fff-1077-727e-80a9-67dc4565d96f",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e57-ae47-50e29926c1da",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7998-b7bd-f72dbcc38a56": {
			"id": "01972fff-1079-7998-b7bd-f72dbcc38a56",
			"batchWeighingId": "01972fff-1077-727e-80a9-67dc4565d96f",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7af3-8559-3a60c752184c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-79bb-9788-451390a8a25e": {
			"id": "01972fff-1079-79bb-9788-451390a8a25e",
			"batchWeighingId": "01972fff-1077-727e-80a9-67dc4565d96f",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f40-82c8-df11c4507261",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7a8d-a3d1-628b41a82755": {
			"id": "01972fff-1079-7a8d-a3d1-628b41a82755",
			"batchWeighingId": "01972fff-1077-727e-80a9-67dc4565d96f",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bbe-92ae-b7a8cb3f4256",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7e6d-a37e-7d229906ecfc": {
			"id": "01972fff-1079-7e6d-a37e-7d229906ecfc",
			"batchWeighingId": "01972fff-1077-727e-80a9-67dc4565d96f",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-70c9-a367-822ddf7ab517",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7351-b83f-89fa97ec11ae": {
			"id": "01972fff-1079-7351-b83f-89fa97ec11ae",
			"batchWeighingId": "01972fff-1077-727e-80a9-67dc4565d96f",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f84-ae7e-b13efb25ca6c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7887-b582-070730d5f16c": {
			"id": "01972fff-1079-7887-b582-070730d5f16c",
			"batchWeighingId": "01972fff-1077-727e-80a9-67dc4565d96f",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-79ed-b1c7-97f006625806",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7338-ac86-00d7bd1dc4de": {
			"id": "01972fff-1078-7338-ac86-00d7bd1dc4de",
			"batchWeighingId": "01972fff-1077-77c4-8a9a-69f6d20da473",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-738c-8002-80530c1c9c58",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7ec1-810e-9a5ab8ec6674": {
			"id": "01972fff-1078-7ec1-810e-9a5ab8ec6674",
			"batchWeighingId": "01972fff-1077-77c4-8a9a-69f6d20da473",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7760-95c3-b5bd6aa3f3d5",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-78db-888c-ddda037fe5cb": {
			"id": "01972fff-1078-78db-888c-ddda037fe5cb",
			"batchWeighingId": "01972fff-1077-77c4-8a9a-69f6d20da473",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7dae-b37e-ea59d076c941",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-78c0-b535-b7681cada048": {
			"id": "01972fff-1078-78c0-b535-b7681cada048",
			"batchWeighingId": "01972fff-1077-77c4-8a9a-69f6d20da473",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7975-8e6f-bae9f8a73b89",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7032-9fda-dfee17286619": {
			"id": "01972fff-1078-7032-9fda-dfee17286619",
			"batchWeighingId": "01972fff-1077-77c4-8a9a-69f6d20da473",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c74-9543-da36591e073c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-74dc-a87b-198d9fc24f79": {
			"id": "01972fff-1078-74dc-a87b-198d9fc24f79",
			"batchWeighingId": "01972fff-1077-77c4-8a9a-69f6d20da473",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f11-88c2-2496ae669d38",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7702-937c-d58a5eef7dc4": {
			"id": "01972fff-1078-7702-937c-d58a5eef7dc4",
			"batchWeighingId": "01972fff-1077-77c4-8a9a-69f6d20da473",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-764a-a8eb-861dc377f79c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7c7c-a1c9-4285d367ce57": {
			"id": "01972fff-1078-7c7c-a1c9-4285d367ce57",
			"batchWeighingId": "01972fff-1077-77c4-8a9a-69f6d20da473",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-73de-87e3-d46cdbe0c1fc",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-74c7-8e81-9871938cdb17": {
			"id": "01972fff-1078-74c7-8e81-9871938cdb17",
			"batchWeighingId": "01972fff-1077-77c4-8a9a-69f6d20da473",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-719c-936d-d0f6c8cd8310",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7865-8548-3c63f845bdaf": {
			"id": "01972fff-1078-7865-8548-3c63f845bdaf",
			"batchWeighingId": "01972fff-1077-77c4-8a9a-69f6d20da473",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7fef-b3f5-90e7bf54b8a8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7afe-94ae-70a545bb1822": {
			"id": "01972fff-1078-7afe-94ae-70a545bb1822",
			"batchWeighingId": "01972fff-1077-77c4-8a9a-69f6d20da473",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-70e9-a49e-1ebd31ce20ff",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7d6b-981e-8d06c72b2066": {
			"id": "01972fff-1078-7d6b-981e-8d06c72b2066",
			"batchWeighingId": "01972fff-1077-77c4-8a9a-69f6d20da473",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7519-a311-5f7ab4f7711e",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-700a-9357-1332da030723": {
			"id": "01972fff-1079-700a-9357-1332da030723",
			"batchWeighingId": "01972fff-1077-75d6-939a-1def7970604d",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-738c-8002-80530c1c9c58",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-76bf-9d7e-d2685bc36e0f": {
			"id": "01972fff-1079-76bf-9d7e-d2685bc36e0f",
			"batchWeighingId": "01972fff-1077-75d6-939a-1def7970604d",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7760-95c3-b5bd6aa3f3d5",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7ad5-aad8-597d1f5e8865": {
			"id": "01972fff-1079-7ad5-aad8-597d1f5e8865",
			"batchWeighingId": "01972fff-1077-75d6-939a-1def7970604d",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7dae-b37e-ea59d076c941",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-710a-9f62-90d883b1a1ab": {
			"id": "01972fff-1079-710a-9f62-90d883b1a1ab",
			"batchWeighingId": "01972fff-1077-75d6-939a-1def7970604d",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7975-8e6f-bae9f8a73b89",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7415-ab87-d3b7f6277b52": {
			"id": "01972fff-1079-7415-ab87-d3b7f6277b52",
			"batchWeighingId": "01972fff-1077-75d6-939a-1def7970604d",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c74-9543-da36591e073c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-73a0-a31c-349223ded67e": {
			"id": "01972fff-1079-73a0-a31c-349223ded67e",
			"batchWeighingId": "01972fff-1077-75d6-939a-1def7970604d",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f11-88c2-2496ae669d38",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-740f-8199-4faa1e8d2da1": {
			"id": "01972fff-1079-740f-8199-4faa1e8d2da1",
			"batchWeighingId": "01972fff-1077-75d6-939a-1def7970604d",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-764a-a8eb-861dc377f79c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-77d6-ac43-69dc738de478": {
			"id": "01972fff-1079-77d6-ac43-69dc738de478",
			"batchWeighingId": "01972fff-1077-75d6-939a-1def7970604d",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-73de-87e3-d46cdbe0c1fc",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7c2a-a383-08c83611a3d3": {
			"id": "01972fff-1079-7c2a-a383-08c83611a3d3",
			"batchWeighingId": "01972fff-1077-75d6-939a-1def7970604d",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-719c-936d-d0f6c8cd8310",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7bae-beb6-c5b344962e5d": {
			"id": "01972fff-1079-7bae-beb6-c5b344962e5d",
			"batchWeighingId": "01972fff-1077-75d6-939a-1def7970604d",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7fef-b3f5-90e7bf54b8a8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7caf-984c-06c68c929beb": {
			"id": "01972fff-1079-7caf-984c-06c68c929beb",
			"batchWeighingId": "01972fff-1077-75d6-939a-1def7970604d",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-70e9-a49e-1ebd31ce20ff",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7e42-a247-98209326dece": {
			"id": "01972fff-1079-7e42-a247-98209326dece",
			"batchWeighingId": "01972fff-1077-75d6-939a-1def7970604d",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7519-a311-5f7ab4f7711e",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7924-aa81-3f49a8e9bf34": {
			"id": "01972fff-1078-7924-aa81-3f49a8e9bf34",
			"batchWeighingId": "01972fff-1077-768f-a955-afa738b49925",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7eba-9776-82691d10b223",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-74fd-88ec-332e7e753c87": {
			"id": "01972fff-1078-74fd-88ec-332e7e753c87",
			"batchWeighingId": "01972fff-1077-768f-a955-afa738b49925",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ab5-b24d-428d7d28ce64",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7530-adcb-8c69c48ec1dc": {
			"id": "01972fff-1078-7530-adcb-8c69c48ec1dc",
			"batchWeighingId": "01972fff-1077-768f-a955-afa738b49925",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7417-939c-f98b0727e8e2",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7517-8d69-b773097b3326": {
			"id": "01972fff-1078-7517-8d69-b773097b3326",
			"batchWeighingId": "01972fff-1077-768f-a955-afa738b49925",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7312-8ebe-b2c789cd0651",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-75da-baca-72b9994ee0bc": {
			"id": "01972fff-1078-75da-baca-72b9994ee0bc",
			"batchWeighingId": "01972fff-1077-768f-a955-afa738b49925",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7a0b-bef2-e3752acd058c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-785d-8e05-db808ff8158b": {
			"id": "01972fff-1078-785d-8e05-db808ff8158b",
			"batchWeighingId": "01972fff-1077-768f-a955-afa738b49925",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-735b-a125-253a52f704a3",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-76fa-8246-239c8514b378": {
			"id": "01972fff-1078-76fa-8246-239c8514b378",
			"batchWeighingId": "01972fff-1077-768f-a955-afa738b49925",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b25-990f-8dead42552b1",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-744d-bb43-c35dd90d286d": {
			"id": "01972fff-1078-744d-bb43-c35dd90d286d",
			"batchWeighingId": "01972fff-1077-768f-a955-afa738b49925",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7506-b926-195a1917c8ee",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7297-a911-f5952af89560": {
			"id": "01972fff-1078-7297-a911-f5952af89560",
			"batchWeighingId": "01972fff-1077-768f-a955-afa738b49925",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f48-895d-81d248190670",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7f26-925f-98b3abd84a9e": {
			"id": "01972fff-1078-7f26-925f-98b3abd84a9e",
			"batchWeighingId": "01972fff-1077-768f-a955-afa738b49925",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-75f4-b9c1-70879f2393e8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7df3-a61b-6581b2871179": {
			"id": "01972fff-1078-7df3-a61b-6581b2871179",
			"batchWeighingId": "01972fff-1077-768f-a955-afa738b49925",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7038-9b04-c008ec5447da",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7009-a6e2-ea5048f6815d": {
			"id": "01972fff-1078-7009-a6e2-ea5048f6815d",
			"batchWeighingId": "01972fff-1077-768f-a955-afa738b49925",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-763e-a057-586b9f940469",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7e2e-897e-49799b9cb741": {
			"id": "01972fff-1079-7e2e-897e-49799b9cb741",
			"batchWeighingId": "01972fff-1077-7a01-a92c-cbd729031f79",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7eba-9776-82691d10b223",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-76fb-b30b-58ee1292dbb9": {
			"id": "01972fff-1079-76fb-b30b-58ee1292dbb9",
			"batchWeighingId": "01972fff-1077-7a01-a92c-cbd729031f79",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ab5-b24d-428d7d28ce64",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7d80-b0d2-2ef91c80ec57": {
			"id": "01972fff-1079-7d80-b0d2-2ef91c80ec57",
			"batchWeighingId": "01972fff-1077-7a01-a92c-cbd729031f79",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7417-939c-f98b0727e8e2",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7d64-b460-639ff563c0df": {
			"id": "01972fff-1079-7d64-b460-639ff563c0df",
			"batchWeighingId": "01972fff-1077-7a01-a92c-cbd729031f79",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7312-8ebe-b2c789cd0651",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7202-939a-1896ec3c46e2": {
			"id": "01972fff-1079-7202-939a-1896ec3c46e2",
			"batchWeighingId": "01972fff-1077-7a01-a92c-cbd729031f79",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7a0b-bef2-e3752acd058c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7a29-9602-c3671b0f7a90": {
			"id": "01972fff-1079-7a29-9602-c3671b0f7a90",
			"batchWeighingId": "01972fff-1077-7a01-a92c-cbd729031f79",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-735b-a125-253a52f704a3",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7154-90af-b762b583687e": {
			"id": "01972fff-1079-7154-90af-b762b583687e",
			"batchWeighingId": "01972fff-1077-7a01-a92c-cbd729031f79",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b25-990f-8dead42552b1",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-71d9-ba9d-b977f5cfa70a": {
			"id": "01972fff-1079-71d9-ba9d-b977f5cfa70a",
			"batchWeighingId": "01972fff-1077-7a01-a92c-cbd729031f79",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7506-b926-195a1917c8ee",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-72d2-96e7-4a6ec6458113": {
			"id": "01972fff-1079-72d2-96e7-4a6ec6458113",
			"batchWeighingId": "01972fff-1077-7a01-a92c-cbd729031f79",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f48-895d-81d248190670",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7a0f-ac51-1b8303d2bc53": {
			"id": "01972fff-1079-7a0f-ac51-1b8303d2bc53",
			"batchWeighingId": "01972fff-1077-7a01-a92c-cbd729031f79",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-75f4-b9c1-70879f2393e8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7466-a16f-1742c2168102": {
			"id": "01972fff-1079-7466-a16f-1742c2168102",
			"batchWeighingId": "01972fff-1077-7a01-a92c-cbd729031f79",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7038-9b04-c008ec5447da",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7da0-add5-c60c96f90b3a": {
			"id": "01972fff-1079-7da0-add5-c60c96f90b3a",
			"batchWeighingId": "01972fff-1077-7a01-a92c-cbd729031f79",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-763e-a057-586b9f940469",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7bef-91c9-ac269b45b220": {
			"id": "01972fff-1078-7bef-91c9-ac269b45b220",
			"batchWeighingId": "01972fff-1077-7729-8cc1-f1446313d9cb",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7cc0-8f09-74e5c8d3e0c8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7e82-8dc7-16df05f8b690": {
			"id": "01972fff-1078-7e82-8dc7-16df05f8b690",
			"batchWeighingId": "01972fff-1077-7729-8cc1-f1446313d9cb",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72a9-9660-c9530e27c9c4",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7a25-b5c4-3aa3381ae78d": {
			"id": "01972fff-1078-7a25-b5c4-3aa3381ae78d",
			"batchWeighingId": "01972fff-1077-7729-8cc1-f1446313d9cb",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c80-b927-c4dd6a802201",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7bc9-befd-26daba2af040": {
			"id": "01972fff-1078-7bc9-befd-26daba2af040",
			"batchWeighingId": "01972fff-1077-7729-8cc1-f1446313d9cb",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7de0-a2c2-04b18d96cf1c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-73cf-a563-4671a4314afa": {
			"id": "01972fff-1078-73cf-a563-4671a4314afa",
			"batchWeighingId": "01972fff-1077-7729-8cc1-f1446313d9cb",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-78e4-bf20-7df89055c146",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7c9d-82cf-f98450ed183c": {
			"id": "01972fff-1078-7c9d-82cf-f98450ed183c",
			"batchWeighingId": "01972fff-1077-7729-8cc1-f1446313d9cb",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bb2-9afa-2aaca02d4cd1",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7485-8bbc-4c6d5e786edc": {
			"id": "01972fff-1078-7485-8bbc-4c6d5e786edc",
			"batchWeighingId": "01972fff-1077-7729-8cc1-f1446313d9cb",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-73a5-a585-dbd6c2beaca5",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-79d7-ae40-dc2cda2081e3": {
			"id": "01972fff-1078-79d7-ae40-dc2cda2081e3",
			"batchWeighingId": "01972fff-1077-7729-8cc1-f1446313d9cb",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e0c-8e4a-4574c3d0def1",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7f7d-98f1-7cc0475fcaec": {
			"id": "01972fff-1078-7f7d-98f1-7cc0475fcaec",
			"batchWeighingId": "01972fff-1077-7729-8cc1-f1446313d9cb",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b5c-b9c3-a8646cef2411",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-79d8-8fba-f5b5cdbb9033": {
			"id": "01972fff-1078-79d8-8fba-f5b5cdbb9033",
			"batchWeighingId": "01972fff-1077-7729-8cc1-f1446313d9cb",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bf7-9a2d-255c32e6bab6",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7d0d-9996-89f58d0391e6": {
			"id": "01972fff-1078-7d0d-9996-89f58d0391e6",
			"batchWeighingId": "01972fff-1077-7729-8cc1-f1446313d9cb",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-77e5-8abc-31b7064e18f9",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7c7c-a764-410f90837df4": {
			"id": "01972fff-1078-7c7c-a764-410f90837df4",
			"batchWeighingId": "01972fff-1077-7729-8cc1-f1446313d9cb",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-79c5-85e8-41ce5450a00e",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-740a-bd79-8158547fc691": {
			"id": "01972fff-1078-740a-bd79-8158547fc691",
			"batchWeighingId": "01972fff-1077-7729-8cc1-f1446313d9cb",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7254-9a40-bce0b6095f36",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7891-ad14-d953b3728ab2": {
			"id": "01972fff-1078-7891-ad14-d953b3728ab2",
			"batchWeighingId": "01972fff-1077-7729-8cc1-f1446313d9cb",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7de7-b6c1-f86afe274a36",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7aa2-a17c-48f50bfb55e0": {
			"id": "01972fff-1078-7aa2-a17c-48f50bfb55e0",
			"batchWeighingId": "01972fff-1077-7729-8cc1-f1446313d9cb",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e91-85c6-54515cbe68e8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-741c-a54c-24c40907dee8": {
			"id": "01972fff-1078-741c-a54c-24c40907dee8",
			"batchWeighingId": "01972fff-1077-7729-8cc1-f1446313d9cb",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7eac-bd4c-8e83837951e7",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7bca-b420-29a24d5a5321": {
			"id": "01972fff-1078-7bca-b420-29a24d5a5321",
			"batchWeighingId": "01972fff-1077-7729-8cc1-f1446313d9cb",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f7f-be3e-d0da05b69a77",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-73d6-a402-027a3e5e5928": {
			"id": "01972fff-1078-73d6-a402-027a3e5e5928",
			"batchWeighingId": "01972fff-1077-7729-8cc1-f1446313d9cb",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-76b4-be3e-26e9330abc8c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-733f-93b4-94e4fa6e7860": {
			"id": "01972fff-1079-733f-93b4-94e4fa6e7860",
			"batchWeighingId": "01972fff-1077-75b7-9b00-84389ba8aa3c",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7cc0-8f09-74e5c8d3e0c8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7e03-8038-9495ab94415c": {
			"id": "01972fff-1079-7e03-8038-9495ab94415c",
			"batchWeighingId": "01972fff-1077-75b7-9b00-84389ba8aa3c",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72a9-9660-c9530e27c9c4",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-76c4-8d49-8aee8ce0475f": {
			"id": "01972fff-1079-76c4-8d49-8aee8ce0475f",
			"batchWeighingId": "01972fff-1077-75b7-9b00-84389ba8aa3c",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c80-b927-c4dd6a802201",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7c9e-ac0d-b177a950c313": {
			"id": "01972fff-1079-7c9e-ac0d-b177a950c313",
			"batchWeighingId": "01972fff-1077-75b7-9b00-84389ba8aa3c",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7de0-a2c2-04b18d96cf1c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7f29-848c-ff18bf1d9334": {
			"id": "01972fff-1079-7f29-848c-ff18bf1d9334",
			"batchWeighingId": "01972fff-1077-75b7-9b00-84389ba8aa3c",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-78e4-bf20-7df89055c146",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-78e7-b437-ada1c534aad8": {
			"id": "01972fff-1079-78e7-b437-ada1c534aad8",
			"batchWeighingId": "01972fff-1077-75b7-9b00-84389ba8aa3c",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bb2-9afa-2aaca02d4cd1",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-768d-9b70-8e9fd1ca9591": {
			"id": "01972fff-1079-768d-9b70-8e9fd1ca9591",
			"batchWeighingId": "01972fff-1077-75b7-9b00-84389ba8aa3c",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-73a5-a585-dbd6c2beaca5",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7856-811b-dd6d7d69b8f3": {
			"id": "01972fff-1079-7856-811b-dd6d7d69b8f3",
			"batchWeighingId": "01972fff-1077-75b7-9b00-84389ba8aa3c",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e0c-8e4a-4574c3d0def1",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-75ff-aa8e-3ce382674495": {
			"id": "01972fff-1079-75ff-aa8e-3ce382674495",
			"batchWeighingId": "01972fff-1077-75b7-9b00-84389ba8aa3c",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b5c-b9c3-a8646cef2411",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7629-8f63-24658792e4df": {
			"id": "01972fff-1079-7629-8f63-24658792e4df",
			"batchWeighingId": "01972fff-1077-75b7-9b00-84389ba8aa3c",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bf7-9a2d-255c32e6bab6",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7674-af37-e91d2f4689af": {
			"id": "01972fff-1079-7674-af37-e91d2f4689af",
			"batchWeighingId": "01972fff-1077-75b7-9b00-84389ba8aa3c",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-77e5-8abc-31b7064e18f9",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-719d-a120-28cb7f309135": {
			"id": "01972fff-1079-719d-a120-28cb7f309135",
			"batchWeighingId": "01972fff-1077-75b7-9b00-84389ba8aa3c",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-79c5-85e8-41ce5450a00e",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7978-9999-053aab7ce61b": {
			"id": "01972fff-1079-7978-9999-053aab7ce61b",
			"batchWeighingId": "01972fff-1077-75b7-9b00-84389ba8aa3c",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7254-9a40-bce0b6095f36",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7b18-b9f7-a6e3be1defbe": {
			"id": "01972fff-1079-7b18-b9f7-a6e3be1defbe",
			"batchWeighingId": "01972fff-1077-75b7-9b00-84389ba8aa3c",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7de7-b6c1-f86afe274a36",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7c90-8184-e4e1cfe52416": {
			"id": "01972fff-1079-7c90-8184-e4e1cfe52416",
			"batchWeighingId": "01972fff-1077-75b7-9b00-84389ba8aa3c",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e91-85c6-54515cbe68e8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-75ed-b178-251226677a58": {
			"id": "01972fff-1079-75ed-b178-251226677a58",
			"batchWeighingId": "01972fff-1077-75b7-9b00-84389ba8aa3c",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7eac-bd4c-8e83837951e7",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-79ef-bedc-119d8ed35e25": {
			"id": "01972fff-1079-79ef-bedc-119d8ed35e25",
			"batchWeighingId": "01972fff-1077-75b7-9b00-84389ba8aa3c",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f7f-be3e-d0da05b69a77",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-773c-89ab-a7fdab8c9322": {
			"id": "01972fff-1079-773c-89ab-a7fdab8c9322",
			"batchWeighingId": "01972fff-1077-75b7-9b00-84389ba8aa3c",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-76b4-be3e-26e9330abc8c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7c92-bb0f-626c1d47805f": {
			"id": "01972fff-1078-7c92-bb0f-626c1d47805f",
			"batchWeighingId": "01972fff-1077-7626-8fb6-3025ecdae2e0",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d52-8551-bea41c2d42b7",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7355-82be-57b39c528dc1": {
			"id": "01972fff-1078-7355-82be-57b39c528dc1",
			"batchWeighingId": "01972fff-1077-7626-8fb6-3025ecdae2e0",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-706f-9aff-3adda18d98cc",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-726f-9ab4-696b69e093a3": {
			"id": "01972fff-1078-726f-9ab4-696b69e093a3",
			"batchWeighingId": "01972fff-1077-7626-8fb6-3025ecdae2e0",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-77b4-94ec-f73a7ffeb862",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7c00-ae08-5a02e4b02c08": {
			"id": "01972fff-1078-7c00-ae08-5a02e4b02c08",
			"batchWeighingId": "01972fff-1077-7626-8fb6-3025ecdae2e0",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d7d-9eca-281a03d35c29",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7a7c-ba3a-3ffa7ea09357": {
			"id": "01972fff-1078-7a7c-ba3a-3ffa7ea09357",
			"batchWeighingId": "01972fff-1077-7626-8fb6-3025ecdae2e0",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7183-94ca-d5898205c039",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7ff5-9b67-68a53a588b34": {
			"id": "01972fff-1078-7ff5-9b67-68a53a588b34",
			"batchWeighingId": "01972fff-1077-7626-8fb6-3025ecdae2e0",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-705b-ad87-dfc04abf7f79",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7b1a-a64f-22491eabc139": {
			"id": "01972fff-1078-7b1a-a64f-22491eabc139",
			"batchWeighingId": "01972fff-1077-7626-8fb6-3025ecdae2e0",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-700c-a74d-921798039d33",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7d22-be03-603de570b3a4": {
			"id": "01972fff-1078-7d22-be03-603de570b3a4",
			"batchWeighingId": "01972fff-1077-7626-8fb6-3025ecdae2e0",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-743a-807e-8525fbe3ddf6",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7431-a15c-cc348335ac79": {
			"id": "01972fff-1078-7431-a15c-cc348335ac79",
			"batchWeighingId": "01972fff-1077-7626-8fb6-3025ecdae2e0",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c55-ac86-4f1b8ea1eddd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-74bf-92f1-2d3b6907118e": {
			"id": "01972fff-1078-74bf-92f1-2d3b6907118e",
			"batchWeighingId": "01972fff-1077-7626-8fb6-3025ecdae2e0",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-705c-a42a-57982cfdaf67",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7e1e-a54c-a618bd214aa6": {
			"id": "01972fff-1078-7e1e-a54c-a618bd214aa6",
			"batchWeighingId": "01972fff-1077-7626-8fb6-3025ecdae2e0",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-760e-a723-6e0f16df5266",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7a07-830d-b88b36a7fcbf": {
			"id": "01972fff-1078-7a07-830d-b88b36a7fcbf",
			"batchWeighingId": "01972fff-1077-7626-8fb6-3025ecdae2e0",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7070-a724-9868e4e676ac",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7333-b9a1-c216395ad18a": {
			"id": "01972fff-1078-7333-b9a1-c216395ad18a",
			"batchWeighingId": "01972fff-1077-7626-8fb6-3025ecdae2e0",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7397-a4ac-2d286c030acb",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-775c-817a-2076fcfc3edc": {
			"id": "01972fff-1078-775c-817a-2076fcfc3edc",
			"batchWeighingId": "01972fff-1077-7626-8fb6-3025ecdae2e0",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-791f-a265-9cdd4121d220",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-72a6-9a44-19d0d31aeabb": {
			"id": "01972fff-1078-72a6-9a44-19d0d31aeabb",
			"batchWeighingId": "01972fff-1077-7626-8fb6-3025ecdae2e0",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ba2-84f7-ab4adbfeaf6b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7cdc-86ba-81c3b7610d03": {
			"id": "01972fff-1078-7cdc-86ba-81c3b7610d03",
			"batchWeighingId": "01972fff-1077-7626-8fb6-3025ecdae2e0",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7543-9639-80c738150ab9",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7678-9f86-dc316396e156": {
			"id": "01972fff-1078-7678-9f86-dc316396e156",
			"batchWeighingId": "01972fff-1077-7626-8fb6-3025ecdae2e0",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-758f-8ad0-025a138f650a",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7a64-97fa-137be9347063": {
			"id": "01972fff-1078-7a64-97fa-137be9347063",
			"batchWeighingId": "01972fff-1077-7626-8fb6-3025ecdae2e0",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-753e-b982-ef834631ddce",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-709b-9fe4-3180da814c94": {
			"id": "01972fff-1079-709b-9fe4-3180da814c94",
			"batchWeighingId": "01972fff-1077-7baf-b620-3863e7fb3583",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d52-8551-bea41c2d42b7",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7dcf-806c-59df6abdb022": {
			"id": "01972fff-1079-7dcf-806c-59df6abdb022",
			"batchWeighingId": "01972fff-1077-7baf-b620-3863e7fb3583",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-706f-9aff-3adda18d98cc",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7ef2-8ddb-ce7980e3e705": {
			"id": "01972fff-1079-7ef2-8ddb-ce7980e3e705",
			"batchWeighingId": "01972fff-1077-7baf-b620-3863e7fb3583",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-77b4-94ec-f73a7ffeb862",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7937-bf1c-210f61ecfa2f": {
			"id": "01972fff-1079-7937-bf1c-210f61ecfa2f",
			"batchWeighingId": "01972fff-1077-7baf-b620-3863e7fb3583",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d7d-9eca-281a03d35c29",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-74bf-b5e5-6b119f160316": {
			"id": "01972fff-1079-74bf-b5e5-6b119f160316",
			"batchWeighingId": "01972fff-1077-7baf-b620-3863e7fb3583",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7183-94ca-d5898205c039",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7024-aaa9-864c720e5877": {
			"id": "01972fff-1079-7024-aaa9-864c720e5877",
			"batchWeighingId": "01972fff-1077-7baf-b620-3863e7fb3583",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-705b-ad87-dfc04abf7f79",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7ef4-8502-67fd1bc9a859": {
			"id": "01972fff-1079-7ef4-8502-67fd1bc9a859",
			"batchWeighingId": "01972fff-1077-7baf-b620-3863e7fb3583",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-700c-a74d-921798039d33",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7c3f-a8ea-dee19b1d0b72": {
			"id": "01972fff-1079-7c3f-a8ea-dee19b1d0b72",
			"batchWeighingId": "01972fff-1077-7baf-b620-3863e7fb3583",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-743a-807e-8525fbe3ddf6",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7e91-a29c-d1a89c7e1160": {
			"id": "01972fff-1079-7e91-a29c-d1a89c7e1160",
			"batchWeighingId": "01972fff-1077-7baf-b620-3863e7fb3583",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c55-ac86-4f1b8ea1eddd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7131-87d5-370fc366e62b": {
			"id": "01972fff-1079-7131-87d5-370fc366e62b",
			"batchWeighingId": "01972fff-1077-7baf-b620-3863e7fb3583",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-705c-a42a-57982cfdaf67",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-75bd-83b4-f7081d755db3": {
			"id": "01972fff-1079-75bd-83b4-f7081d755db3",
			"batchWeighingId": "01972fff-1077-7baf-b620-3863e7fb3583",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-760e-a723-6e0f16df5266",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7f49-8fb5-36b873f686bd": {
			"id": "01972fff-1079-7f49-8fb5-36b873f686bd",
			"batchWeighingId": "01972fff-1077-7baf-b620-3863e7fb3583",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7070-a724-9868e4e676ac",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-74fe-974d-8343ab35464f": {
			"id": "01972fff-1079-74fe-974d-8343ab35464f",
			"batchWeighingId": "01972fff-1077-7baf-b620-3863e7fb3583",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7397-a4ac-2d286c030acb",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7b19-9949-3d21c031927c": {
			"id": "01972fff-1079-7b19-9949-3d21c031927c",
			"batchWeighingId": "01972fff-1077-7baf-b620-3863e7fb3583",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-791f-a265-9cdd4121d220",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7d1b-bf58-ea57a012101d": {
			"id": "01972fff-1079-7d1b-bf58-ea57a012101d",
			"batchWeighingId": "01972fff-1077-7baf-b620-3863e7fb3583",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ba2-84f7-ab4adbfeaf6b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7ea8-a08d-ca1970595d03": {
			"id": "01972fff-1079-7ea8-a08d-ca1970595d03",
			"batchWeighingId": "01972fff-1077-7baf-b620-3863e7fb3583",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7543-9639-80c738150ab9",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7018-8892-ca4691ee309e": {
			"id": "01972fff-1079-7018-8892-ca4691ee309e",
			"batchWeighingId": "01972fff-1077-7baf-b620-3863e7fb3583",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-758f-8ad0-025a138f650a",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-709f-aea8-a56e3b64c358": {
			"id": "01972fff-1079-709f-aea8-a56e3b64c358",
			"batchWeighingId": "01972fff-1077-7baf-b620-3863e7fb3583",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-753e-b982-ef834631ddce",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7f10-a908-df053ec67172": {
			"id": "01972fff-1078-7f10-a908-df053ec67172",
			"batchWeighingId": "01972fff-1077-709d-9017-9fa9b924fb13",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7588-8948-d019938cabcf",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-78d1-aeac-f6499a0eb311": {
			"id": "01972fff-1078-78d1-aeac-f6499a0eb311",
			"batchWeighingId": "01972fff-1077-709d-9017-9fa9b924fb13",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7793-be98-5b3a0f57f68c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7a0c-8894-fe184137cb84": {
			"id": "01972fff-1078-7a0c-8894-fe184137cb84",
			"batchWeighingId": "01972fff-1077-709d-9017-9fa9b924fb13",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7fd5-87a6-05a93ab71b2f",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7ec8-a24f-bf218b25c768": {
			"id": "01972fff-1078-7ec8-a24f-bf218b25c768",
			"batchWeighingId": "01972fff-1077-709d-9017-9fa9b924fb13",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7aaa-99a1-c17c58bbf637",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7ff8-b6dd-a95ae9c27489": {
			"id": "01972fff-1078-7ff8-b6dd-a95ae9c27489",
			"batchWeighingId": "01972fff-1077-709d-9017-9fa9b924fb13",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-756e-a1fc-12f249a87226",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-700e-90cd-2dc1442d46e5": {
			"id": "01972fff-1078-700e-90cd-2dc1442d46e5",
			"batchWeighingId": "01972fff-1077-709d-9017-9fa9b924fb13",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-74ee-8acd-2950986e209b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7068-9afb-b882d250d383": {
			"id": "01972fff-1078-7068-9afb-b882d250d383",
			"batchWeighingId": "01972fff-1077-709d-9017-9fa9b924fb13",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-759a-b3bf-d087463fcac5",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-77f1-a314-5d6927acd181": {
			"id": "01972fff-1078-77f1-a314-5d6927acd181",
			"batchWeighingId": "01972fff-1077-709d-9017-9fa9b924fb13",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72f7-9fd9-51851a3f6e0e",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7a98-b683-064b6062b2b5": {
			"id": "01972fff-1078-7a98-b683-064b6062b2b5",
			"batchWeighingId": "01972fff-1077-709d-9017-9fa9b924fb13",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-73af-b25b-4244838049fd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7167-951f-26ee43265ab5": {
			"id": "01972fff-1078-7167-951f-26ee43265ab5",
			"batchWeighingId": "01972fff-1077-709d-9017-9fa9b924fb13",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f8d-a674-968ede5f4929",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7ab9-ba6a-7aaa2be7dccf": {
			"id": "01972fff-1078-7ab9-ba6a-7aaa2be7dccf",
			"batchWeighingId": "01972fff-1077-709d-9017-9fa9b924fb13",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ebd-ba0d-78821fa95a34",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7fd4-ab1f-319adde4495d": {
			"id": "01972fff-1078-7fd4-ab1f-319adde4495d",
			"batchWeighingId": "01972fff-1077-709d-9017-9fa9b924fb13",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-715e-ada5-30bf34cd667d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7435-a3fe-1e125a4ad0ce": {
			"id": "01972fff-1078-7435-a3fe-1e125a4ad0ce",
			"batchWeighingId": "01972fff-1077-709d-9017-9fa9b924fb13",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-78b6-888f-d279b7ab60bd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7694-8b61-194d0e96b021": {
			"id": "01972fff-1078-7694-8b61-194d0e96b021",
			"batchWeighingId": "01972fff-1077-709d-9017-9fa9b924fb13",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-735a-b9e6-ec3de3e1594a",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-79ac-b064-dbe8df25dcb1": {
			"id": "01972fff-1078-79ac-b064-dbe8df25dcb1",
			"batchWeighingId": "01972fff-1077-709d-9017-9fa9b924fb13",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e69-975a-290d0743efef",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7042-81d0-5e2de2847a26": {
			"id": "01972fff-1078-7042-81d0-5e2de2847a26",
			"batchWeighingId": "01972fff-1077-709d-9017-9fa9b924fb13",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-786d-8513-0664c3ccad98",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7602-91b0-04b54fb499fa": {
			"id": "01972fff-1078-7602-91b0-04b54fb499fa",
			"batchWeighingId": "01972fff-1077-709d-9017-9fa9b924fb13",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7db6-ac89-92b6bcde462b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7ef1-bb74-d594ef5757e2": {
			"id": "01972fff-1078-7ef1-bb74-d594ef5757e2",
			"batchWeighingId": "01972fff-1077-709d-9017-9fa9b924fb13",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7cd8-b9b2-b52c2dd90d20",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7b65-9aec-caf312bfdd16": {
			"id": "01972fff-1079-7b65-9aec-caf312bfdd16",
			"batchWeighingId": "01972fff-1077-726f-bb62-c5d2e419050d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7588-8948-d019938cabcf",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7106-a61b-aec7699903fd": {
			"id": "01972fff-1079-7106-a61b-aec7699903fd",
			"batchWeighingId": "01972fff-1077-726f-bb62-c5d2e419050d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7793-be98-5b3a0f57f68c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-781d-86fc-9535f7eb16a8": {
			"id": "01972fff-1079-781d-86fc-9535f7eb16a8",
			"batchWeighingId": "01972fff-1077-726f-bb62-c5d2e419050d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7fd5-87a6-05a93ab71b2f",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7136-afc8-50c81e053bfe": {
			"id": "01972fff-1079-7136-afc8-50c81e053bfe",
			"batchWeighingId": "01972fff-1077-726f-bb62-c5d2e419050d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7aaa-99a1-c17c58bbf637",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7dd3-adef-213b77ddb0f6": {
			"id": "01972fff-1079-7dd3-adef-213b77ddb0f6",
			"batchWeighingId": "01972fff-1077-726f-bb62-c5d2e419050d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-756e-a1fc-12f249a87226",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-767f-a89a-eab934602c78": {
			"id": "01972fff-1079-767f-a89a-eab934602c78",
			"batchWeighingId": "01972fff-1077-726f-bb62-c5d2e419050d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-74ee-8acd-2950986e209b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7d77-8fc0-b404cd690f35": {
			"id": "01972fff-1079-7d77-8fc0-b404cd690f35",
			"batchWeighingId": "01972fff-1077-726f-bb62-c5d2e419050d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-759a-b3bf-d087463fcac5",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7d31-a51a-799c1db838db": {
			"id": "01972fff-1079-7d31-a51a-799c1db838db",
			"batchWeighingId": "01972fff-1077-726f-bb62-c5d2e419050d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72f7-9fd9-51851a3f6e0e",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7902-8f9c-94b28a39a74f": {
			"id": "01972fff-1079-7902-8f9c-94b28a39a74f",
			"batchWeighingId": "01972fff-1077-726f-bb62-c5d2e419050d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-73af-b25b-4244838049fd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7cac-b344-e94617db6449": {
			"id": "01972fff-1079-7cac-b344-e94617db6449",
			"batchWeighingId": "01972fff-1077-726f-bb62-c5d2e419050d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f8d-a674-968ede5f4929",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7511-b1b9-e824744a5c36": {
			"id": "01972fff-1079-7511-b1b9-e824744a5c36",
			"batchWeighingId": "01972fff-1077-726f-bb62-c5d2e419050d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ebd-ba0d-78821fa95a34",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-77e9-9546-d64bb3052180": {
			"id": "01972fff-1079-77e9-9546-d64bb3052180",
			"batchWeighingId": "01972fff-1077-726f-bb62-c5d2e419050d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-715e-ada5-30bf34cd667d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-726a-98a4-6d213c9e933c": {
			"id": "01972fff-1079-726a-98a4-6d213c9e933c",
			"batchWeighingId": "01972fff-1077-726f-bb62-c5d2e419050d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-78b6-888f-d279b7ab60bd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-76ad-b8fe-5aecbb48ddeb": {
			"id": "01972fff-1079-76ad-b8fe-5aecbb48ddeb",
			"batchWeighingId": "01972fff-1077-726f-bb62-c5d2e419050d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-735a-b9e6-ec3de3e1594a",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-713b-a03f-e0ce0a545589": {
			"id": "01972fff-1079-713b-a03f-e0ce0a545589",
			"batchWeighingId": "01972fff-1077-726f-bb62-c5d2e419050d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e69-975a-290d0743efef",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7a7c-8c1b-7717551a1c75": {
			"id": "01972fff-1079-7a7c-8c1b-7717551a1c75",
			"batchWeighingId": "01972fff-1077-726f-bb62-c5d2e419050d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-786d-8513-0664c3ccad98",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7faf-960e-54f5a7676c30": {
			"id": "01972fff-1079-7faf-960e-54f5a7676c30",
			"batchWeighingId": "01972fff-1077-726f-bb62-c5d2e419050d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7db6-ac89-92b6bcde462b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-73fa-898c-4ac9701d8f41": {
			"id": "01972fff-1079-73fa-898c-4ac9701d8f41",
			"batchWeighingId": "01972fff-1077-726f-bb62-c5d2e419050d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7cd8-b9b2-b52c2dd90d20",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7e6b-bb4d-59b784a41766": {
			"id": "01972fff-1078-7e6b-bb4d-59b784a41766",
			"batchWeighingId": "01972fff-1077-76d2-a82f-cee00eebeb52",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72d3-8b30-e0ab83e8d37d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7b57-9907-d8431fda9428": {
			"id": "01972fff-1078-7b57-9907-d8431fda9428",
			"batchWeighingId": "01972fff-1077-76d2-a82f-cee00eebeb52",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ac9-b2dd-13c1750b4fac",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7b63-b52b-fe5610f9bab2": {
			"id": "01972fff-1078-7b63-b52b-fe5610f9bab2",
			"batchWeighingId": "01972fff-1077-76d2-a82f-cee00eebeb52",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7220-8bd9-19935e9b4527",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7281-a0d6-5d6e823d7998": {
			"id": "01972fff-1078-7281-a0d6-5d6e823d7998",
			"batchWeighingId": "01972fff-1077-76d2-a82f-cee00eebeb52",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7251-ad3c-0cf9dfddd06c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7092-a709-9a30e7628c96": {
			"id": "01972fff-1078-7092-a709-9a30e7628c96",
			"batchWeighingId": "01972fff-1077-76d2-a82f-cee00eebeb52",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-756f-b159-cc0612f285c8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7a66-884e-16a5657180de": {
			"id": "01972fff-1078-7a66-884e-16a5657180de",
			"batchWeighingId": "01972fff-1077-76d2-a82f-cee00eebeb52",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72fa-bf32-652bf5bf8d5b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-738b-9efb-327946505655": {
			"id": "01972fff-1078-738b-9efb-327946505655",
			"batchWeighingId": "01972fff-1077-76d2-a82f-cee00eebeb52",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-736b-850a-0f073660b996",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7336-9905-94d28796169d": {
			"id": "01972fff-1078-7336-9905-94d28796169d",
			"batchWeighingId": "01972fff-1077-76d2-a82f-cee00eebeb52",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-769c-977d-a08eba7e9622",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7a32-8efe-8a0392957669": {
			"id": "01972fff-1078-7a32-8efe-8a0392957669",
			"batchWeighingId": "01972fff-1077-76d2-a82f-cee00eebeb52",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7834-b8ae-bbf502ec6115",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7455-b924-4e123944f9ec": {
			"id": "01972fff-1078-7455-b924-4e123944f9ec",
			"batchWeighingId": "01972fff-1077-76d2-a82f-cee00eebeb52",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-725a-9159-dcc67d810756",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7811-9adf-2022645fae13": {
			"id": "01972fff-1078-7811-9adf-2022645fae13",
			"batchWeighingId": "01972fff-1077-76d2-a82f-cee00eebeb52",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ca3-9f3b-9c24d52fcf77",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7cd3-bff2-83bb5191e221": {
			"id": "01972fff-1078-7cd3-bff2-83bb5191e221",
			"batchWeighingId": "01972fff-1077-76d2-a82f-cee00eebeb52",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7baa-9842-af256f4506e0",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-77fd-898b-e81b98ad14a7": {
			"id": "01972fff-1078-77fd-898b-e81b98ad14a7",
			"batchWeighingId": "01972fff-1077-76d2-a82f-cee00eebeb52",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-741f-83bf-c4acd2f30d37",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-73a3-af45-33c178f1daaf": {
			"id": "01972fff-1078-73a3-af45-33c178f1daaf",
			"batchWeighingId": "01972fff-1077-76d2-a82f-cee00eebeb52",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-704e-bfa5-366faf7530bd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7374-ae25-98639186caac": {
			"id": "01972fff-1078-7374-ae25-98639186caac",
			"batchWeighingId": "01972fff-1077-76d2-a82f-cee00eebeb52",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7293-be3c-09d702091eda",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7165-b3a4-be77de85b1a8": {
			"id": "01972fff-1078-7165-b3a4-be77de85b1a8",
			"batchWeighingId": "01972fff-1077-76d2-a82f-cee00eebeb52",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b4b-8037-8939efa37fc3",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7be6-a35c-486e57036383": {
			"id": "01972fff-1078-7be6-a35c-486e57036383",
			"batchWeighingId": "01972fff-1077-76d2-a82f-cee00eebeb52",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7542-b533-b57facd55fc7",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-771a-a7b6-929878ecafee": {
			"id": "01972fff-1078-771a-a7b6-929878ecafee",
			"batchWeighingId": "01972fff-1077-76d2-a82f-cee00eebeb52",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7fbc-af18-3cdac7a0cc1d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7655-a470-4853e5cdf2cb": {
			"id": "01972fff-1079-7655-a470-4853e5cdf2cb",
			"batchWeighingId": "01972fff-1077-7fc9-ac9c-ad32c3d8fe97",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72d3-8b30-e0ab83e8d37d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-709a-a060-5c4bcccdecf7": {
			"id": "01972fff-1079-709a-a060-5c4bcccdecf7",
			"batchWeighingId": "01972fff-1077-7fc9-ac9c-ad32c3d8fe97",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ac9-b2dd-13c1750b4fac",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-74df-87ff-ed972534520d": {
			"id": "01972fff-1079-74df-87ff-ed972534520d",
			"batchWeighingId": "01972fff-1077-7fc9-ac9c-ad32c3d8fe97",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7220-8bd9-19935e9b4527",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7ab3-883f-53c3637337b9": {
			"id": "01972fff-1079-7ab3-883f-53c3637337b9",
			"batchWeighingId": "01972fff-1077-7fc9-ac9c-ad32c3d8fe97",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7251-ad3c-0cf9dfddd06c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-75a3-92be-7eb73715d8e6": {
			"id": "01972fff-1079-75a3-92be-7eb73715d8e6",
			"batchWeighingId": "01972fff-1077-7fc9-ac9c-ad32c3d8fe97",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-756f-b159-cc0612f285c8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7afa-957b-5a988e568aa1": {
			"id": "01972fff-1079-7afa-957b-5a988e568aa1",
			"batchWeighingId": "01972fff-1077-7fc9-ac9c-ad32c3d8fe97",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72fa-bf32-652bf5bf8d5b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7972-a551-d820eb532706": {
			"id": "01972fff-1079-7972-a551-d820eb532706",
			"batchWeighingId": "01972fff-1077-7fc9-ac9c-ad32c3d8fe97",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-736b-850a-0f073660b996",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-708c-ae42-985f7c9afebf": {
			"id": "01972fff-1079-708c-ae42-985f7c9afebf",
			"batchWeighingId": "01972fff-1077-7fc9-ac9c-ad32c3d8fe97",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-769c-977d-a08eba7e9622",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-72b9-abfa-ed9a6188d1bb": {
			"id": "01972fff-1079-72b9-abfa-ed9a6188d1bb",
			"batchWeighingId": "01972fff-1077-7fc9-ac9c-ad32c3d8fe97",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7834-b8ae-bbf502ec6115",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7edc-8f12-bb85a692517e": {
			"id": "01972fff-1079-7edc-8f12-bb85a692517e",
			"batchWeighingId": "01972fff-1077-7fc9-ac9c-ad32c3d8fe97",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-725a-9159-dcc67d810756",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7ae6-a3d1-13beedc9c382": {
			"id": "01972fff-1079-7ae6-a3d1-13beedc9c382",
			"batchWeighingId": "01972fff-1077-7fc9-ac9c-ad32c3d8fe97",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ca3-9f3b-9c24d52fcf77",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-726b-8ed7-4d326cf1a4d8": {
			"id": "01972fff-1079-726b-8ed7-4d326cf1a4d8",
			"batchWeighingId": "01972fff-1077-7fc9-ac9c-ad32c3d8fe97",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7baa-9842-af256f4506e0",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7e23-8581-6f5074b44f92": {
			"id": "01972fff-1079-7e23-8581-6f5074b44f92",
			"batchWeighingId": "01972fff-1077-7fc9-ac9c-ad32c3d8fe97",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-741f-83bf-c4acd2f30d37",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7308-a722-84069fc5dff6": {
			"id": "01972fff-1079-7308-a722-84069fc5dff6",
			"batchWeighingId": "01972fff-1077-7fc9-ac9c-ad32c3d8fe97",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-704e-bfa5-366faf7530bd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-70cd-bf24-cefb0a4cd5c9": {
			"id": "01972fff-1079-70cd-bf24-cefb0a4cd5c9",
			"batchWeighingId": "01972fff-1077-7fc9-ac9c-ad32c3d8fe97",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7293-be3c-09d702091eda",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-758c-b753-6aa84b0b5abe": {
			"id": "01972fff-1079-758c-b753-6aa84b0b5abe",
			"batchWeighingId": "01972fff-1077-7fc9-ac9c-ad32c3d8fe97",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b4b-8037-8939efa37fc3",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-78bb-9af9-805a94378f40": {
			"id": "01972fff-1079-78bb-9af9-805a94378f40",
			"batchWeighingId": "01972fff-1077-7fc9-ac9c-ad32c3d8fe97",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7542-b533-b57facd55fc7",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7094-ac45-6db47f85ee4a": {
			"id": "01972fff-1079-7094-ac45-6db47f85ee4a",
			"batchWeighingId": "01972fff-1077-7fc9-ac9c-ad32c3d8fe97",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7fbc-af18-3cdac7a0cc1d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-73c5-8d7a-cb22f0011ce3": {
			"id": "01972fff-1078-73c5-8d7a-cb22f0011ce3",
			"batchWeighingId": "01972fff-1077-7929-9ef9-5968d1f0ae8f",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-791f-8133-0da1c1775cc1",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-76f3-ab87-c76a01448e35": {
			"id": "01972fff-1078-76f3-ab87-c76a01448e35",
			"batchWeighingId": "01972fff-1077-7929-9ef9-5968d1f0ae8f",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-785f-a996-3528e8721a65",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7c28-8391-a5890416a4e1": {
			"id": "01972fff-1078-7c28-8391-a5890416a4e1",
			"batchWeighingId": "01972fff-1077-7929-9ef9-5968d1f0ae8f",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-76fa-b086-05bdfdf5ceac",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-75dc-8e1e-42e13c2f8414": {
			"id": "01972fff-1078-75dc-8e1e-42e13c2f8414",
			"batchWeighingId": "01972fff-1077-7929-9ef9-5968d1f0ae8f",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-759d-aee4-7ef4826f8848",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7057-b199-80ea76aa9808": {
			"id": "01972fff-1078-7057-b199-80ea76aa9808",
			"batchWeighingId": "01972fff-1077-7929-9ef9-5968d1f0ae8f",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-747b-8adb-bd455ba79531",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7026-b1ef-597da8ef1ff7": {
			"id": "01972fff-1078-7026-b1ef-597da8ef1ff7",
			"batchWeighingId": "01972fff-1077-7929-9ef9-5968d1f0ae8f",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d0e-ae8e-266abac6fb6c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7daf-bcd9-3acf56878661": {
			"id": "01972fff-1078-7daf-bcd9-3acf56878661",
			"batchWeighingId": "01972fff-1077-7929-9ef9-5968d1f0ae8f",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7183-9ac0-fde99a456d9e",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7e8b-8461-445585a9f25e": {
			"id": "01972fff-1078-7e8b-8461-445585a9f25e",
			"batchWeighingId": "01972fff-1077-7929-9ef9-5968d1f0ae8f",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bf4-bbb1-08943a23cb9d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-759c-85ed-8734116abc24": {
			"id": "01972fff-1078-759c-85ed-8734116abc24",
			"batchWeighingId": "01972fff-1077-7929-9ef9-5968d1f0ae8f",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7791-8b3f-d4206701ca8a",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7990-95fa-1dfc6a2c0ba2": {
			"id": "01972fff-1078-7990-95fa-1dfc6a2c0ba2",
			"batchWeighingId": "01972fff-1077-7929-9ef9-5968d1f0ae8f",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e92-8c88-0ca0d3695405",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-788e-b6dd-84ece37ad91b": {
			"id": "01972fff-1078-788e-b6dd-84ece37ad91b",
			"batchWeighingId": "01972fff-1077-7929-9ef9-5968d1f0ae8f",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b00-b171-5d7dca8bad24",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7215-8b24-9733be49416c": {
			"id": "01972fff-1078-7215-8b24-9733be49416c",
			"batchWeighingId": "01972fff-1077-7929-9ef9-5968d1f0ae8f",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7cb5-9b6b-584a83e4fa96",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-725b-9319-388910597c37": {
			"id": "01972fff-1079-725b-9319-388910597c37",
			"batchWeighingId": "01972fff-1077-7bdd-adf5-05236192d8b6",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-791f-8133-0da1c1775cc1",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7156-9443-ca5a80e1d75e": {
			"id": "01972fff-1079-7156-9443-ca5a80e1d75e",
			"batchWeighingId": "01972fff-1077-7bdd-adf5-05236192d8b6",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-785f-a996-3528e8721a65",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7167-b3e9-76c52c3ed7d6": {
			"id": "01972fff-1079-7167-b3e9-76c52c3ed7d6",
			"batchWeighingId": "01972fff-1077-7bdd-adf5-05236192d8b6",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-76fa-b086-05bdfdf5ceac",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-70aa-a03c-5644664c8337": {
			"id": "01972fff-1079-70aa-a03c-5644664c8337",
			"batchWeighingId": "01972fff-1077-7bdd-adf5-05236192d8b6",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-759d-aee4-7ef4826f8848",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-78a3-ad22-79f582af97d5": {
			"id": "01972fff-1079-78a3-ad22-79f582af97d5",
			"batchWeighingId": "01972fff-1077-7bdd-adf5-05236192d8b6",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-747b-8adb-bd455ba79531",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7f88-a9ff-a06fb8b047e0": {
			"id": "01972fff-1079-7f88-a9ff-a06fb8b047e0",
			"batchWeighingId": "01972fff-1077-7bdd-adf5-05236192d8b6",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d0e-ae8e-266abac6fb6c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-74b7-9d28-f00298911704": {
			"id": "01972fff-1079-74b7-9d28-f00298911704",
			"batchWeighingId": "01972fff-1077-7bdd-adf5-05236192d8b6",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7183-9ac0-fde99a456d9e",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7ecb-8d62-75893defbc98": {
			"id": "01972fff-1079-7ecb-8d62-75893defbc98",
			"batchWeighingId": "01972fff-1077-7bdd-adf5-05236192d8b6",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bf4-bbb1-08943a23cb9d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-726c-9338-091db8e35bc7": {
			"id": "01972fff-1079-726c-9338-091db8e35bc7",
			"batchWeighingId": "01972fff-1077-7bdd-adf5-05236192d8b6",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7791-8b3f-d4206701ca8a",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-756d-aefc-6eb072da6b0c": {
			"id": "01972fff-1079-756d-aefc-6eb072da6b0c",
			"batchWeighingId": "01972fff-1077-7bdd-adf5-05236192d8b6",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e92-8c88-0ca0d3695405",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-767d-8d39-8c4a31adfcd9": {
			"id": "01972fff-1079-767d-8d39-8c4a31adfcd9",
			"batchWeighingId": "01972fff-1077-7bdd-adf5-05236192d8b6",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b00-b171-5d7dca8bad24",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7ace-88ab-3018ae759bac": {
			"id": "01972fff-1079-7ace-88ab-3018ae759bac",
			"batchWeighingId": "01972fff-1077-7bdd-adf5-05236192d8b6",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7cb5-9b6b-584a83e4fa96",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7e80-8051-dde09ed01c58": {
			"id": "01972fff-1078-7e80-8051-dde09ed01c58",
			"batchWeighingId": "01972fff-1077-7fde-9d4b-ca3f4a76dbd4",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c5a-8407-dfd45f9b13be",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-71d2-ac07-b9714d89e06d": {
			"id": "01972fff-1078-71d2-ac07-b9714d89e06d",
			"batchWeighingId": "01972fff-1077-7fde-9d4b-ca3f4a76dbd4",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-70da-8dbd-231ca75278c2",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7dca-abc5-40464c93158f": {
			"id": "01972fff-1078-7dca-abc5-40464c93158f",
			"batchWeighingId": "01972fff-1077-7fde-9d4b-ca3f4a76dbd4",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7440-a0ba-9c08606f2a20",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-70f8-8c07-0d0ca2ae932a": {
			"id": "01972fff-1078-70f8-8c07-0d0ca2ae932a",
			"batchWeighingId": "01972fff-1077-7fde-9d4b-ca3f4a76dbd4",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b91-9a5e-901bc6790db4",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-745b-a9d8-36614ba22dc8": {
			"id": "01972fff-1078-745b-a9d8-36614ba22dc8",
			"batchWeighingId": "01972fff-1077-7fde-9d4b-ca3f4a76dbd4",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d17-976e-1c4a59fe50cf",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7936-8c20-ee5579f1ea30": {
			"id": "01972fff-1078-7936-8c20-ee5579f1ea30",
			"batchWeighingId": "01972fff-1077-7fde-9d4b-ca3f4a76dbd4",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e57-ae47-50e29926c1da",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7272-9744-f775859974ed": {
			"id": "01972fff-1078-7272-9744-f775859974ed",
			"batchWeighingId": "01972fff-1077-7fde-9d4b-ca3f4a76dbd4",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7af3-8559-3a60c752184c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-721e-8652-2f007ddf8444": {
			"id": "01972fff-1078-721e-8652-2f007ddf8444",
			"batchWeighingId": "01972fff-1077-7fde-9d4b-ca3f4a76dbd4",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f40-82c8-df11c4507261",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-77f5-82f5-067ddc36825b": {
			"id": "01972fff-1078-77f5-82f5-067ddc36825b",
			"batchWeighingId": "01972fff-1077-7fde-9d4b-ca3f4a76dbd4",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bbe-92ae-b7a8cb3f4256",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-77f4-9636-981aaf4f3ac7": {
			"id": "01972fff-1078-77f4-9636-981aaf4f3ac7",
			"batchWeighingId": "01972fff-1077-7fde-9d4b-ca3f4a76dbd4",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-70c9-a367-822ddf7ab517",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7a8d-bec3-d4ae6df8dd09": {
			"id": "01972fff-1078-7a8d-bec3-d4ae6df8dd09",
			"batchWeighingId": "01972fff-1077-7fde-9d4b-ca3f4a76dbd4",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f84-ae7e-b13efb25ca6c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7e69-92ea-0b2849148323": {
			"id": "01972fff-1078-7e69-92ea-0b2849148323",
			"batchWeighingId": "01972fff-1077-7fde-9d4b-ca3f4a76dbd4",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-79ed-b1c7-97f006625806",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-766d-abe1-cd8712ae29cb": {
			"id": "01972fff-1079-766d-abe1-cd8712ae29cb",
			"batchWeighingId": "01972fff-1077-7306-88cc-0740b056a341",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c5a-8407-dfd45f9b13be",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-74fb-970d-7c46c263859b": {
			"id": "01972fff-1079-74fb-970d-7c46c263859b",
			"batchWeighingId": "01972fff-1077-7306-88cc-0740b056a341",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-70da-8dbd-231ca75278c2",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7d98-8393-1e51c86323f5": {
			"id": "01972fff-1079-7d98-8393-1e51c86323f5",
			"batchWeighingId": "01972fff-1077-7306-88cc-0740b056a341",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7440-a0ba-9c08606f2a20",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7d0c-b1c6-6fd78aaad863": {
			"id": "01972fff-1079-7d0c-b1c6-6fd78aaad863",
			"batchWeighingId": "01972fff-1077-7306-88cc-0740b056a341",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b91-9a5e-901bc6790db4",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7114-ad29-7b8f8379e8f1": {
			"id": "01972fff-1079-7114-ad29-7b8f8379e8f1",
			"batchWeighingId": "01972fff-1077-7306-88cc-0740b056a341",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d17-976e-1c4a59fe50cf",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-70dd-9442-ef422addbd98": {
			"id": "01972fff-1079-70dd-9442-ef422addbd98",
			"batchWeighingId": "01972fff-1077-7306-88cc-0740b056a341",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e57-ae47-50e29926c1da",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7e1a-a053-de35405f662d": {
			"id": "01972fff-1079-7e1a-a053-de35405f662d",
			"batchWeighingId": "01972fff-1077-7306-88cc-0740b056a341",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7af3-8559-3a60c752184c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-76bb-b60d-38029176d1fd": {
			"id": "01972fff-1079-76bb-b60d-38029176d1fd",
			"batchWeighingId": "01972fff-1077-7306-88cc-0740b056a341",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f40-82c8-df11c4507261",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7c03-90d2-e2bd20f680cd": {
			"id": "01972fff-1079-7c03-90d2-e2bd20f680cd",
			"batchWeighingId": "01972fff-1077-7306-88cc-0740b056a341",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bbe-92ae-b7a8cb3f4256",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-73d7-82a8-3b882efe3a63": {
			"id": "01972fff-1079-73d7-82a8-3b882efe3a63",
			"batchWeighingId": "01972fff-1077-7306-88cc-0740b056a341",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-70c9-a367-822ddf7ab517",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-76ce-9615-dca6b88cedd1": {
			"id": "01972fff-1079-76ce-9615-dca6b88cedd1",
			"batchWeighingId": "01972fff-1077-7306-88cc-0740b056a341",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f84-ae7e-b13efb25ca6c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-777c-a88d-309c84c36016": {
			"id": "01972fff-1079-777c-a88d-309c84c36016",
			"batchWeighingId": "01972fff-1077-7306-88cc-0740b056a341",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-79ed-b1c7-97f006625806",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7cc2-9d6b-3df96df00526": {
			"id": "01972fff-1078-7cc2-9d6b-3df96df00526",
			"batchWeighingId": "01972fff-1077-7f61-b727-3d4d92f17810",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-738c-8002-80530c1c9c58",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7b9b-a914-9331193d97d1": {
			"id": "01972fff-1078-7b9b-a914-9331193d97d1",
			"batchWeighingId": "01972fff-1077-7f61-b727-3d4d92f17810",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7760-95c3-b5bd6aa3f3d5",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7297-898c-a1131b02540b": {
			"id": "01972fff-1078-7297-898c-a1131b02540b",
			"batchWeighingId": "01972fff-1077-7f61-b727-3d4d92f17810",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7dae-b37e-ea59d076c941",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7564-813a-b11adfaaa227": {
			"id": "01972fff-1078-7564-813a-b11adfaaa227",
			"batchWeighingId": "01972fff-1077-7f61-b727-3d4d92f17810",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7975-8e6f-bae9f8a73b89",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7dae-9f01-468ecb82b99d": {
			"id": "01972fff-1078-7dae-9f01-468ecb82b99d",
			"batchWeighingId": "01972fff-1077-7f61-b727-3d4d92f17810",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c74-9543-da36591e073c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7464-b896-2c541073b18d": {
			"id": "01972fff-1078-7464-b896-2c541073b18d",
			"batchWeighingId": "01972fff-1077-7f61-b727-3d4d92f17810",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f11-88c2-2496ae669d38",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-709a-be7d-ed8fa393e273": {
			"id": "01972fff-1078-709a-be7d-ed8fa393e273",
			"batchWeighingId": "01972fff-1077-7f61-b727-3d4d92f17810",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-764a-a8eb-861dc377f79c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-776c-827f-88df6e209122": {
			"id": "01972fff-1078-776c-827f-88df6e209122",
			"batchWeighingId": "01972fff-1077-7f61-b727-3d4d92f17810",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-73de-87e3-d46cdbe0c1fc",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7e21-a185-a3d6c66ed379": {
			"id": "01972fff-1078-7e21-a185-a3d6c66ed379",
			"batchWeighingId": "01972fff-1077-7f61-b727-3d4d92f17810",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-719c-936d-d0f6c8cd8310",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7133-8dee-86eb8684169a": {
			"id": "01972fff-1078-7133-8dee-86eb8684169a",
			"batchWeighingId": "01972fff-1077-7f61-b727-3d4d92f17810",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7fef-b3f5-90e7bf54b8a8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7cc6-9a5d-5b90e58a3243": {
			"id": "01972fff-1078-7cc6-9a5d-5b90e58a3243",
			"batchWeighingId": "01972fff-1077-7f61-b727-3d4d92f17810",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-70e9-a49e-1ebd31ce20ff",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7157-8c0d-412ca8cd73e9": {
			"id": "01972fff-1078-7157-8c0d-412ca8cd73e9",
			"batchWeighingId": "01972fff-1077-7f61-b727-3d4d92f17810",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7519-a311-5f7ab4f7711e",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-787f-8e72-8aa049089cdd": {
			"id": "01972fff-1079-787f-8e72-8aa049089cdd",
			"batchWeighingId": "01972fff-1077-73ef-8555-802367637495",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-738c-8002-80530c1c9c58",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7b82-ad61-36dbf871cdca": {
			"id": "01972fff-1079-7b82-ad61-36dbf871cdca",
			"batchWeighingId": "01972fff-1077-73ef-8555-802367637495",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7760-95c3-b5bd6aa3f3d5",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-79df-b49a-c9e6ccb8c662": {
			"id": "01972fff-1079-79df-b49a-c9e6ccb8c662",
			"batchWeighingId": "01972fff-1077-73ef-8555-802367637495",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7dae-b37e-ea59d076c941",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7c40-8507-0c6719d5c1bf": {
			"id": "01972fff-1079-7c40-8507-0c6719d5c1bf",
			"batchWeighingId": "01972fff-1077-73ef-8555-802367637495",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7975-8e6f-bae9f8a73b89",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7520-ae6d-21984f20570b": {
			"id": "01972fff-1079-7520-ae6d-21984f20570b",
			"batchWeighingId": "01972fff-1077-73ef-8555-802367637495",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c74-9543-da36591e073c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7a5b-834c-a93e3e1f42e4": {
			"id": "01972fff-1079-7a5b-834c-a93e3e1f42e4",
			"batchWeighingId": "01972fff-1077-73ef-8555-802367637495",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f11-88c2-2496ae669d38",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7751-9c21-881e9c248a9c": {
			"id": "01972fff-1079-7751-9c21-881e9c248a9c",
			"batchWeighingId": "01972fff-1077-73ef-8555-802367637495",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-764a-a8eb-861dc377f79c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-73f9-8263-c624da0b308f": {
			"id": "01972fff-1079-73f9-8263-c624da0b308f",
			"batchWeighingId": "01972fff-1077-73ef-8555-802367637495",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-73de-87e3-d46cdbe0c1fc",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7fda-8cf7-76dae948bc58": {
			"id": "01972fff-1079-7fda-8cf7-76dae948bc58",
			"batchWeighingId": "01972fff-1077-73ef-8555-802367637495",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-719c-936d-d0f6c8cd8310",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7030-81f3-c96e45ba88ef": {
			"id": "01972fff-1079-7030-81f3-c96e45ba88ef",
			"batchWeighingId": "01972fff-1077-73ef-8555-802367637495",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7fef-b3f5-90e7bf54b8a8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7e76-a6ef-0eef972ef310": {
			"id": "01972fff-1079-7e76-a6ef-0eef972ef310",
			"batchWeighingId": "01972fff-1077-73ef-8555-802367637495",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-70e9-a49e-1ebd31ce20ff",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-71e8-b63e-68f5b99dca19": {
			"id": "01972fff-1079-71e8-b63e-68f5b99dca19",
			"batchWeighingId": "01972fff-1077-73ef-8555-802367637495",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7519-a311-5f7ab4f7711e",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-75b6-b7fe-0dadb3fdc18b": {
			"id": "01972fff-1078-75b6-b7fe-0dadb3fdc18b",
			"batchWeighingId": "01972fff-1077-75a9-9407-8e3f301005f9",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7eba-9776-82691d10b223",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7c86-b3c0-ec38004d6530": {
			"id": "01972fff-1078-7c86-b3c0-ec38004d6530",
			"batchWeighingId": "01972fff-1077-75a9-9407-8e3f301005f9",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ab5-b24d-428d7d28ce64",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-78f0-9d2b-f6cac6c152bc": {
			"id": "01972fff-1078-78f0-9d2b-f6cac6c152bc",
			"batchWeighingId": "01972fff-1077-75a9-9407-8e3f301005f9",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7417-939c-f98b0727e8e2",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-79df-aa06-960c6eb15b49": {
			"id": "01972fff-1078-79df-aa06-960c6eb15b49",
			"batchWeighingId": "01972fff-1077-75a9-9407-8e3f301005f9",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7312-8ebe-b2c789cd0651",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-74d2-aa10-1f2b3256c5dd": {
			"id": "01972fff-1078-74d2-aa10-1f2b3256c5dd",
			"batchWeighingId": "01972fff-1077-75a9-9407-8e3f301005f9",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7a0b-bef2-e3752acd058c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7b9d-b584-0f2f4d06ecb8": {
			"id": "01972fff-1078-7b9d-b584-0f2f4d06ecb8",
			"batchWeighingId": "01972fff-1077-75a9-9407-8e3f301005f9",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-735b-a125-253a52f704a3",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-75d9-82c9-574dcdd02236": {
			"id": "01972fff-1078-75d9-82c9-574dcdd02236",
			"batchWeighingId": "01972fff-1077-75a9-9407-8e3f301005f9",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b25-990f-8dead42552b1",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7c39-9fd0-8f91a8d30398": {
			"id": "01972fff-1078-7c39-9fd0-8f91a8d30398",
			"batchWeighingId": "01972fff-1077-75a9-9407-8e3f301005f9",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7506-b926-195a1917c8ee",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-79e1-8528-2248ca264448": {
			"id": "01972fff-1078-79e1-8528-2248ca264448",
			"batchWeighingId": "01972fff-1077-75a9-9407-8e3f301005f9",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f48-895d-81d248190670",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-74ef-a0c8-59b1404d93ae": {
			"id": "01972fff-1078-74ef-a0c8-59b1404d93ae",
			"batchWeighingId": "01972fff-1077-75a9-9407-8e3f301005f9",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-75f4-b9c1-70879f2393e8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7bff-bfe7-248b9bd433d9": {
			"id": "01972fff-1078-7bff-bfe7-248b9bd433d9",
			"batchWeighingId": "01972fff-1077-75a9-9407-8e3f301005f9",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7038-9b04-c008ec5447da",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7169-834c-3390ea25b15a": {
			"id": "01972fff-1078-7169-834c-3390ea25b15a",
			"batchWeighingId": "01972fff-1077-75a9-9407-8e3f301005f9",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-763e-a057-586b9f940469",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7477-b4b9-cca441f08c13": {
			"id": "01972fff-1079-7477-b4b9-cca441f08c13",
			"batchWeighingId": "01972fff-1077-7091-99b1-7e6487ef5312",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7eba-9776-82691d10b223",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7613-898d-e4e31459ab4b": {
			"id": "01972fff-1079-7613-898d-e4e31459ab4b",
			"batchWeighingId": "01972fff-1077-7091-99b1-7e6487ef5312",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ab5-b24d-428d7d28ce64",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7ee1-a1bf-caf4ffc46fa2": {
			"id": "01972fff-1079-7ee1-a1bf-caf4ffc46fa2",
			"batchWeighingId": "01972fff-1077-7091-99b1-7e6487ef5312",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7417-939c-f98b0727e8e2",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7c28-8109-9f70ee5ad86d": {
			"id": "01972fff-1079-7c28-8109-9f70ee5ad86d",
			"batchWeighingId": "01972fff-1077-7091-99b1-7e6487ef5312",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7312-8ebe-b2c789cd0651",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7067-9007-718feedaa60e": {
			"id": "01972fff-1079-7067-9007-718feedaa60e",
			"batchWeighingId": "01972fff-1077-7091-99b1-7e6487ef5312",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7a0b-bef2-e3752acd058c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-71a7-ac89-a1490e2b6bd2": {
			"id": "01972fff-1079-71a7-ac89-a1490e2b6bd2",
			"batchWeighingId": "01972fff-1077-7091-99b1-7e6487ef5312",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-735b-a125-253a52f704a3",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7bd9-b969-49ab07b6d7dd": {
			"id": "01972fff-1079-7bd9-b969-49ab07b6d7dd",
			"batchWeighingId": "01972fff-1077-7091-99b1-7e6487ef5312",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b25-990f-8dead42552b1",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7433-af01-1074dffe1774": {
			"id": "01972fff-1079-7433-af01-1074dffe1774",
			"batchWeighingId": "01972fff-1077-7091-99b1-7e6487ef5312",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7506-b926-195a1917c8ee",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7c36-87d7-b0a86f52f221": {
			"id": "01972fff-1079-7c36-87d7-b0a86f52f221",
			"batchWeighingId": "01972fff-1077-7091-99b1-7e6487ef5312",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f48-895d-81d248190670",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7730-ac3f-abb4999b9a79": {
			"id": "01972fff-1079-7730-ac3f-abb4999b9a79",
			"batchWeighingId": "01972fff-1077-7091-99b1-7e6487ef5312",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-75f4-b9c1-70879f2393e8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7cf9-85a4-d46c1c44ea1a": {
			"id": "01972fff-1079-7cf9-85a4-d46c1c44ea1a",
			"batchWeighingId": "01972fff-1077-7091-99b1-7e6487ef5312",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7038-9b04-c008ec5447da",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7dd4-8c4b-b42173875fe7": {
			"id": "01972fff-1079-7dd4-8c4b-b42173875fe7",
			"batchWeighingId": "01972fff-1077-7091-99b1-7e6487ef5312",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-763e-a057-586b9f940469",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-794f-ae67-5494c19d8f3a": {
			"id": "01972fff-1078-794f-ae67-5494c19d8f3a",
			"batchWeighingId": "01972fff-1077-792a-b295-a3a819f5db54",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7cc0-8f09-74e5c8d3e0c8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7bd3-8108-a7d864629bf2": {
			"id": "01972fff-1078-7bd3-8108-a7d864629bf2",
			"batchWeighingId": "01972fff-1077-792a-b295-a3a819f5db54",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72a9-9660-c9530e27c9c4",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7252-99ca-05b0e810e68e": {
			"id": "01972fff-1078-7252-99ca-05b0e810e68e",
			"batchWeighingId": "01972fff-1077-792a-b295-a3a819f5db54",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c80-b927-c4dd6a802201",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7b08-8a59-48a987001a89": {
			"id": "01972fff-1078-7b08-8a59-48a987001a89",
			"batchWeighingId": "01972fff-1077-792a-b295-a3a819f5db54",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7de0-a2c2-04b18d96cf1c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7879-a552-2e36718909e0": {
			"id": "01972fff-1078-7879-a552-2e36718909e0",
			"batchWeighingId": "01972fff-1077-792a-b295-a3a819f5db54",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-78e4-bf20-7df89055c146",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-70f1-bcf6-b5c52c0adfe3": {
			"id": "01972fff-1078-70f1-bcf6-b5c52c0adfe3",
			"batchWeighingId": "01972fff-1077-792a-b295-a3a819f5db54",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bb2-9afa-2aaca02d4cd1",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-74a8-b9a0-1cff23770cab": {
			"id": "01972fff-1078-74a8-b9a0-1cff23770cab",
			"batchWeighingId": "01972fff-1077-792a-b295-a3a819f5db54",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-73a5-a585-dbd6c2beaca5",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7b83-8adc-735155f7b983": {
			"id": "01972fff-1078-7b83-8adc-735155f7b983",
			"batchWeighingId": "01972fff-1077-792a-b295-a3a819f5db54",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e0c-8e4a-4574c3d0def1",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7406-917c-106f8f2e14bd": {
			"id": "01972fff-1078-7406-917c-106f8f2e14bd",
			"batchWeighingId": "01972fff-1077-792a-b295-a3a819f5db54",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b5c-b9c3-a8646cef2411",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7a07-9455-caa109004cd3": {
			"id": "01972fff-1078-7a07-9455-caa109004cd3",
			"batchWeighingId": "01972fff-1077-792a-b295-a3a819f5db54",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bf7-9a2d-255c32e6bab6",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-76f3-9d28-ed2a7fc7d161": {
			"id": "01972fff-1078-76f3-9d28-ed2a7fc7d161",
			"batchWeighingId": "01972fff-1077-792a-b295-a3a819f5db54",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-77e5-8abc-31b7064e18f9",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-73b1-b2e0-bcc6eea4e425": {
			"id": "01972fff-1078-73b1-b2e0-bcc6eea4e425",
			"batchWeighingId": "01972fff-1077-792a-b295-a3a819f5db54",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-79c5-85e8-41ce5450a00e",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7aa4-bdaa-6dc8b269ae62": {
			"id": "01972fff-1078-7aa4-bdaa-6dc8b269ae62",
			"batchWeighingId": "01972fff-1077-792a-b295-a3a819f5db54",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7254-9a40-bce0b6095f36",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7203-82d8-95e740a2366c": {
			"id": "01972fff-1078-7203-82d8-95e740a2366c",
			"batchWeighingId": "01972fff-1077-792a-b295-a3a819f5db54",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7de7-b6c1-f86afe274a36",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7f96-ae20-092f1081b61e": {
			"id": "01972fff-1078-7f96-ae20-092f1081b61e",
			"batchWeighingId": "01972fff-1077-792a-b295-a3a819f5db54",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e91-85c6-54515cbe68e8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-74dc-b6d6-247000b5625c": {
			"id": "01972fff-1078-74dc-b6d6-247000b5625c",
			"batchWeighingId": "01972fff-1077-792a-b295-a3a819f5db54",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7eac-bd4c-8e83837951e7",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-781a-b868-cc2538f2d84e": {
			"id": "01972fff-1078-781a-b868-cc2538f2d84e",
			"batchWeighingId": "01972fff-1077-792a-b295-a3a819f5db54",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f7f-be3e-d0da05b69a77",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7343-b964-8453eb7d9864": {
			"id": "01972fff-1078-7343-b964-8453eb7d9864",
			"batchWeighingId": "01972fff-1077-792a-b295-a3a819f5db54",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-76b4-be3e-26e9330abc8c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7cd7-8fdb-cf7396eb0a2a": {
			"id": "01972fff-1079-7cd7-8fdb-cf7396eb0a2a",
			"batchWeighingId": "01972fff-1077-7337-9559-e30fcc3c1941",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7cc0-8f09-74e5c8d3e0c8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-70b3-ad6d-0844075cb34b": {
			"id": "01972fff-1079-70b3-ad6d-0844075cb34b",
			"batchWeighingId": "01972fff-1077-7337-9559-e30fcc3c1941",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72a9-9660-c9530e27c9c4",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7533-bc0f-498da3cc2d27": {
			"id": "01972fff-1079-7533-bc0f-498da3cc2d27",
			"batchWeighingId": "01972fff-1077-7337-9559-e30fcc3c1941",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c80-b927-c4dd6a802201",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7b87-905b-fbd3599d3671": {
			"id": "01972fff-1079-7b87-905b-fbd3599d3671",
			"batchWeighingId": "01972fff-1077-7337-9559-e30fcc3c1941",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7de0-a2c2-04b18d96cf1c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7f1d-975e-65c5618c528d": {
			"id": "01972fff-1079-7f1d-975e-65c5618c528d",
			"batchWeighingId": "01972fff-1077-7337-9559-e30fcc3c1941",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-78e4-bf20-7df89055c146",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-75e0-a834-ab62eca21d20": {
			"id": "01972fff-1079-75e0-a834-ab62eca21d20",
			"batchWeighingId": "01972fff-1077-7337-9559-e30fcc3c1941",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bb2-9afa-2aaca02d4cd1",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7a40-8d39-5e8a201cefba": {
			"id": "01972fff-1079-7a40-8d39-5e8a201cefba",
			"batchWeighingId": "01972fff-1077-7337-9559-e30fcc3c1941",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-73a5-a585-dbd6c2beaca5",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7081-843d-2edf4a148fb7": {
			"id": "01972fff-1079-7081-843d-2edf4a148fb7",
			"batchWeighingId": "01972fff-1077-7337-9559-e30fcc3c1941",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e0c-8e4a-4574c3d0def1",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-755e-aa1d-09b6ea7ebf26": {
			"id": "01972fff-1079-755e-aa1d-09b6ea7ebf26",
			"batchWeighingId": "01972fff-1077-7337-9559-e30fcc3c1941",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b5c-b9c3-a8646cef2411",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7e1b-afb1-8c411a224bb8": {
			"id": "01972fff-1079-7e1b-afb1-8c411a224bb8",
			"batchWeighingId": "01972fff-1077-7337-9559-e30fcc3c1941",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bf7-9a2d-255c32e6bab6",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7245-8b14-ebc7857e7d8e": {
			"id": "01972fff-1079-7245-8b14-ebc7857e7d8e",
			"batchWeighingId": "01972fff-1077-7337-9559-e30fcc3c1941",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-77e5-8abc-31b7064e18f9",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7159-84fb-ee8c2311ce77": {
			"id": "01972fff-1079-7159-84fb-ee8c2311ce77",
			"batchWeighingId": "01972fff-1077-7337-9559-e30fcc3c1941",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-79c5-85e8-41ce5450a00e",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7a61-8023-a6dd793af19f": {
			"id": "01972fff-1079-7a61-8023-a6dd793af19f",
			"batchWeighingId": "01972fff-1077-7337-9559-e30fcc3c1941",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7254-9a40-bce0b6095f36",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-744a-9f94-31a4713750a8": {
			"id": "01972fff-1079-744a-9f94-31a4713750a8",
			"batchWeighingId": "01972fff-1077-7337-9559-e30fcc3c1941",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7de7-b6c1-f86afe274a36",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-721e-89fb-6cc491037c62": {
			"id": "01972fff-1079-721e-89fb-6cc491037c62",
			"batchWeighingId": "01972fff-1077-7337-9559-e30fcc3c1941",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e91-85c6-54515cbe68e8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-762c-9b6d-8fc2c93dcc59": {
			"id": "01972fff-1079-762c-9b6d-8fc2c93dcc59",
			"batchWeighingId": "01972fff-1077-7337-9559-e30fcc3c1941",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7eac-bd4c-8e83837951e7",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-735c-a97f-639858619e1c": {
			"id": "01972fff-1079-735c-a97f-639858619e1c",
			"batchWeighingId": "01972fff-1077-7337-9559-e30fcc3c1941",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f7f-be3e-d0da05b69a77",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7792-90bc-9d102e7b933a": {
			"id": "01972fff-1079-7792-90bc-9d102e7b933a",
			"batchWeighingId": "01972fff-1077-7337-9559-e30fcc3c1941",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-76b4-be3e-26e9330abc8c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7d55-a5cd-4e5582ece718": {
			"id": "01972fff-1078-7d55-a5cd-4e5582ece718",
			"batchWeighingId": "01972fff-1077-7a74-8b73-c78299c6a553",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d52-8551-bea41c2d42b7",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7eda-b334-43a026ce3ca6": {
			"id": "01972fff-1078-7eda-b334-43a026ce3ca6",
			"batchWeighingId": "01972fff-1077-7a74-8b73-c78299c6a553",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-706f-9aff-3adda18d98cc",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-717a-a8f4-21438141a8c3": {
			"id": "01972fff-1078-717a-a8f4-21438141a8c3",
			"batchWeighingId": "01972fff-1077-7a74-8b73-c78299c6a553",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-77b4-94ec-f73a7ffeb862",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-71b1-ae57-a7fc9211fb48": {
			"id": "01972fff-1078-71b1-ae57-a7fc9211fb48",
			"batchWeighingId": "01972fff-1077-7a74-8b73-c78299c6a553",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d7d-9eca-281a03d35c29",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-72a7-aef1-43fcac7211f2": {
			"id": "01972fff-1078-72a7-aef1-43fcac7211f2",
			"batchWeighingId": "01972fff-1077-7a74-8b73-c78299c6a553",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7183-94ca-d5898205c039",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-70f8-9619-dd2ff4626266": {
			"id": "01972fff-1078-70f8-9619-dd2ff4626266",
			"batchWeighingId": "01972fff-1077-7a74-8b73-c78299c6a553",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-705b-ad87-dfc04abf7f79",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7093-b3c4-a23c4cb313ec": {
			"id": "01972fff-1078-7093-b3c4-a23c4cb313ec",
			"batchWeighingId": "01972fff-1077-7a74-8b73-c78299c6a553",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-700c-a74d-921798039d33",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-70ab-8313-470f38aa9ea3": {
			"id": "01972fff-1078-70ab-8313-470f38aa9ea3",
			"batchWeighingId": "01972fff-1077-7a74-8b73-c78299c6a553",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-743a-807e-8525fbe3ddf6",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-70b1-9e65-b28991c47e9f": {
			"id": "01972fff-1078-70b1-9e65-b28991c47e9f",
			"batchWeighingId": "01972fff-1077-7a74-8b73-c78299c6a553",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c55-ac86-4f1b8ea1eddd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-72e9-a306-010be2228a24": {
			"id": "01972fff-1078-72e9-a306-010be2228a24",
			"batchWeighingId": "01972fff-1077-7a74-8b73-c78299c6a553",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-705c-a42a-57982cfdaf67",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-742c-a607-70b3f49aeb6d": {
			"id": "01972fff-1078-742c-a607-70b3f49aeb6d",
			"batchWeighingId": "01972fff-1077-7a74-8b73-c78299c6a553",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-760e-a723-6e0f16df5266",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7d27-b0c9-1633825172e6": {
			"id": "01972fff-1078-7d27-b0c9-1633825172e6",
			"batchWeighingId": "01972fff-1077-7a74-8b73-c78299c6a553",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7070-a724-9868e4e676ac",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-767b-89ee-da49c085cc23": {
			"id": "01972fff-1078-767b-89ee-da49c085cc23",
			"batchWeighingId": "01972fff-1077-7a74-8b73-c78299c6a553",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7397-a4ac-2d286c030acb",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-74d5-9be4-f1c0f20c4e36": {
			"id": "01972fff-1078-74d5-9be4-f1c0f20c4e36",
			"batchWeighingId": "01972fff-1077-7a74-8b73-c78299c6a553",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-791f-a265-9cdd4121d220",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-798c-b007-446dd4ac87d3": {
			"id": "01972fff-1078-798c-b007-446dd4ac87d3",
			"batchWeighingId": "01972fff-1077-7a74-8b73-c78299c6a553",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ba2-84f7-ab4adbfeaf6b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7ddb-8e1d-4eddb6067cd5": {
			"id": "01972fff-1078-7ddb-8e1d-4eddb6067cd5",
			"batchWeighingId": "01972fff-1077-7a74-8b73-c78299c6a553",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7543-9639-80c738150ab9",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-762b-9adb-7b8e789f3a0d": {
			"id": "01972fff-1078-762b-9adb-7b8e789f3a0d",
			"batchWeighingId": "01972fff-1077-7a74-8b73-c78299c6a553",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-758f-8ad0-025a138f650a",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7ba4-b88c-60aabc6619fc": {
			"id": "01972fff-1078-7ba4-b88c-60aabc6619fc",
			"batchWeighingId": "01972fff-1077-7a74-8b73-c78299c6a553",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-753e-b982-ef834631ddce",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-77fa-a80b-b90c257a28dd": {
			"id": "01972fff-1079-77fa-a80b-b90c257a28dd",
			"batchWeighingId": "01972fff-1077-73f1-8a55-dc3991819df7",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d52-8551-bea41c2d42b7",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7027-8b30-1e30a8212a43": {
			"id": "01972fff-1079-7027-8b30-1e30a8212a43",
			"batchWeighingId": "01972fff-1077-73f1-8a55-dc3991819df7",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-706f-9aff-3adda18d98cc",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7945-9360-3059ecc18736": {
			"id": "01972fff-1079-7945-9360-3059ecc18736",
			"batchWeighingId": "01972fff-1077-73f1-8a55-dc3991819df7",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-77b4-94ec-f73a7ffeb862",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-771d-87c0-43fd65145754": {
			"id": "01972fff-1079-771d-87c0-43fd65145754",
			"batchWeighingId": "01972fff-1077-73f1-8a55-dc3991819df7",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d7d-9eca-281a03d35c29",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-718d-aeea-d0e5f4b13904": {
			"id": "01972fff-1079-718d-aeea-d0e5f4b13904",
			"batchWeighingId": "01972fff-1077-73f1-8a55-dc3991819df7",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7183-94ca-d5898205c039",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7e80-a50c-cc63bba8a985": {
			"id": "01972fff-1079-7e80-a50c-cc63bba8a985",
			"batchWeighingId": "01972fff-1077-73f1-8a55-dc3991819df7",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-705b-ad87-dfc04abf7f79",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7ae6-92d0-41f1e8932570": {
			"id": "01972fff-1079-7ae6-92d0-41f1e8932570",
			"batchWeighingId": "01972fff-1077-73f1-8a55-dc3991819df7",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-700c-a74d-921798039d33",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7aef-972f-a9ab42acebdc": {
			"id": "01972fff-1079-7aef-972f-a9ab42acebdc",
			"batchWeighingId": "01972fff-1077-73f1-8a55-dc3991819df7",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-743a-807e-8525fbe3ddf6",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7d92-ac3e-58078e4597e3": {
			"id": "01972fff-1079-7d92-ac3e-58078e4597e3",
			"batchWeighingId": "01972fff-1077-73f1-8a55-dc3991819df7",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c55-ac86-4f1b8ea1eddd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7481-be11-724f845f7cb2": {
			"id": "01972fff-1079-7481-be11-724f845f7cb2",
			"batchWeighingId": "01972fff-1077-73f1-8a55-dc3991819df7",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-705c-a42a-57982cfdaf67",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7260-bdb7-59123941b8a6": {
			"id": "01972fff-1079-7260-bdb7-59123941b8a6",
			"batchWeighingId": "01972fff-1077-73f1-8a55-dc3991819df7",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-760e-a723-6e0f16df5266",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-77e7-b248-9916fa64547a": {
			"id": "01972fff-1079-77e7-b248-9916fa64547a",
			"batchWeighingId": "01972fff-1077-73f1-8a55-dc3991819df7",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7070-a724-9868e4e676ac",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7fc8-87e2-0ac0a6725697": {
			"id": "01972fff-1079-7fc8-87e2-0ac0a6725697",
			"batchWeighingId": "01972fff-1077-73f1-8a55-dc3991819df7",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7397-a4ac-2d286c030acb",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7150-870e-598b566083d8": {
			"id": "01972fff-1079-7150-870e-598b566083d8",
			"batchWeighingId": "01972fff-1077-73f1-8a55-dc3991819df7",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-791f-a265-9cdd4121d220",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7631-8487-980e3c58bf60": {
			"id": "01972fff-1079-7631-8487-980e3c58bf60",
			"batchWeighingId": "01972fff-1077-73f1-8a55-dc3991819df7",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ba2-84f7-ab4adbfeaf6b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7110-91de-657226c81400": {
			"id": "01972fff-1079-7110-91de-657226c81400",
			"batchWeighingId": "01972fff-1077-73f1-8a55-dc3991819df7",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7543-9639-80c738150ab9",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7f69-9941-9c6a1bd1a83b": {
			"id": "01972fff-1079-7f69-9941-9c6a1bd1a83b",
			"batchWeighingId": "01972fff-1077-73f1-8a55-dc3991819df7",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-758f-8ad0-025a138f650a",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7bf1-8381-0b98d0daa50f": {
			"id": "01972fff-1079-7bf1-8381-0b98d0daa50f",
			"batchWeighingId": "01972fff-1077-73f1-8a55-dc3991819df7",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-753e-b982-ef834631ddce",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-72c7-99f6-4846ae3b30ed": {
			"id": "01972fff-1078-72c7-99f6-4846ae3b30ed",
			"batchWeighingId": "01972fff-1077-7c5c-843c-21b1c5b4a2e1",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7588-8948-d019938cabcf",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-729b-b109-edb2dadbf871": {
			"id": "01972fff-1078-729b-b109-edb2dadbf871",
			"batchWeighingId": "01972fff-1077-7c5c-843c-21b1c5b4a2e1",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7793-be98-5b3a0f57f68c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-77f1-99bf-97e65aaf577e": {
			"id": "01972fff-1078-77f1-99bf-97e65aaf577e",
			"batchWeighingId": "01972fff-1077-7c5c-843c-21b1c5b4a2e1",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7fd5-87a6-05a93ab71b2f",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7e14-9980-fc215f453fe7": {
			"id": "01972fff-1078-7e14-9980-fc215f453fe7",
			"batchWeighingId": "01972fff-1077-7c5c-843c-21b1c5b4a2e1",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7aaa-99a1-c17c58bbf637",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7e25-95d8-602865cb83b3": {
			"id": "01972fff-1078-7e25-95d8-602865cb83b3",
			"batchWeighingId": "01972fff-1077-7c5c-843c-21b1c5b4a2e1",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-756e-a1fc-12f249a87226",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7572-a374-f419628fc1f1": {
			"id": "01972fff-1078-7572-a374-f419628fc1f1",
			"batchWeighingId": "01972fff-1077-7c5c-843c-21b1c5b4a2e1",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-74ee-8acd-2950986e209b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7636-9a9e-cb54f625f111": {
			"id": "01972fff-1078-7636-9a9e-cb54f625f111",
			"batchWeighingId": "01972fff-1077-7c5c-843c-21b1c5b4a2e1",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-759a-b3bf-d087463fcac5",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7ed1-a545-48b8914622ee": {
			"id": "01972fff-1078-7ed1-a545-48b8914622ee",
			"batchWeighingId": "01972fff-1077-7c5c-843c-21b1c5b4a2e1",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72f7-9fd9-51851a3f6e0e",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-78b8-924f-19938d948433": {
			"id": "01972fff-1078-78b8-924f-19938d948433",
			"batchWeighingId": "01972fff-1077-7c5c-843c-21b1c5b4a2e1",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-73af-b25b-4244838049fd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7471-8c34-2df169a03d90": {
			"id": "01972fff-1078-7471-8c34-2df169a03d90",
			"batchWeighingId": "01972fff-1077-7c5c-843c-21b1c5b4a2e1",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f8d-a674-968ede5f4929",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-714d-825a-356ec6aaf423": {
			"id": "01972fff-1078-714d-825a-356ec6aaf423",
			"batchWeighingId": "01972fff-1077-7c5c-843c-21b1c5b4a2e1",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ebd-ba0d-78821fa95a34",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7d71-a5fa-6acd52a716ca": {
			"id": "01972fff-1078-7d71-a5fa-6acd52a716ca",
			"batchWeighingId": "01972fff-1077-7c5c-843c-21b1c5b4a2e1",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-715e-ada5-30bf34cd667d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7014-9bd6-d611c262c0ab": {
			"id": "01972fff-1078-7014-9bd6-d611c262c0ab",
			"batchWeighingId": "01972fff-1077-7c5c-843c-21b1c5b4a2e1",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-78b6-888f-d279b7ab60bd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-72a8-8e86-4e94e525d1cf": {
			"id": "01972fff-1078-72a8-8e86-4e94e525d1cf",
			"batchWeighingId": "01972fff-1077-7c5c-843c-21b1c5b4a2e1",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-735a-b9e6-ec3de3e1594a",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7de2-94f6-32d453cf4153": {
			"id": "01972fff-1078-7de2-94f6-32d453cf4153",
			"batchWeighingId": "01972fff-1077-7c5c-843c-21b1c5b4a2e1",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e69-975a-290d0743efef",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-765a-8748-972d60131587": {
			"id": "01972fff-1078-765a-8748-972d60131587",
			"batchWeighingId": "01972fff-1077-7c5c-843c-21b1c5b4a2e1",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-786d-8513-0664c3ccad98",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7d22-84eb-913d2a7a2da3": {
			"id": "01972fff-1078-7d22-84eb-913d2a7a2da3",
			"batchWeighingId": "01972fff-1077-7c5c-843c-21b1c5b4a2e1",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7db6-ac89-92b6bcde462b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7883-8d72-7aeeffe5886d": {
			"id": "01972fff-1078-7883-8d72-7aeeffe5886d",
			"batchWeighingId": "01972fff-1077-7c5c-843c-21b1c5b4a2e1",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7cd8-b9b2-b52c2dd90d20",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-79b5-8484-fad72c28488d": {
			"id": "01972fff-1079-79b5-8484-fad72c28488d",
			"batchWeighingId": "01972fff-1077-7d3a-9df2-6a612c1d3234",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7588-8948-d019938cabcf",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7d8b-a00d-fff0be9bde40": {
			"id": "01972fff-1079-7d8b-a00d-fff0be9bde40",
			"batchWeighingId": "01972fff-1077-7d3a-9df2-6a612c1d3234",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7793-be98-5b3a0f57f68c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-74b9-a0c3-d09a4935592e": {
			"id": "01972fff-1079-74b9-a0c3-d09a4935592e",
			"batchWeighingId": "01972fff-1077-7d3a-9df2-6a612c1d3234",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7fd5-87a6-05a93ab71b2f",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7473-8193-1865f834325c": {
			"id": "01972fff-1079-7473-8193-1865f834325c",
			"batchWeighingId": "01972fff-1077-7d3a-9df2-6a612c1d3234",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7aaa-99a1-c17c58bbf637",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7bae-bde3-1975e65984f2": {
			"id": "01972fff-1079-7bae-bde3-1975e65984f2",
			"batchWeighingId": "01972fff-1077-7d3a-9df2-6a612c1d3234",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-756e-a1fc-12f249a87226",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7100-ad43-68ddefbe7d65": {
			"id": "01972fff-1079-7100-ad43-68ddefbe7d65",
			"batchWeighingId": "01972fff-1077-7d3a-9df2-6a612c1d3234",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-74ee-8acd-2950986e209b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7fe5-a005-f82e06d932dd": {
			"id": "01972fff-1079-7fe5-a005-f82e06d932dd",
			"batchWeighingId": "01972fff-1077-7d3a-9df2-6a612c1d3234",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-759a-b3bf-d087463fcac5",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7548-982f-24e53eb11fb0": {
			"id": "01972fff-1079-7548-982f-24e53eb11fb0",
			"batchWeighingId": "01972fff-1077-7d3a-9df2-6a612c1d3234",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72f7-9fd9-51851a3f6e0e",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7a9f-af91-6a9c55a0279c": {
			"id": "01972fff-1079-7a9f-af91-6a9c55a0279c",
			"batchWeighingId": "01972fff-1077-7d3a-9df2-6a612c1d3234",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-73af-b25b-4244838049fd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7b4e-b872-9150dac1adbf": {
			"id": "01972fff-1079-7b4e-b872-9150dac1adbf",
			"batchWeighingId": "01972fff-1077-7d3a-9df2-6a612c1d3234",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f8d-a674-968ede5f4929",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7926-9b80-f3c5e15f5d68": {
			"id": "01972fff-1079-7926-9b80-f3c5e15f5d68",
			"batchWeighingId": "01972fff-1077-7d3a-9df2-6a612c1d3234",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ebd-ba0d-78821fa95a34",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7a8b-841a-91fed00a00af": {
			"id": "01972fff-1079-7a8b-841a-91fed00a00af",
			"batchWeighingId": "01972fff-1077-7d3a-9df2-6a612c1d3234",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-715e-ada5-30bf34cd667d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7206-a83a-31d1ba47e356": {
			"id": "01972fff-1079-7206-a83a-31d1ba47e356",
			"batchWeighingId": "01972fff-1077-7d3a-9df2-6a612c1d3234",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-78b6-888f-d279b7ab60bd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7bda-8bfd-805b1f1c7cb6": {
			"id": "01972fff-1079-7bda-8bfd-805b1f1c7cb6",
			"batchWeighingId": "01972fff-1077-7d3a-9df2-6a612c1d3234",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-735a-b9e6-ec3de3e1594a",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7883-8835-b0b66bcecb6c": {
			"id": "01972fff-1079-7883-8835-b0b66bcecb6c",
			"batchWeighingId": "01972fff-1077-7d3a-9df2-6a612c1d3234",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e69-975a-290d0743efef",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7d11-9fca-7e6336f558ed": {
			"id": "01972fff-1079-7d11-9fca-7e6336f558ed",
			"batchWeighingId": "01972fff-1077-7d3a-9df2-6a612c1d3234",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-786d-8513-0664c3ccad98",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-78db-aba3-dcca3b890f41": {
			"id": "01972fff-1079-78db-aba3-dcca3b890f41",
			"batchWeighingId": "01972fff-1077-7d3a-9df2-6a612c1d3234",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7db6-ac89-92b6bcde462b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-782a-ad93-da7f993935eb": {
			"id": "01972fff-1079-782a-ad93-da7f993935eb",
			"batchWeighingId": "01972fff-1077-7d3a-9df2-6a612c1d3234",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7cd8-b9b2-b52c2dd90d20",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7da6-b8ad-1428475c123b": {
			"id": "01972fff-1078-7da6-b8ad-1428475c123b",
			"batchWeighingId": "01972fff-1077-769d-8792-bb80fafc6420",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72d3-8b30-e0ab83e8d37d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-725f-bd9b-6a5de9b2b4a9": {
			"id": "01972fff-1078-725f-bd9b-6a5de9b2b4a9",
			"batchWeighingId": "01972fff-1077-769d-8792-bb80fafc6420",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ac9-b2dd-13c1750b4fac",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-76af-87e5-850db9ce8e33": {
			"id": "01972fff-1078-76af-87e5-850db9ce8e33",
			"batchWeighingId": "01972fff-1077-769d-8792-bb80fafc6420",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7220-8bd9-19935e9b4527",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-74bd-9567-1a3d8c58b6e5": {
			"id": "01972fff-1078-74bd-9567-1a3d8c58b6e5",
			"batchWeighingId": "01972fff-1077-769d-8792-bb80fafc6420",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7251-ad3c-0cf9dfddd06c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-71f7-a1bc-dd160de6adc2": {
			"id": "01972fff-1078-71f7-a1bc-dd160de6adc2",
			"batchWeighingId": "01972fff-1077-769d-8792-bb80fafc6420",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-756f-b159-cc0612f285c8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7836-8775-0d17acc69304": {
			"id": "01972fff-1078-7836-8775-0d17acc69304",
			"batchWeighingId": "01972fff-1077-769d-8792-bb80fafc6420",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72fa-bf32-652bf5bf8d5b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-74dc-986e-74f5d439dce1": {
			"id": "01972fff-1078-74dc-986e-74f5d439dce1",
			"batchWeighingId": "01972fff-1077-769d-8792-bb80fafc6420",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-736b-850a-0f073660b996",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7c0a-bcfa-215367380353": {
			"id": "01972fff-1078-7c0a-bcfa-215367380353",
			"batchWeighingId": "01972fff-1077-769d-8792-bb80fafc6420",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-769c-977d-a08eba7e9622",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7ac7-9b9f-a47972c50e53": {
			"id": "01972fff-1078-7ac7-9b9f-a47972c50e53",
			"batchWeighingId": "01972fff-1077-769d-8792-bb80fafc6420",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7834-b8ae-bbf502ec6115",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7a4f-a9c8-e1485d30e97c": {
			"id": "01972fff-1078-7a4f-a9c8-e1485d30e97c",
			"batchWeighingId": "01972fff-1077-769d-8792-bb80fafc6420",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-725a-9159-dcc67d810756",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-75ab-a028-6051373e4e74": {
			"id": "01972fff-1078-75ab-a028-6051373e4e74",
			"batchWeighingId": "01972fff-1077-769d-8792-bb80fafc6420",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ca3-9f3b-9c24d52fcf77",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-799b-ad0d-bfb8bdb13010": {
			"id": "01972fff-1078-799b-ad0d-bfb8bdb13010",
			"batchWeighingId": "01972fff-1077-769d-8792-bb80fafc6420",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7baa-9842-af256f4506e0",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7db6-8489-201ade1c647d": {
			"id": "01972fff-1078-7db6-8489-201ade1c647d",
			"batchWeighingId": "01972fff-1077-769d-8792-bb80fafc6420",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-741f-83bf-c4acd2f30d37",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-717d-bcd3-ec553ab4b11b": {
			"id": "01972fff-1078-717d-bcd3-ec553ab4b11b",
			"batchWeighingId": "01972fff-1077-769d-8792-bb80fafc6420",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-704e-bfa5-366faf7530bd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7958-85a7-dcf0043661cf": {
			"id": "01972fff-1078-7958-85a7-dcf0043661cf",
			"batchWeighingId": "01972fff-1077-769d-8792-bb80fafc6420",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7293-be3c-09d702091eda",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7455-ae55-4fba33d0dcd2": {
			"id": "01972fff-1078-7455-ae55-4fba33d0dcd2",
			"batchWeighingId": "01972fff-1077-769d-8792-bb80fafc6420",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b4b-8037-8939efa37fc3",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-71d7-b26e-b479b4b6879b": {
			"id": "01972fff-1078-71d7-b26e-b479b4b6879b",
			"batchWeighingId": "01972fff-1077-769d-8792-bb80fafc6420",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7542-b533-b57facd55fc7",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7e00-bd24-d9d5cba5bd77": {
			"id": "01972fff-1078-7e00-bd24-d9d5cba5bd77",
			"batchWeighingId": "01972fff-1077-769d-8792-bb80fafc6420",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7fbc-af18-3cdac7a0cc1d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7b63-b4be-4897222c6a10": {
			"id": "01972fff-1079-7b63-b4be-4897222c6a10",
			"batchWeighingId": "01972fff-1077-7dd1-81f9-1b92da554a04",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72d3-8b30-e0ab83e8d37d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7ce9-b41f-8826fd7b3b26": {
			"id": "01972fff-1079-7ce9-b41f-8826fd7b3b26",
			"batchWeighingId": "01972fff-1077-7dd1-81f9-1b92da554a04",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ac9-b2dd-13c1750b4fac",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7c31-8412-39e01e33105c": {
			"id": "01972fff-1079-7c31-8412-39e01e33105c",
			"batchWeighingId": "01972fff-1077-7dd1-81f9-1b92da554a04",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7220-8bd9-19935e9b4527",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-78da-b4a5-01d95a3712b0": {
			"id": "01972fff-1079-78da-b4a5-01d95a3712b0",
			"batchWeighingId": "01972fff-1077-7dd1-81f9-1b92da554a04",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7251-ad3c-0cf9dfddd06c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-799d-8f27-634191c07961": {
			"id": "01972fff-1079-799d-8f27-634191c07961",
			"batchWeighingId": "01972fff-1077-7dd1-81f9-1b92da554a04",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-756f-b159-cc0612f285c8",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7352-a52e-280bdbe723e3": {
			"id": "01972fff-1079-7352-a52e-280bdbe723e3",
			"batchWeighingId": "01972fff-1077-7dd1-81f9-1b92da554a04",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-72fa-bf32-652bf5bf8d5b",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7bc1-96f3-38275c935f66": {
			"id": "01972fff-1079-7bc1-96f3-38275c935f66",
			"batchWeighingId": "01972fff-1077-7dd1-81f9-1b92da554a04",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-736b-850a-0f073660b996",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-783d-b717-0c348d3ca547": {
			"id": "01972fff-1079-783d-b717-0c348d3ca547",
			"batchWeighingId": "01972fff-1077-7dd1-81f9-1b92da554a04",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-769c-977d-a08eba7e9622",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-72de-ab10-49a1ff491c02": {
			"id": "01972fff-1079-72de-ab10-49a1ff491c02",
			"batchWeighingId": "01972fff-1077-7dd1-81f9-1b92da554a04",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7834-b8ae-bbf502ec6115",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7ce4-986a-ecfe90a8cc1a": {
			"id": "01972fff-1079-7ce4-986a-ecfe90a8cc1a",
			"batchWeighingId": "01972fff-1077-7dd1-81f9-1b92da554a04",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-725a-9159-dcc67d810756",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7e74-80eb-5c8ae1025360": {
			"id": "01972fff-1079-7e74-80eb-5c8ae1025360",
			"batchWeighingId": "01972fff-1077-7dd1-81f9-1b92da554a04",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7ca3-9f3b-9c24d52fcf77",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7cf6-b190-c4493c697367": {
			"id": "01972fff-1079-7cf6-b190-c4493c697367",
			"batchWeighingId": "01972fff-1077-7dd1-81f9-1b92da554a04",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7baa-9842-af256f4506e0",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7960-91ca-eed112e86c43": {
			"id": "01972fff-1079-7960-91ca-eed112e86c43",
			"batchWeighingId": "01972fff-1077-7dd1-81f9-1b92da554a04",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-741f-83bf-c4acd2f30d37",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7753-9bcd-0eb4a398633b": {
			"id": "01972fff-1079-7753-9bcd-0eb4a398633b",
			"batchWeighingId": "01972fff-1077-7dd1-81f9-1b92da554a04",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-704e-bfa5-366faf7530bd",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7ff3-85af-0f36c923fad0": {
			"id": "01972fff-1079-7ff3-85af-0f36c923fad0",
			"batchWeighingId": "01972fff-1077-7dd1-81f9-1b92da554a04",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7293-be3c-09d702091eda",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-79d6-8110-f42f203bc3c1": {
			"id": "01972fff-1079-79d6-8110-f42f203bc3c1",
			"batchWeighingId": "01972fff-1077-7dd1-81f9-1b92da554a04",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b4b-8037-8939efa37fc3",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-77c0-b476-876ef441f175": {
			"id": "01972fff-1079-77c0-b476-876ef441f175",
			"batchWeighingId": "01972fff-1077-7dd1-81f9-1b92da554a04",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7542-b533-b57facd55fc7",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7b33-ba79-30f32e14af5b": {
			"id": "01972fff-1079-7b33-ba79-30f32e14af5b",
			"batchWeighingId": "01972fff-1077-7dd1-81f9-1b92da554a04",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7fbc-af18-3cdac7a0cc1d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7eb6-a4dd-cc639b2fbbcb": {
			"id": "01972fff-1078-7eb6-a4dd-cc639b2fbbcb",
			"batchWeighingId": "01972fff-1077-7b69-a7fc-04ba5e609c16",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-791f-8133-0da1c1775cc1",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-788f-be27-cbd368a47a87": {
			"id": "01972fff-1078-788f-be27-cbd368a47a87",
			"batchWeighingId": "01972fff-1077-7b69-a7fc-04ba5e609c16",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-785f-a996-3528e8721a65",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7421-8684-83775fb30778": {
			"id": "01972fff-1078-7421-8684-83775fb30778",
			"batchWeighingId": "01972fff-1077-7b69-a7fc-04ba5e609c16",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-76fa-b086-05bdfdf5ceac",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-76e3-b96a-f4abfad899ac": {
			"id": "01972fff-1078-76e3-b96a-f4abfad899ac",
			"batchWeighingId": "01972fff-1077-7b69-a7fc-04ba5e609c16",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-759d-aee4-7ef4826f8848",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7625-9187-ac4f9d9d1048": {
			"id": "01972fff-1078-7625-9187-ac4f9d9d1048",
			"batchWeighingId": "01972fff-1077-7b69-a7fc-04ba5e609c16",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-747b-8adb-bd455ba79531",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7fa1-a498-fd6fc8308fb7": {
			"id": "01972fff-1078-7fa1-a498-fd6fc8308fb7",
			"batchWeighingId": "01972fff-1077-7b69-a7fc-04ba5e609c16",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d0e-ae8e-266abac6fb6c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-78b6-95d7-bde3aa9abfc6": {
			"id": "01972fff-1078-78b6-95d7-bde3aa9abfc6",
			"batchWeighingId": "01972fff-1077-7b69-a7fc-04ba5e609c16",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7183-9ac0-fde99a456d9e",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7d10-80cd-e35a8a79408e": {
			"id": "01972fff-1078-7d10-80cd-e35a8a79408e",
			"batchWeighingId": "01972fff-1077-7b69-a7fc-04ba5e609c16",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bf4-bbb1-08943a23cb9d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7b2d-b776-f7307577f6e1": {
			"id": "01972fff-1078-7b2d-b776-f7307577f6e1",
			"batchWeighingId": "01972fff-1077-7b69-a7fc-04ba5e609c16",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7791-8b3f-d4206701ca8a",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7079-acdf-5c1ac7b313aa": {
			"id": "01972fff-1078-7079-acdf-5c1ac7b313aa",
			"batchWeighingId": "01972fff-1077-7b69-a7fc-04ba5e609c16",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e92-8c88-0ca0d3695405",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7833-8a8c-6f596ca09879": {
			"id": "01972fff-1078-7833-8a8c-6f596ca09879",
			"batchWeighingId": "01972fff-1077-7b69-a7fc-04ba5e609c16",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b00-b171-5d7dca8bad24",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-725a-b897-5be507629ef9": {
			"id": "01972fff-1078-725a-b897-5be507629ef9",
			"batchWeighingId": "01972fff-1077-7b69-a7fc-04ba5e609c16",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7cb5-9b6b-584a83e4fa96",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7566-a9fe-d6937ffd4215": {
			"id": "01972fff-1079-7566-a9fe-d6937ffd4215",
			"batchWeighingId": "01972fff-1077-7804-ad9f-9e8c4ff69ba8",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-791f-8133-0da1c1775cc1",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7e90-afd9-138d0e89db88": {
			"id": "01972fff-1079-7e90-afd9-138d0e89db88",
			"batchWeighingId": "01972fff-1077-7804-ad9f-9e8c4ff69ba8",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-785f-a996-3528e8721a65",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-77a5-9613-48679fa23547": {
			"id": "01972fff-1079-77a5-9613-48679fa23547",
			"batchWeighingId": "01972fff-1077-7804-ad9f-9e8c4ff69ba8",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-76fa-b086-05bdfdf5ceac",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-746a-9ba5-14461c6f4a30": {
			"id": "01972fff-1079-746a-9ba5-14461c6f4a30",
			"batchWeighingId": "01972fff-1077-7804-ad9f-9e8c4ff69ba8",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-759d-aee4-7ef4826f8848",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-77af-89e6-49357e9aae3f": {
			"id": "01972fff-1079-77af-89e6-49357e9aae3f",
			"batchWeighingId": "01972fff-1077-7804-ad9f-9e8c4ff69ba8",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-747b-8adb-bd455ba79531",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7759-851d-e68d7d7cd0fd": {
			"id": "01972fff-1079-7759-851d-e68d7d7cd0fd",
			"batchWeighingId": "01972fff-1077-7804-ad9f-9e8c4ff69ba8",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d0e-ae8e-266abac6fb6c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7acb-8216-26e0d8ab31ee": {
			"id": "01972fff-1079-7acb-8216-26e0d8ab31ee",
			"batchWeighingId": "01972fff-1077-7804-ad9f-9e8c4ff69ba8",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7183-9ac0-fde99a456d9e",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7ca2-a776-6267bb84008f": {
			"id": "01972fff-1079-7ca2-a776-6267bb84008f",
			"batchWeighingId": "01972fff-1077-7804-ad9f-9e8c4ff69ba8",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bf4-bbb1-08943a23cb9d",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-722c-bf3e-c2a69612af1c": {
			"id": "01972fff-1079-722c-bf3e-c2a69612af1c",
			"batchWeighingId": "01972fff-1077-7804-ad9f-9e8c4ff69ba8",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7791-8b3f-d4206701ca8a",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7b21-bf35-e2ea0257b8c2": {
			"id": "01972fff-1079-7b21-bf35-e2ea0257b8c2",
			"batchWeighingId": "01972fff-1077-7804-ad9f-9e8c4ff69ba8",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e92-8c88-0ca0d3695405",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7ea0-a8b5-d8ee9aabb26b": {
			"id": "01972fff-1079-7ea0-a8b5-d8ee9aabb26b",
			"batchWeighingId": "01972fff-1077-7804-ad9f-9e8c4ff69ba8",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b00-b171-5d7dca8bad24",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7d72-bfd4-4aae2167dbf0": {
			"id": "01972fff-1079-7d72-bfd4-4aae2167dbf0",
			"batchWeighingId": "01972fff-1077-7804-ad9f-9e8c4ff69ba8",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7cb5-9b6b-584a83e4fa96",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7dfc-9189-762cdec8e55a": {
			"id": "01972fff-1078-7dfc-9189-762cdec8e55a",
			"batchWeighingId": "01972fff-1077-7fb6-8fcd-7a60e5bf77e1",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c5a-8407-dfd45f9b13be",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-780e-b499-bd77aa7b7514": {
			"id": "01972fff-1078-780e-b499-bd77aa7b7514",
			"batchWeighingId": "01972fff-1077-7fb6-8fcd-7a60e5bf77e1",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-70da-8dbd-231ca75278c2",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7dad-abad-f3daa6730010": {
			"id": "01972fff-1078-7dad-abad-f3daa6730010",
			"batchWeighingId": "01972fff-1077-7fb6-8fcd-7a60e5bf77e1",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7440-a0ba-9c08606f2a20",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-77aa-ae83-504ce088098c": {
			"id": "01972fff-1078-77aa-ae83-504ce088098c",
			"batchWeighingId": "01972fff-1077-7fb6-8fcd-7a60e5bf77e1",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b91-9a5e-901bc6790db4",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7ba8-a73d-74754612efee": {
			"id": "01972fff-1078-7ba8-a73d-74754612efee",
			"batchWeighingId": "01972fff-1077-7fb6-8fcd-7a60e5bf77e1",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d17-976e-1c4a59fe50cf",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7001-a102-63b6bf52442a": {
			"id": "01972fff-1078-7001-a102-63b6bf52442a",
			"batchWeighingId": "01972fff-1077-7fb6-8fcd-7a60e5bf77e1",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e57-ae47-50e29926c1da",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-794e-8b3f-40c1caa6231c": {
			"id": "01972fff-1078-794e-8b3f-40c1caa6231c",
			"batchWeighingId": "01972fff-1077-7fb6-8fcd-7a60e5bf77e1",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7af3-8559-3a60c752184c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7732-bb9a-61a665e307b2": {
			"id": "01972fff-1078-7732-bb9a-61a665e307b2",
			"batchWeighingId": "01972fff-1077-7fb6-8fcd-7a60e5bf77e1",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f40-82c8-df11c4507261",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7f2e-8dfb-e3c14d1f5eb0": {
			"id": "01972fff-1078-7f2e-8dfb-e3c14d1f5eb0",
			"batchWeighingId": "01972fff-1077-7fb6-8fcd-7a60e5bf77e1",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bbe-92ae-b7a8cb3f4256",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7518-8c3e-676d0e28491f": {
			"id": "01972fff-1078-7518-8c3e-676d0e28491f",
			"batchWeighingId": "01972fff-1077-7fb6-8fcd-7a60e5bf77e1",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-70c9-a367-822ddf7ab517",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7e64-9b8f-01c79131ceae": {
			"id": "01972fff-1078-7e64-9b8f-01c79131ceae",
			"batchWeighingId": "01972fff-1077-7fb6-8fcd-7a60e5bf77e1",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f84-ae7e-b13efb25ca6c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1078-7e97-a718-ec7e488219aa": {
			"id": "01972fff-1078-7e97-a718-ec7e488219aa",
			"batchWeighingId": "01972fff-1077-7fb6-8fcd-7a60e5bf77e1",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-79ed-b1c7-97f006625806",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InitialWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7b8a-9690-20c03dff38be": {
			"id": "01972fff-1079-7b8a-9690-20c03dff38be",
			"batchWeighingId": "01972fff-1077-74bf-bfd6-cca461010b16",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7c5a-8407-dfd45f9b13be",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7488-8f4b-1b6b956f8e9a": {
			"id": "01972fff-1079-7488-8f4b-1b6b956f8e9a",
			"batchWeighingId": "01972fff-1077-74bf-bfd6-cca461010b16",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-70da-8dbd-231ca75278c2",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7eb2-943e-621821ed608b": {
			"id": "01972fff-1079-7eb2-943e-621821ed608b",
			"batchWeighingId": "01972fff-1077-74bf-bfd6-cca461010b16",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7440-a0ba-9c08606f2a20",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7fdd-9a19-a8b72c470558": {
			"id": "01972fff-1079-7fdd-9a19-a8b72c470558",
			"batchWeighingId": "01972fff-1077-74bf-bfd6-cca461010b16",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7b91-9a5e-901bc6790db4",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7fa6-9ead-4e36e961175f": {
			"id": "01972fff-1079-7fa6-9ead-4e36e961175f",
			"batchWeighingId": "01972fff-1077-74bf-bfd6-cca461010b16",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7d17-976e-1c4a59fe50cf",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-78c2-9b32-1a8a1193a8f8": {
			"id": "01972fff-1079-78c2-9b32-1a8a1193a8f8",
			"batchWeighingId": "01972fff-1077-74bf-bfd6-cca461010b16",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7e57-ae47-50e29926c1da",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-78ad-80d7-cdcac7ea78d7": {
			"id": "01972fff-1079-78ad-80d7-cdcac7ea78d7",
			"batchWeighingId": "01972fff-1077-74bf-bfd6-cca461010b16",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7af3-8559-3a60c752184c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-78a5-ac40-4348daa33b31": {
			"id": "01972fff-1079-78a5-ac40-4348daa33b31",
			"batchWeighingId": "01972fff-1077-74bf-bfd6-cca461010b16",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f40-82c8-df11c4507261",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7a70-8bd2-333bf2d8d6ee": {
			"id": "01972fff-1079-7a70-8bd2-333bf2d8d6ee",
			"batchWeighingId": "01972fff-1077-74bf-bfd6-cca461010b16",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7bbe-92ae-b7a8cb3f4256",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7210-8595-8411ae69a50c": {
			"id": "01972fff-1079-7210-8595-8411ae69a50c",
			"batchWeighingId": "01972fff-1077-74bf-bfd6-cca461010b16",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-70c9-a367-822ddf7ab517",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7770-878d-e37c4413c3e3": {
			"id": "01972fff-1079-7770-878d-e37c4413c3e3",
			"batchWeighingId": "01972fff-1077-74bf-bfd6-cca461010b16",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-7f84-ae7e-b13efb25ca6c",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		},
		"01972fff-1079-7c68-a42f-589127c3b591": {
			"id": "01972fff-1079-7c68-a42f-589127c3b591",
			"batchWeighingId": "01972fff-1077-74bf-bfd6-cca461010b16",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"trialId": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"penId": "01972fff-1071-79ed-b1c7-97f006625806",
			"groupId": "01972fff-1074-7806-af3f-3e7363e11a43",
			"feedId": "01972fff-1073-70c8-9244-d11766428c34",
			"update": {
				"lastServerUpdate": null,
				"lastLocalUpdate": null,
				"lastEditedByUser": {
					"userId": "",
					"name": ""
				}
			},
			"type": {
				"type": "InterimWeighing"
			},
			"inputNumber": 0,
			"inputWeight": 0
		}
	},
	"pens": {
		"01972fff-1071-738c-8002-80530c1c9c58": {
			"id": "01972fff-1071-738c-8002-80530c1c9c58",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"name": "Sti 25",
			"number": 25
		},
		"01972fff-1071-7760-95c3-b5bd6aa3f3d5": {
			"id": "01972fff-1071-7760-95c3-b5bd6aa3f3d5",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"name": "Sti 26",
			"number": 26
		},
		"01972fff-1071-7dae-b37e-ea59d076c941": {
			"id": "01972fff-1071-7dae-b37e-ea59d076c941",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"name": "Sti 27",
			"number": 27
		},
		"01972fff-1071-7975-8e6f-bae9f8a73b89": {
			"id": "01972fff-1071-7975-8e6f-bae9f8a73b89",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"name": "Sti 28",
			"number": 28
		},
		"01972fff-1071-7c74-9543-da36591e073c": {
			"id": "01972fff-1071-7c74-9543-da36591e073c",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"name": "Sti 29",
			"number": 29
		},
		"01972fff-1071-7f11-88c2-2496ae669d38": {
			"id": "01972fff-1071-7f11-88c2-2496ae669d38",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"name": "Sti 30",
			"number": 30
		},
		"01972fff-1071-764a-a8eb-861dc377f79c": {
			"id": "01972fff-1071-764a-a8eb-861dc377f79c",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"name": "Sti 31",
			"number": 31
		},
		"01972fff-1071-73de-87e3-d46cdbe0c1fc": {
			"id": "01972fff-1071-73de-87e3-d46cdbe0c1fc",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"name": "Sti 32",
			"number": 32
		},
		"01972fff-1071-719c-936d-d0f6c8cd8310": {
			"id": "01972fff-1071-719c-936d-d0f6c8cd8310",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"name": "Sti 33",
			"number": 33
		},
		"01972fff-1071-7fef-b3f5-90e7bf54b8a8": {
			"id": "01972fff-1071-7fef-b3f5-90e7bf54b8a8",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"name": "Sti 34",
			"number": 34
		},
		"01972fff-1071-70e9-a49e-1ebd31ce20ff": {
			"id": "01972fff-1071-70e9-a49e-1ebd31ce20ff",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"name": "Sti 35",
			"number": 35
		},
		"01972fff-1071-7519-a311-5f7ab4f7711e": {
			"id": "01972fff-1071-7519-a311-5f7ab4f7711e",
			"sectionId": "01972fff-106f-73c8-8186-c7038ed5d257",
			"name": "Sti 36",
			"number": 36
		},
		"01972fff-1071-7eba-9776-82691d10b223": {
			"id": "01972fff-1071-7eba-9776-82691d10b223",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"name": "Sti 37",
			"number": 37
		},
		"01972fff-1071-7ab5-b24d-428d7d28ce64": {
			"id": "01972fff-1071-7ab5-b24d-428d7d28ce64",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"name": "Sti 38",
			"number": 38
		},
		"01972fff-1071-7417-939c-f98b0727e8e2": {
			"id": "01972fff-1071-7417-939c-f98b0727e8e2",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"name": "Sti 39",
			"number": 39
		},
		"01972fff-1071-7312-8ebe-b2c789cd0651": {
			"id": "01972fff-1071-7312-8ebe-b2c789cd0651",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"name": "Sti 40",
			"number": 40
		},
		"01972fff-1071-7a0b-bef2-e3752acd058c": {
			"id": "01972fff-1071-7a0b-bef2-e3752acd058c",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"name": "Sti 41",
			"number": 41
		},
		"01972fff-1071-735b-a125-253a52f704a3": {
			"id": "01972fff-1071-735b-a125-253a52f704a3",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"name": "Sti 42",
			"number": 42
		},
		"01972fff-1071-7b25-990f-8dead42552b1": {
			"id": "01972fff-1071-7b25-990f-8dead42552b1",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"name": "Sti 43",
			"number": 43
		},
		"01972fff-1071-7506-b926-195a1917c8ee": {
			"id": "01972fff-1071-7506-b926-195a1917c8ee",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"name": "Sti 44",
			"number": 44
		},
		"01972fff-1071-7f48-895d-81d248190670": {
			"id": "01972fff-1071-7f48-895d-81d248190670",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"name": "Sti 45",
			"number": 45
		},
		"01972fff-1071-75f4-b9c1-70879f2393e8": {
			"id": "01972fff-1071-75f4-b9c1-70879f2393e8",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"name": "Sti 46",
			"number": 46
		},
		"01972fff-1071-7038-9b04-c008ec5447da": {
			"id": "01972fff-1071-7038-9b04-c008ec5447da",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"name": "Sti 47",
			"number": 47
		},
		"01972fff-1071-763e-a057-586b9f940469": {
			"id": "01972fff-1071-763e-a057-586b9f940469",
			"sectionId": "01972fff-1070-7e37-8828-421745207623",
			"name": "Sti 48",
			"number": 48
		},
		"01972fff-1071-7cc0-8f09-74e5c8d3e0c8": {
			"id": "01972fff-1071-7cc0-8f09-74e5c8d3e0c8",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"name": "Sti 49",
			"number": 49
		},
		"01972fff-1071-72a9-9660-c9530e27c9c4": {
			"id": "01972fff-1071-72a9-9660-c9530e27c9c4",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"name": "Sti 50",
			"number": 50
		},
		"01972fff-1071-7c80-b927-c4dd6a802201": {
			"id": "01972fff-1071-7c80-b927-c4dd6a802201",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"name": "Sti 51",
			"number": 51
		},
		"01972fff-1071-7de0-a2c2-04b18d96cf1c": {
			"id": "01972fff-1071-7de0-a2c2-04b18d96cf1c",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"name": "Sti 52",
			"number": 52
		},
		"01972fff-1071-78e4-bf20-7df89055c146": {
			"id": "01972fff-1071-78e4-bf20-7df89055c146",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"name": "Sti 53",
			"number": 53
		},
		"01972fff-1071-7bb2-9afa-2aaca02d4cd1": {
			"id": "01972fff-1071-7bb2-9afa-2aaca02d4cd1",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"name": "Sti 54",
			"number": 54
		},
		"01972fff-1071-73a5-a585-dbd6c2beaca5": {
			"id": "01972fff-1071-73a5-a585-dbd6c2beaca5",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"name": "Sti 55",
			"number": 55
		},
		"01972fff-1071-7e0c-8e4a-4574c3d0def1": {
			"id": "01972fff-1071-7e0c-8e4a-4574c3d0def1",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"name": "Sti 56",
			"number": 56
		},
		"01972fff-1071-7b5c-b9c3-a8646cef2411": {
			"id": "01972fff-1071-7b5c-b9c3-a8646cef2411",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"name": "Sti 57",
			"number": 57
		},
		"01972fff-1071-7bf7-9a2d-255c32e6bab6": {
			"id": "01972fff-1071-7bf7-9a2d-255c32e6bab6",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"name": "Sti 58",
			"number": 58
		},
		"01972fff-1071-77e5-8abc-31b7064e18f9": {
			"id": "01972fff-1071-77e5-8abc-31b7064e18f9",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"name": "Sti 59",
			"number": 59
		},
		"01972fff-1071-79c5-85e8-41ce5450a00e": {
			"id": "01972fff-1071-79c5-85e8-41ce5450a00e",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"name": "Sti 60",
			"number": 60
		},
		"01972fff-1071-7254-9a40-bce0b6095f36": {
			"id": "01972fff-1071-7254-9a40-bce0b6095f36",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"name": "Sti 61",
			"number": 61
		},
		"01972fff-1071-7de7-b6c1-f86afe274a36": {
			"id": "01972fff-1071-7de7-b6c1-f86afe274a36",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"name": "Sti 62",
			"number": 62
		},
		"01972fff-1071-7e91-85c6-54515cbe68e8": {
			"id": "01972fff-1071-7e91-85c6-54515cbe68e8",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"name": "Sti 63",
			"number": 63
		},
		"01972fff-1071-7eac-bd4c-8e83837951e7": {
			"id": "01972fff-1071-7eac-bd4c-8e83837951e7",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"name": "Sti 64",
			"number": 64
		},
		"01972fff-1071-7f7f-be3e-d0da05b69a77": {
			"id": "01972fff-1071-7f7f-be3e-d0da05b69a77",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"name": "Sti 65",
			"number": 65
		},
		"01972fff-1071-76b4-be3e-26e9330abc8c": {
			"id": "01972fff-1071-76b4-be3e-26e9330abc8c",
			"sectionId": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"name": "Sti 66",
			"number": 66
		},
		"01972fff-1071-7d52-8551-bea41c2d42b7": {
			"id": "01972fff-1071-7d52-8551-bea41c2d42b7",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"name": "Sti 67",
			"number": 67
		},
		"01972fff-1071-706f-9aff-3adda18d98cc": {
			"id": "01972fff-1071-706f-9aff-3adda18d98cc",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"name": "Sti 68",
			"number": 68
		},
		"01972fff-1071-77b4-94ec-f73a7ffeb862": {
			"id": "01972fff-1071-77b4-94ec-f73a7ffeb862",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"name": "Sti 69",
			"number": 69
		},
		"01972fff-1071-7d7d-9eca-281a03d35c29": {
			"id": "01972fff-1071-7d7d-9eca-281a03d35c29",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"name": "Sti 70",
			"number": 70
		},
		"01972fff-1071-7183-94ca-d5898205c039": {
			"id": "01972fff-1071-7183-94ca-d5898205c039",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"name": "Sti 71",
			"number": 71
		},
		"01972fff-1071-705b-ad87-dfc04abf7f79": {
			"id": "01972fff-1071-705b-ad87-dfc04abf7f79",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"name": "Sti 72",
			"number": 72
		},
		"01972fff-1071-700c-a74d-921798039d33": {
			"id": "01972fff-1071-700c-a74d-921798039d33",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"name": "Sti 73",
			"number": 73
		},
		"01972fff-1071-743a-807e-8525fbe3ddf6": {
			"id": "01972fff-1071-743a-807e-8525fbe3ddf6",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"name": "Sti 74",
			"number": 74
		},
		"01972fff-1071-7c55-ac86-4f1b8ea1eddd": {
			"id": "01972fff-1071-7c55-ac86-4f1b8ea1eddd",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"name": "Sti 75",
			"number": 75
		},
		"01972fff-1071-705c-a42a-57982cfdaf67": {
			"id": "01972fff-1071-705c-a42a-57982cfdaf67",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"name": "Sti 76",
			"number": 76
		},
		"01972fff-1071-760e-a723-6e0f16df5266": {
			"id": "01972fff-1071-760e-a723-6e0f16df5266",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"name": "Sti 77",
			"number": 77
		},
		"01972fff-1071-7070-a724-9868e4e676ac": {
			"id": "01972fff-1071-7070-a724-9868e4e676ac",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"name": "Sti 78",
			"number": 78
		},
		"01972fff-1071-7397-a4ac-2d286c030acb": {
			"id": "01972fff-1071-7397-a4ac-2d286c030acb",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"name": "Sti 79",
			"number": 79
		},
		"01972fff-1071-791f-a265-9cdd4121d220": {
			"id": "01972fff-1071-791f-a265-9cdd4121d220",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"name": "Sti 80",
			"number": 80
		},
		"01972fff-1071-7ba2-84f7-ab4adbfeaf6b": {
			"id": "01972fff-1071-7ba2-84f7-ab4adbfeaf6b",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"name": "Sti 81",
			"number": 81
		},
		"01972fff-1071-7543-9639-80c738150ab9": {
			"id": "01972fff-1071-7543-9639-80c738150ab9",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"name": "Sti 82",
			"number": 82
		},
		"01972fff-1071-758f-8ad0-025a138f650a": {
			"id": "01972fff-1071-758f-8ad0-025a138f650a",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"name": "Sti 83",
			"number": 83
		},
		"01972fff-1071-753e-b982-ef834631ddce": {
			"id": "01972fff-1071-753e-b982-ef834631ddce",
			"sectionId": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"name": "Sti 84",
			"number": 84
		},
		"01972fff-1071-7588-8948-d019938cabcf": {
			"id": "01972fff-1071-7588-8948-d019938cabcf",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"name": "Sti 85",
			"number": 85
		},
		"01972fff-1071-7793-be98-5b3a0f57f68c": {
			"id": "01972fff-1071-7793-be98-5b3a0f57f68c",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"name": "Sti 86",
			"number": 86
		},
		"01972fff-1071-7fd5-87a6-05a93ab71b2f": {
			"id": "01972fff-1071-7fd5-87a6-05a93ab71b2f",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"name": "Sti 87",
			"number": 87
		},
		"01972fff-1071-7aaa-99a1-c17c58bbf637": {
			"id": "01972fff-1071-7aaa-99a1-c17c58bbf637",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"name": "Sti 88",
			"number": 88
		},
		"01972fff-1071-756e-a1fc-12f249a87226": {
			"id": "01972fff-1071-756e-a1fc-12f249a87226",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"name": "Sti 89",
			"number": 89
		},
		"01972fff-1071-74ee-8acd-2950986e209b": {
			"id": "01972fff-1071-74ee-8acd-2950986e209b",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"name": "Sti 90",
			"number": 90
		},
		"01972fff-1071-759a-b3bf-d087463fcac5": {
			"id": "01972fff-1071-759a-b3bf-d087463fcac5",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"name": "Sti 91",
			"number": 91
		},
		"01972fff-1071-72f7-9fd9-51851a3f6e0e": {
			"id": "01972fff-1071-72f7-9fd9-51851a3f6e0e",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"name": "Sti 92",
			"number": 92
		},
		"01972fff-1071-73af-b25b-4244838049fd": {
			"id": "01972fff-1071-73af-b25b-4244838049fd",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"name": "Sti 93",
			"number": 93
		},
		"01972fff-1071-7f8d-a674-968ede5f4929": {
			"id": "01972fff-1071-7f8d-a674-968ede5f4929",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"name": "Sti 94",
			"number": 94
		},
		"01972fff-1071-7ebd-ba0d-78821fa95a34": {
			"id": "01972fff-1071-7ebd-ba0d-78821fa95a34",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"name": "Sti 95",
			"number": 95
		},
		"01972fff-1071-715e-ada5-30bf34cd667d": {
			"id": "01972fff-1071-715e-ada5-30bf34cd667d",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"name": "Sti 96",
			"number": 96
		},
		"01972fff-1071-78b6-888f-d279b7ab60bd": {
			"id": "01972fff-1071-78b6-888f-d279b7ab60bd",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"name": "Sti 97",
			"number": 97
		},
		"01972fff-1071-735a-b9e6-ec3de3e1594a": {
			"id": "01972fff-1071-735a-b9e6-ec3de3e1594a",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"name": "Sti 98",
			"number": 98
		},
		"01972fff-1071-7e69-975a-290d0743efef": {
			"id": "01972fff-1071-7e69-975a-290d0743efef",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"name": "Sti 99",
			"number": 99
		},
		"01972fff-1071-786d-8513-0664c3ccad98": {
			"id": "01972fff-1071-786d-8513-0664c3ccad98",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"name": "Sti 100",
			"number": 100
		},
		"01972fff-1071-7db6-ac89-92b6bcde462b": {
			"id": "01972fff-1071-7db6-ac89-92b6bcde462b",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"name": "Sti 101",
			"number": 101
		},
		"01972fff-1071-7cd8-b9b2-b52c2dd90d20": {
			"id": "01972fff-1071-7cd8-b9b2-b52c2dd90d20",
			"sectionId": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"name": "Sti 102",
			"number": 102
		},
		"01972fff-1071-72d3-8b30-e0ab83e8d37d": {
			"id": "01972fff-1071-72d3-8b30-e0ab83e8d37d",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"name": "Sti 103",
			"number": 103
		},
		"01972fff-1071-7ac9-b2dd-13c1750b4fac": {
			"id": "01972fff-1071-7ac9-b2dd-13c1750b4fac",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"name": "Sti 104",
			"number": 104
		},
		"01972fff-1071-7220-8bd9-19935e9b4527": {
			"id": "01972fff-1071-7220-8bd9-19935e9b4527",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"name": "Sti 105",
			"number": 105
		},
		"01972fff-1071-7251-ad3c-0cf9dfddd06c": {
			"id": "01972fff-1071-7251-ad3c-0cf9dfddd06c",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"name": "Sti 106",
			"number": 106
		},
		"01972fff-1071-756f-b159-cc0612f285c8": {
			"id": "01972fff-1071-756f-b159-cc0612f285c8",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"name": "Sti 107",
			"number": 107
		},
		"01972fff-1071-72fa-bf32-652bf5bf8d5b": {
			"id": "01972fff-1071-72fa-bf32-652bf5bf8d5b",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"name": "Sti 108",
			"number": 108
		},
		"01972fff-1071-736b-850a-0f073660b996": {
			"id": "01972fff-1071-736b-850a-0f073660b996",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"name": "Sti 109",
			"number": 109
		},
		"01972fff-1071-769c-977d-a08eba7e9622": {
			"id": "01972fff-1071-769c-977d-a08eba7e9622",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"name": "Sti 110",
			"number": 110
		},
		"01972fff-1071-7834-b8ae-bbf502ec6115": {
			"id": "01972fff-1071-7834-b8ae-bbf502ec6115",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"name": "Sti 111",
			"number": 111
		},
		"01972fff-1071-725a-9159-dcc67d810756": {
			"id": "01972fff-1071-725a-9159-dcc67d810756",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"name": "Sti 112",
			"number": 112
		},
		"01972fff-1071-7ca3-9f3b-9c24d52fcf77": {
			"id": "01972fff-1071-7ca3-9f3b-9c24d52fcf77",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"name": "Sti 113",
			"number": 113
		},
		"01972fff-1071-7baa-9842-af256f4506e0": {
			"id": "01972fff-1071-7baa-9842-af256f4506e0",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"name": "Sti 114",
			"number": 114
		},
		"01972fff-1071-741f-83bf-c4acd2f30d37": {
			"id": "01972fff-1071-741f-83bf-c4acd2f30d37",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"name": "Sti 115",
			"number": 115
		},
		"01972fff-1071-704e-bfa5-366faf7530bd": {
			"id": "01972fff-1071-704e-bfa5-366faf7530bd",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"name": "Sti 116",
			"number": 116
		},
		"01972fff-1071-7293-be3c-09d702091eda": {
			"id": "01972fff-1071-7293-be3c-09d702091eda",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"name": "Sti 117",
			"number": 117
		},
		"01972fff-1071-7b4b-8037-8939efa37fc3": {
			"id": "01972fff-1071-7b4b-8037-8939efa37fc3",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"name": "Sti 118",
			"number": 118
		},
		"01972fff-1071-7542-b533-b57facd55fc7": {
			"id": "01972fff-1071-7542-b533-b57facd55fc7",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"name": "Sti 119",
			"number": 119
		},
		"01972fff-1071-7fbc-af18-3cdac7a0cc1d": {
			"id": "01972fff-1071-7fbc-af18-3cdac7a0cc1d",
			"sectionId": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"name": "Sti 120",
			"number": 120
		},
		"01972fff-1071-791f-8133-0da1c1775cc1": {
			"id": "01972fff-1071-791f-8133-0da1c1775cc1",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"name": "Sti 1",
			"number": 1
		},
		"01972fff-1071-785f-a996-3528e8721a65": {
			"id": "01972fff-1071-785f-a996-3528e8721a65",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"name": "Sti 2",
			"number": 2
		},
		"01972fff-1071-76fa-b086-05bdfdf5ceac": {
			"id": "01972fff-1071-76fa-b086-05bdfdf5ceac",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"name": "Sti 3",
			"number": 3
		},
		"01972fff-1071-759d-aee4-7ef4826f8848": {
			"id": "01972fff-1071-759d-aee4-7ef4826f8848",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"name": "Sti 4",
			"number": 4
		},
		"01972fff-1071-747b-8adb-bd455ba79531": {
			"id": "01972fff-1071-747b-8adb-bd455ba79531",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"name": "Sti 5",
			"number": 5
		},
		"01972fff-1071-7d0e-ae8e-266abac6fb6c": {
			"id": "01972fff-1071-7d0e-ae8e-266abac6fb6c",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"name": "Sti 6",
			"number": 6
		},
		"01972fff-1071-7183-9ac0-fde99a456d9e": {
			"id": "01972fff-1071-7183-9ac0-fde99a456d9e",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"name": "Sti 7",
			"number": 7
		},
		"01972fff-1071-7bf4-bbb1-08943a23cb9d": {
			"id": "01972fff-1071-7bf4-bbb1-08943a23cb9d",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"name": "Sti 8",
			"number": 8
		},
		"01972fff-1071-7791-8b3f-d4206701ca8a": {
			"id": "01972fff-1071-7791-8b3f-d4206701ca8a",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"name": "Sti 9",
			"number": 9
		},
		"01972fff-1071-7e92-8c88-0ca0d3695405": {
			"id": "01972fff-1071-7e92-8c88-0ca0d3695405",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"name": "Sti 10",
			"number": 10
		},
		"01972fff-1071-7b00-b171-5d7dca8bad24": {
			"id": "01972fff-1071-7b00-b171-5d7dca8bad24",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"name": "Sti 11",
			"number": 11
		},
		"01972fff-1071-7cb5-9b6b-584a83e4fa96": {
			"id": "01972fff-1071-7cb5-9b6b-584a83e4fa96",
			"sectionId": "01972fff-1070-70eb-b46c-b6cc61549859",
			"name": "Sti 12",
			"number": 12
		},
		"01972fff-1071-7c5a-8407-dfd45f9b13be": {
			"id": "01972fff-1071-7c5a-8407-dfd45f9b13be",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"name": "Sti 13",
			"number": 13
		},
		"01972fff-1071-70da-8dbd-231ca75278c2": {
			"id": "01972fff-1071-70da-8dbd-231ca75278c2",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"name": "Sti 14",
			"number": 14
		},
		"01972fff-1071-7440-a0ba-9c08606f2a20": {
			"id": "01972fff-1071-7440-a0ba-9c08606f2a20",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"name": "Sti 15",
			"number": 15
		},
		"01972fff-1071-7b91-9a5e-901bc6790db4": {
			"id": "01972fff-1071-7b91-9a5e-901bc6790db4",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"name": "Sti 16",
			"number": 16
		},
		"01972fff-1071-7d17-976e-1c4a59fe50cf": {
			"id": "01972fff-1071-7d17-976e-1c4a59fe50cf",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"name": "Sti 17",
			"number": 17
		},
		"01972fff-1071-7e57-ae47-50e29926c1da": {
			"id": "01972fff-1071-7e57-ae47-50e29926c1da",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"name": "Sti 18",
			"number": 18
		},
		"01972fff-1071-7af3-8559-3a60c752184c": {
			"id": "01972fff-1071-7af3-8559-3a60c752184c",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"name": "Sti 19",
			"number": 19
		},
		"01972fff-1071-7f40-82c8-df11c4507261": {
			"id": "01972fff-1071-7f40-82c8-df11c4507261",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"name": "Sti 20",
			"number": 20
		},
		"01972fff-1071-7bbe-92ae-b7a8cb3f4256": {
			"id": "01972fff-1071-7bbe-92ae-b7a8cb3f4256",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"name": "Sti 21",
			"number": 21
		},
		"01972fff-1071-70c9-a367-822ddf7ab517": {
			"id": "01972fff-1071-70c9-a367-822ddf7ab517",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"name": "Sti 22",
			"number": 22
		},
		"01972fff-1071-7f84-ae7e-b13efb25ca6c": {
			"id": "01972fff-1071-7f84-ae7e-b13efb25ca6c",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"name": "Sti 23",
			"number": 23
		},
		"01972fff-1071-79ed-b1c7-97f006625806": {
			"id": "01972fff-1071-79ed-b1c7-97f006625806",
			"sectionId": "01972fff-1070-790f-8114-e0b57871e6c6",
			"name": "Sti 24",
			"number": 24
		}
	},
	"groups": {
		"01972fff-1074-7d10-981d-df6e8166c11b": {
			"id": "01972fff-1074-7d10-981d-df6e8166c11b",
			"name": "Gruppe 9",
			"number": 9
		},
		"01972fff-1074-7dd5-bee8-919b51ae9e46": {
			"id": "01972fff-1074-7dd5-bee8-919b51ae9e46",
			"name": "Gruppe 57",
			"number": 57
		},
		"01972fff-1074-7e10-a518-1774449f4a78": {
			"id": "01972fff-1074-7e10-a518-1774449f4a78",
			"name": "Gruppe 41",
			"number": 41
		},
		"01972fff-1074-7177-bf46-a13f7214290a": {
			"id": "01972fff-1074-7177-bf46-a13f7214290a",
			"name": "Gruppe 48",
			"number": 48
		},
		"01972fff-1074-72f9-b40e-86c50d5bbbc5": {
			"id": "01972fff-1074-72f9-b40e-86c50d5bbbc5",
			"name": "Gruppe 44",
			"number": 44
		},
		"01972fff-1074-7d9c-a7e1-1032b8339868": {
			"id": "01972fff-1074-7d9c-a7e1-1032b8339868",
			"name": "Gruppe 25",
			"number": 25
		},
		"01972fff-1074-7d42-ba80-c8fff335e3aa": {
			"id": "01972fff-1074-7d42-ba80-c8fff335e3aa",
			"name": "Gruppe 1",
			"number": 1
		},
		"01972fff-1074-78c9-a90a-e669a9b391d6": {
			"id": "01972fff-1074-78c9-a90a-e669a9b391d6",
			"name": "Gruppe 46",
			"number": 46
		},
		"01972fff-1074-76e2-8f0f-b627d7876d1b": {
			"id": "01972fff-1074-76e2-8f0f-b627d7876d1b",
			"name": "Gruppe 29",
			"number": 29
		},
		"01972fff-1074-789c-a4a5-038022c0a654": {
			"id": "01972fff-1074-789c-a4a5-038022c0a654",
			"name": "Gruppe 27",
			"number": 27
		},
		"01972fff-1074-725d-86b7-e110dd1bbaf9": {
			"id": "01972fff-1074-725d-86b7-e110dd1bbaf9",
			"name": "Gruppe 42",
			"number": 42
		},
		"01972fff-1074-7453-b115-d3264654e675": {
			"id": "01972fff-1074-7453-b115-d3264654e675",
			"name": "Gruppe 31",
			"number": 31
		},
		"01972fff-1074-7df4-bcac-95bdc5a11fce": {
			"id": "01972fff-1074-7df4-bcac-95bdc5a11fce",
			"name": "Gruppe 35",
			"number": 35
		},
		"01972fff-1074-78f0-bba5-a1316d26e785": {
			"id": "01972fff-1074-78f0-bba5-a1316d26e785",
			"name": "Gruppe 58",
			"number": 58
		},
		"01972fff-1074-7dcb-9176-bfcc1b1d3003": {
			"id": "01972fff-1074-7dcb-9176-bfcc1b1d3003",
			"name": "Gruppe 8",
			"number": 8
		},
		"01972fff-1074-74e8-a28c-caa1f88d3e19": {
			"id": "01972fff-1074-74e8-a28c-caa1f88d3e19",
			"name": "Gruppe 60",
			"number": 60
		},
		"01972fff-1074-79a5-85c0-aa8eb41ab55b": {
			"id": "01972fff-1074-79a5-85c0-aa8eb41ab55b",
			"name": "Gruppe 33",
			"number": 33
		},
		"01972fff-1074-7e49-a410-a914f5601901": {
			"id": "01972fff-1074-7e49-a410-a914f5601901",
			"name": "Gruppe 39",
			"number": 39
		},
		"01972fff-1074-7016-a0d3-43cf60310750": {
			"id": "01972fff-1074-7016-a0d3-43cf60310750",
			"name": "Gruppe 24",
			"number": 24
		},
		"01972fff-1074-768a-b957-6b679dcbde1a": {
			"id": "01972fff-1074-768a-b957-6b679dcbde1a",
			"name": "Gruppe 37",
			"number": 37
		},
		"01972fff-1074-7da2-9468-06b6ae96cc3e": {
			"id": "01972fff-1074-7da2-9468-06b6ae96cc3e",
			"name": "Gruppe 32",
			"number": 32
		},
		"01972fff-1074-7a16-9a77-141d6f238d7a": {
			"id": "01972fff-1074-7a16-9a77-141d6f238d7a",
			"name": "Gruppe 64",
			"number": 64
		},
		"01972fff-1074-7ffe-bbf8-004d982c3415": {
			"id": "01972fff-1074-7ffe-bbf8-004d982c3415",
			"name": "Gruppe 62",
			"number": 62
		},
		"01972fff-1074-7b77-b8fa-d3e8316a684e": {
			"id": "01972fff-1074-7b77-b8fa-d3e8316a684e",
			"name": "Gruppe 40",
			"number": 40
		},
		"01972fff-1074-7806-af3f-3e7363e11a43": {
			"id": "01972fff-1074-7806-af3f-3e7363e11a43",
			"name": "Gruppe 0",
			"number": 0
		}
	},
	"feeds": {
		"01972fff-1073-768e-a704-96b337a28dc8": {
			"id": "01972fff-1073-768e-a704-96b337a28dc8",
			"name": "Kom9",
			"number": 9
		},
		"01972fff-1073-7db7-80ac-8842ff8a10c4": {
			"id": "01972fff-1073-7db7-80ac-8842ff8a10c4",
			"name": "Kom57",
			"number": 57
		},
		"01972fff-1073-7b01-aeb2-d6e7a9fadc56": {
			"id": "01972fff-1073-7b01-aeb2-d6e7a9fadc56",
			"name": "Kom41",
			"number": 41
		},
		"01972fff-1073-7d55-88cd-5f895dc4abf8": {
			"id": "01972fff-1073-7d55-88cd-5f895dc4abf8",
			"name": "Kom48",
			"number": 48
		},
		"01972fff-1073-7462-b75a-1795fa322e94": {
			"id": "01972fff-1073-7462-b75a-1795fa322e94",
			"name": "Kom44",
			"number": 44
		},
		"01972fff-1073-72e1-98be-7c371f964ea3": {
			"id": "01972fff-1073-72e1-98be-7c371f964ea3",
			"name": "Kom25",
			"number": 25
		},
		"01972fff-1073-7b7a-895e-e2bb43ad02b8": {
			"id": "01972fff-1073-7b7a-895e-e2bb43ad02b8",
			"name": "Kom1",
			"number": 1
		},
		"01972fff-1073-7c17-adfb-dea545036534": {
			"id": "01972fff-1073-7c17-adfb-dea545036534",
			"name": "Kom46",
			"number": 46
		},
		"01972fff-1073-71bb-9676-74b8ad38a7f5": {
			"id": "01972fff-1073-71bb-9676-74b8ad38a7f5",
			"name": "Kom29",
			"number": 29
		},
		"01972fff-1073-7143-b001-418161fc9afb": {
			"id": "01972fff-1073-7143-b001-418161fc9afb",
			"name": "Kom27",
			"number": 27
		},
		"01972fff-1073-7b7e-913d-84011af660c6": {
			"id": "01972fff-1073-7b7e-913d-84011af660c6",
			"name": "Kom42",
			"number": 42
		},
		"01972fff-1073-7ce5-832d-17f4dd82207c": {
			"id": "01972fff-1073-7ce5-832d-17f4dd82207c",
			"name": "Kom31",
			"number": 31
		},
		"01972fff-1073-73a6-8a70-97ef8536f835": {
			"id": "01972fff-1073-73a6-8a70-97ef8536f835",
			"name": "Kom35",
			"number": 35
		},
		"01972fff-1073-736c-a710-27875801f006": {
			"id": "01972fff-1073-736c-a710-27875801f006",
			"name": "Kom58",
			"number": 58
		},
		"01972fff-1073-7dca-a739-5974d1cec08a": {
			"id": "01972fff-1073-7dca-a739-5974d1cec08a",
			"name": "Kom8",
			"number": 8
		},
		"01972fff-1073-78cc-812f-e00712c04d46": {
			"id": "01972fff-1073-78cc-812f-e00712c04d46",
			"name": "Kom60",
			"number": 60
		},
		"01972fff-1073-71ba-8ab2-123d4b06af14": {
			"id": "01972fff-1073-71ba-8ab2-123d4b06af14",
			"name": "Kom33",
			"number": 33
		},
		"01972fff-1073-7db8-8c5a-55955aaa3e75": {
			"id": "01972fff-1073-7db8-8c5a-55955aaa3e75",
			"name": "Kom39",
			"number": 39
		},
		"01972fff-1073-7d3f-8934-70e67e234d0b": {
			"id": "01972fff-1073-7d3f-8934-70e67e234d0b",
			"name": "Kom24",
			"number": 24
		},
		"01972fff-1073-767c-9d38-738c611aa257": {
			"id": "01972fff-1073-767c-9d38-738c611aa257",
			"name": "Kom37",
			"number": 37
		},
		"01972fff-1073-73c8-9a9e-f4417b34b91a": {
			"id": "01972fff-1073-73c8-9a9e-f4417b34b91a",
			"name": "Kom32",
			"number": 32
		},
		"01972fff-1073-7914-83ab-8d5b1f8b8233": {
			"id": "01972fff-1073-7914-83ab-8d5b1f8b8233",
			"name": "Kom64",
			"number": 64
		},
		"01972fff-1073-75b0-9145-ecc03fea2159": {
			"id": "01972fff-1073-75b0-9145-ecc03fea2159",
			"name": "Kom62",
			"number": 62
		},
		"01972fff-1073-70e4-906b-2d9ae5015a8d": {
			"id": "01972fff-1073-70e4-906b-2d9ae5015a8d",
			"name": "Kom40",
			"number": 40
		},
		"01972fff-1073-70c8-9244-d11766428c34": {
			"id": "01972fff-1073-70c8-9244-d11766428c34",
			"name": "Kom0",
			"number": 0
		}
	},
	"sections": {
		"01972fff-106f-73c8-8186-c7038ed5d257": {
			"id": "01972fff-106f-73c8-8186-c7038ed5d257",
			"name": "K10"
		},
		"01972fff-1070-7e37-8828-421745207623": {
			"id": "01972fff-1070-7e37-8828-421745207623",
			"name": "K11"
		},
		"01972fff-1070-7e25-b74f-0c2df42bea2e": {
			"id": "01972fff-1070-7e25-b74f-0c2df42bea2e",
			"name": "K12"
		},
		"01972fff-1070-70bb-93cc-4147e9b967bb": {
			"id": "01972fff-1070-70bb-93cc-4147e9b967bb",
			"name": "K13"
		},
		"01972fff-1070-7ff1-a73f-ab23bec3d79b": {
			"id": "01972fff-1070-7ff1-a73f-ab23bec3d79b",
			"name": "K14"
		},
		"01972fff-1070-7b92-9456-c5e7ce2e1e83": {
			"id": "01972fff-1070-7b92-9456-c5e7ce2e1e83",
			"name": "K15"
		},
		"01972fff-1070-70eb-b46c-b6cc61549859": {
			"id": "01972fff-1070-70eb-b46c-b6cc61549859",
			"name": "K8"
		},
		"01972fff-1070-790f-8114-e0b57871e6c6": {
			"id": "01972fff-1070-790f-8114-e0b57871e6c6",
			"name": "K9"
		}
	},
	"trials": {
		"01972fff-106e-7d03-9ac7-fb4cec72bf3b": {
			"id": "01972fff-106e-7d03-9ac7-fb4cec72bf3b",
			"name": "Afp1951",
			"trialIdentifier": "Afp1951",
			"description": "Trial for Afp1951",
			"status": "Unknown",
			"createdBy": {
				"userId": "test-user-id",
				"name": "Test User"
			},
			"trialDates": {
				"expectedStartDate": "2025-05-29T00:00:00",
				"expectedEndDate": "2025-09-01T00:00:00",
				"startDate": "2025-05-29T00:00:00",
				"endDate": "2025-09-01T00:00:00"
			},
			"phases": [
				{
					"id": "01972fff-1074-752a-a55e-46f9adf21089",
					"number": 1,
					"type": {
						"name": "Initial"
					},
					"expectedStartDate": null,
					"expectedEndDate": null,
					"expectedStartWeightKg": null,
					"expectedEndWeightKg": null
				},
				{
					"id": "01972fff-1075-75c3-9910-f9ba614ab3d3",
					"number": 1,
					"type": {
						"name": "Interim"
					},
					"expectedStartDate": null,
					"expectedEndDate": null,
					"expectedStartWeightKg": null,
					"expectedEndWeightKg": null
				}
			],
			"sectionsIds": [
				"01972fff-106f-73c8-8186-c7038ed5d257",
				"01972fff-1070-7e37-8828-421745207623",
				"01972fff-1070-7e25-b74f-0c2df42bea2e",
				"01972fff-1070-70bb-93cc-4147e9b967bb",
				"01972fff-1070-7ff1-a73f-ab23bec3d79b",
				"01972fff-1070-7b92-9456-c5e7ce2e1e83",
				"01972fff-1070-70eb-b46c-b6cc61549859",
				"01972fff-1070-790f-8114-e0b57871e6c6"
			],
			"penIds": [
				"01972fff-1071-738c-8002-80530c1c9c58",
				"01972fff-1071-7760-95c3-b5bd6aa3f3d5",
				"01972fff-1071-7dae-b37e-ea59d076c941",
				"01972fff-1071-7975-8e6f-bae9f8a73b89",
				"01972fff-1071-7c74-9543-da36591e073c",
				"01972fff-1071-7f11-88c2-2496ae669d38",
				"01972fff-1071-764a-a8eb-861dc377f79c",
				"01972fff-1071-73de-87e3-d46cdbe0c1fc",
				"01972fff-1071-719c-936d-d0f6c8cd8310",
				"01972fff-1071-7fef-b3f5-90e7bf54b8a8",
				"01972fff-1071-70e9-a49e-1ebd31ce20ff",
				"01972fff-1071-7519-a311-5f7ab4f7711e",
				"01972fff-1071-7eba-9776-82691d10b223",
				"01972fff-1071-7ab5-b24d-428d7d28ce64",
				"01972fff-1071-7417-939c-f98b0727e8e2",
				"01972fff-1071-7312-8ebe-b2c789cd0651",
				"01972fff-1071-7a0b-bef2-e3752acd058c",
				"01972fff-1071-735b-a125-253a52f704a3",
				"01972fff-1071-7b25-990f-8dead42552b1",
				"01972fff-1071-7506-b926-195a1917c8ee",
				"01972fff-1071-7f48-895d-81d248190670",
				"01972fff-1071-75f4-b9c1-70879f2393e8",
				"01972fff-1071-7038-9b04-c008ec5447da",
				"01972fff-1071-763e-a057-586b9f940469",
				"01972fff-1071-7cc0-8f09-74e5c8d3e0c8",
				"01972fff-1071-72a9-9660-c9530e27c9c4",
				"01972fff-1071-7c80-b927-c4dd6a802201",
				"01972fff-1071-7de0-a2c2-04b18d96cf1c",
				"01972fff-1071-78e4-bf20-7df89055c146",
				"01972fff-1071-7bb2-9afa-2aaca02d4cd1",
				"01972fff-1071-73a5-a585-dbd6c2beaca5",
				"01972fff-1071-7e0c-8e4a-4574c3d0def1",
				"01972fff-1071-7b5c-b9c3-a8646cef2411",
				"01972fff-1071-7bf7-9a2d-255c32e6bab6",
				"01972fff-1071-77e5-8abc-31b7064e18f9",
				"01972fff-1071-79c5-85e8-41ce5450a00e",
				"01972fff-1071-7254-9a40-bce0b6095f36",
				"01972fff-1071-7de7-b6c1-f86afe274a36",
				"01972fff-1071-7e91-85c6-54515cbe68e8",
				"01972fff-1071-7eac-bd4c-8e83837951e7",
				"01972fff-1071-7f7f-be3e-d0da05b69a77",
				"01972fff-1071-76b4-be3e-26e9330abc8c",
				"01972fff-1071-7d52-8551-bea41c2d42b7",
				"01972fff-1071-706f-9aff-3adda18d98cc",
				"01972fff-1071-77b4-94ec-f73a7ffeb862",
				"01972fff-1071-7d7d-9eca-281a03d35c29",
				"01972fff-1071-7183-94ca-d5898205c039",
				"01972fff-1071-705b-ad87-dfc04abf7f79",
				"01972fff-1071-700c-a74d-921798039d33",
				"01972fff-1071-743a-807e-8525fbe3ddf6",
				"01972fff-1071-7c55-ac86-4f1b8ea1eddd",
				"01972fff-1071-705c-a42a-57982cfdaf67",
				"01972fff-1071-760e-a723-6e0f16df5266",
				"01972fff-1071-7070-a724-9868e4e676ac",
				"01972fff-1071-7397-a4ac-2d286c030acb",
				"01972fff-1071-791f-a265-9cdd4121d220",
				"01972fff-1071-7ba2-84f7-ab4adbfeaf6b",
				"01972fff-1071-7543-9639-80c738150ab9",
				"01972fff-1071-758f-8ad0-025a138f650a",
				"01972fff-1071-753e-b982-ef834631ddce",
				"01972fff-1071-7588-8948-d019938cabcf",
				"01972fff-1071-7793-be98-5b3a0f57f68c",
				"01972fff-1071-7fd5-87a6-05a93ab71b2f",
				"01972fff-1071-7aaa-99a1-c17c58bbf637",
				"01972fff-1071-756e-a1fc-12f249a87226",
				"01972fff-1071-74ee-8acd-2950986e209b",
				"01972fff-1071-759a-b3bf-d087463fcac5",
				"01972fff-1071-72f7-9fd9-51851a3f6e0e",
				"01972fff-1071-73af-b25b-4244838049fd",
				"01972fff-1071-7f8d-a674-968ede5f4929",
				"01972fff-1071-7ebd-ba0d-78821fa95a34",
				"01972fff-1071-715e-ada5-30bf34cd667d",
				"01972fff-1071-78b6-888f-d279b7ab60bd",
				"01972fff-1071-735a-b9e6-ec3de3e1594a",
				"01972fff-1071-7e69-975a-290d0743efef",
				"01972fff-1071-786d-8513-0664c3ccad98",
				"01972fff-1071-7db6-ac89-92b6bcde462b",
				"01972fff-1071-7cd8-b9b2-b52c2dd90d20",
				"01972fff-1071-72d3-8b30-e0ab83e8d37d",
				"01972fff-1071-7ac9-b2dd-13c1750b4fac",
				"01972fff-1071-7220-8bd9-19935e9b4527",
				"01972fff-1071-7251-ad3c-0cf9dfddd06c",
				"01972fff-1071-756f-b159-cc0612f285c8",
				"01972fff-1071-72fa-bf32-652bf5bf8d5b",
				"01972fff-1071-736b-850a-0f073660b996",
				"01972fff-1071-769c-977d-a08eba7e9622",
				"01972fff-1071-7834-b8ae-bbf502ec6115",
				"01972fff-1071-725a-9159-dcc67d810756",
				"01972fff-1071-7ca3-9f3b-9c24d52fcf77",
				"01972fff-1071-7baa-9842-af256f4506e0",
				"01972fff-1071-741f-83bf-c4acd2f30d37",
				"01972fff-1071-704e-bfa5-366faf7530bd",
				"01972fff-1071-7293-be3c-09d702091eda",
				"01972fff-1071-7b4b-8037-8939efa37fc3",
				"01972fff-1071-7542-b533-b57facd55fc7",
				"01972fff-1071-7fbc-af18-3cdac7a0cc1d",
				"01972fff-1071-791f-8133-0da1c1775cc1",
				"01972fff-1071-785f-a996-3528e8721a65",
				"01972fff-1071-76fa-b086-05bdfdf5ceac",
				"01972fff-1071-759d-aee4-7ef4826f8848",
				"01972fff-1071-747b-8adb-bd455ba79531",
				"01972fff-1071-7d0e-ae8e-266abac6fb6c",
				"01972fff-1071-7183-9ac0-fde99a456d9e",
				"01972fff-1071-7bf4-bbb1-08943a23cb9d",
				"01972fff-1071-7791-8b3f-d4206701ca8a",
				"01972fff-1071-7e92-8c88-0ca0d3695405",
				"01972fff-1071-7b00-b171-5d7dca8bad24",
				"01972fff-1071-7cb5-9b6b-584a83e4fa96",
				"01972fff-1071-7c5a-8407-dfd45f9b13be",
				"01972fff-1071-70da-8dbd-231ca75278c2",
				"01972fff-1071-7440-a0ba-9c08606f2a20",
				"01972fff-1071-7b91-9a5e-901bc6790db4",
				"01972fff-1071-7d17-976e-1c4a59fe50cf",
				"01972fff-1071-7e57-ae47-50e29926c1da",
				"01972fff-1071-7af3-8559-3a60c752184c",
				"01972fff-1071-7f40-82c8-df11c4507261",
				"01972fff-1071-7bbe-92ae-b7a8cb3f4256",
				"01972fff-1071-70c9-a367-822ddf7ab517",
				"01972fff-1071-7f84-ae7e-b13efb25ca6c",
				"01972fff-1071-79ed-b1c7-97f006625806"
			],
			"batchIds": [
				"01972fff-1072-72db-95f0-dcb32b7e38f2",
				"01972fff-1072-75dc-8ee9-586cb812668c",
				"01972fff-1072-7375-b509-591bb8159461",
				"01972fff-1072-7507-b4c8-74fb15ed6544",
				"01972fff-1072-723f-bf92-0fbb390a23b5",
				"01972fff-1072-77e5-ba27-3485f4562677",
				"01972fff-1072-76bf-bd55-184bec22ba6d",
				"01972fff-1072-76c0-8c8c-063cedd7777e",
				"01972fff-1072-7207-851d-4e554e54be64",
				"01972fff-1072-760f-a512-523c99b96e40",
				"01972fff-1072-73b4-b5d3-c6ba8f076a2a",
				"01972fff-1072-7361-979a-2e3b556a08ef",
				"01972fff-1072-7733-b572-54a0e07c9d58",
				"01972fff-1072-7924-a458-e725174b75f4",
				"01972fff-1072-7e07-aa8f-50685fd96480",
				"01972fff-1072-7ae0-a462-09127c3be72a",
				"01972fff-1072-7dd8-bed6-7b5f680740c0",
				"01972fff-1072-74dc-8bd5-688cfc58936a",
				"01972fff-1072-76c5-827f-6772315e88e5",
				"01972fff-1072-7b3d-90e5-60763289a55f",
				"01972fff-1072-7f41-9ca0-bca12b75021f",
				"01972fff-1072-73f1-a610-a81b67cc8cef",
				"01972fff-1072-7819-bbc5-19a6852bdb3a",
				"01972fff-1072-77ed-9e78-df3b31e6b183",
				"01972fff-1072-76f9-ad71-4bd032582c4b",
				"01972fff-1072-7b36-a968-5fc75b06ae29",
				"01972fff-1072-79ac-85ba-c5062f178a1d",
				"01972fff-1072-7929-aae1-3b314c5f4b94",
				"01972fff-1072-7828-a5de-d61c01b89a9c",
				"01972fff-1072-7471-b6dc-059c3485d5fa",
				"01972fff-1072-761c-9bcd-767deb67e3aa",
				"01972fff-1072-7138-a5c1-ba1a5227320e"
			]
		}
	},
	"batches": {
		"01972fff-1072-72db-95f0-dcb32b7e38f2": {
			"id": "01972fff-1072-72db-95f0-dcb32b7e38f2",
			"name": "Hold 1",
			"number": 1
		},
		"01972fff-1072-75dc-8ee9-586cb812668c": {
			"id": "01972fff-1072-75dc-8ee9-586cb812668c",
			"name": "Hold 2",
			"number": 2
		},
		"01972fff-1072-7375-b509-591bb8159461": {
			"id": "01972fff-1072-7375-b509-591bb8159461",
			"name": "Hold 3",
			"number": 3
		},
		"01972fff-1072-7507-b4c8-74fb15ed6544": {
			"id": "01972fff-1072-7507-b4c8-74fb15ed6544",
			"name": "Hold 4",
			"number": 4
		},
		"01972fff-1072-723f-bf92-0fbb390a23b5": {
			"id": "01972fff-1072-723f-bf92-0fbb390a23b5",
			"name": "Hold 5",
			"number": 5
		},
		"01972fff-1072-77e5-ba27-3485f4562677": {
			"id": "01972fff-1072-77e5-ba27-3485f4562677",
			"name": "Hold 6",
			"number": 6
		},
		"01972fff-1072-76bf-bd55-184bec22ba6d": {
			"id": "01972fff-1072-76bf-bd55-184bec22ba6d",
			"name": "Hold 7",
			"number": 7
		},
		"01972fff-1072-76c0-8c8c-063cedd7777e": {
			"id": "01972fff-1072-76c0-8c8c-063cedd7777e",
			"name": "Hold 8",
			"number": 8
		},
		"01972fff-1072-7207-851d-4e554e54be64": {
			"id": "01972fff-1072-7207-851d-4e554e54be64",
			"name": "Hold 9",
			"number": 9
		},
		"01972fff-1072-760f-a512-523c99b96e40": {
			"id": "01972fff-1072-760f-a512-523c99b96e40",
			"name": "Hold 10",
			"number": 10
		},
		"01972fff-1072-73b4-b5d3-c6ba8f076a2a": {
			"id": "01972fff-1072-73b4-b5d3-c6ba8f076a2a",
			"name": "Hold 11",
			"number": 11
		},
		"01972fff-1072-7361-979a-2e3b556a08ef": {
			"id": "01972fff-1072-7361-979a-2e3b556a08ef",
			"name": "Hold 12",
			"number": 12
		},
		"01972fff-1072-7733-b572-54a0e07c9d58": {
			"id": "01972fff-1072-7733-b572-54a0e07c9d58",
			"name": "Hold 13",
			"number": 13
		},
		"01972fff-1072-7924-a458-e725174b75f4": {
			"id": "01972fff-1072-7924-a458-e725174b75f4",
			"name": "Hold 14",
			"number": 14
		},
		"01972fff-1072-7e07-aa8f-50685fd96480": {
			"id": "01972fff-1072-7e07-aa8f-50685fd96480",
			"name": "Hold 15",
			"number": 15
		},
		"01972fff-1072-7ae0-a462-09127c3be72a": {
			"id": "01972fff-1072-7ae0-a462-09127c3be72a",
			"name": "Hold 16",
			"number": 16
		},
		"01972fff-1072-7dd8-bed6-7b5f680740c0": {
			"id": "01972fff-1072-7dd8-bed6-7b5f680740c0",
			"name": "Hold 17",
			"number": 17
		},
		"01972fff-1072-74dc-8bd5-688cfc58936a": {
			"id": "01972fff-1072-74dc-8bd5-688cfc58936a",
			"name": "Hold 18",
			"number": 18
		},
		"01972fff-1072-76c5-827f-6772315e88e5": {
			"id": "01972fff-1072-76c5-827f-6772315e88e5",
			"name": "Hold 19",
			"number": 19
		},
		"01972fff-1072-7b3d-90e5-60763289a55f": {
			"id": "01972fff-1072-7b3d-90e5-60763289a55f",
			"name": "Hold 20",
			"number": 20
		},
		"01972fff-1072-7f41-9ca0-bca12b75021f": {
			"id": "01972fff-1072-7f41-9ca0-bca12b75021f",
			"name": "Hold 21",
			"number": 21
		},
		"01972fff-1072-73f1-a610-a81b67cc8cef": {
			"id": "01972fff-1072-73f1-a610-a81b67cc8cef",
			"name": "Hold 22",
			"number": 22
		},
		"01972fff-1072-7819-bbc5-19a6852bdb3a": {
			"id": "01972fff-1072-7819-bbc5-19a6852bdb3a",
			"name": "Hold 23",
			"number": 23
		},
		"01972fff-1072-77ed-9e78-df3b31e6b183": {
			"id": "01972fff-1072-77ed-9e78-df3b31e6b183",
			"name": "Hold 24",
			"number": 24
		},
		"01972fff-1072-76f9-ad71-4bd032582c4b": {
			"id": "01972fff-1072-76f9-ad71-4bd032582c4b",
			"name": "Hold 25",
			"number": 25
		},
		"01972fff-1072-7b36-a968-5fc75b06ae29": {
			"id": "01972fff-1072-7b36-a968-5fc75b06ae29",
			"name": "Hold 26",
			"number": 26
		},
		"01972fff-1072-79ac-85ba-c5062f178a1d": {
			"id": "01972fff-1072-79ac-85ba-c5062f178a1d",
			"name": "Hold 27",
			"number": 27
		},
		"01972fff-1072-7929-aae1-3b314c5f4b94": {
			"id": "01972fff-1072-7929-aae1-3b314c5f4b94",
			"name": "Hold 28",
			"number": 28
		},
		"01972fff-1072-7828-a5de-d61c01b89a9c": {
			"id": "01972fff-1072-7828-a5de-d61c01b89a9c",
			"name": "Hold 29",
			"number": 29
		},
		"01972fff-1072-7471-b6dc-059c3485d5fa": {
			"id": "01972fff-1072-7471-b6dc-059c3485d5fa",
			"name": "Hold 30",
			"number": 30
		},
		"01972fff-1072-761c-9bcd-767deb67e3aa": {
			"id": "01972fff-1072-761c-9bcd-767deb67e3aa",
			"name": "Hold 31",
			"number": 31
		},
		"01972fff-1072-7138-a5c1-ba1a5227320e": {
			"id": "01972fff-1072-7138-a5c1-ba1a5227320e",
			"name": "Hold 32",
			"number": 32
		}
	}
}
